var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _g, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _g2, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _g3, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForecastsImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 184,
    viewBox: "0 0 243 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.3234 57.0812C93.3234 57.0394 93.3196 56.9976 93.3158 56.9596L93.3082 56.8189C93.3006 56.7239 93.2968 56.6289 93.2854 56.5186C93.2626 56.2753 93.2323 56.0358 93.1943 55.8001L93.1639 55.6138C93.1298 55.4199 93.0918 55.2299 93.0462 55.017C93.0424 54.9904 93.0348 54.9637 93.0272 54.9333L93.0158 54.8915C92.9551 54.6444 92.8868 54.3859 92.8032 54.1312L92.7539 53.9715C92.6589 53.6864 92.5716 53.4431 92.4691 53.196C92.378 52.9755 92.2717 52.7436 92.1502 52.4889L92.0818 52.3482C91.9641 52.1163 91.8388 51.8882 91.7135 51.6754L91.6376 51.5537C91.5123 51.3484 91.3794 51.1431 91.2237 50.9264L91.1933 50.8808C91.0529 50.6869 90.901 50.4855 90.7263 50.2726L90.62 50.1471C90.4454 49.938 90.2783 49.7517 90.1074 49.5807L90.0391 49.5122C89.872 49.345 89.7012 49.1815 89.5151 49.0142C89.4961 48.9952 89.481 48.98 89.462 48.961L89.424 48.9306C89.2456 48.7747 89.0633 48.6265 88.8773 48.4858L88.752 48.3946C88.5887 48.2729 88.4216 48.1551 88.2356 48.0334C88.2128 48.0182 88.1938 48.003 88.171 47.9878L88.1255 47.9612C87.9698 47.8585 87.8065 47.7635 87.6509 47.6723L87.6205 47.6533C87.4496 47.5544 87.2712 47.4632 87.0927 47.3757L87.0548 47.3567C87.0206 47.3377 86.9826 47.3225 86.9446 47.3073L86.8915 47.2845C86.789 47.2389 86.6903 47.1894 86.5877 47.1438C86.5346 47.121 86.4814 47.102 86.4321 47.0792L86.3713 47.0526C86.2726 47.0108 86.1701 46.9728 86.0486 46.9271L85.8246 46.8511C85.7372 46.8207 85.6461 46.7903 85.555 46.7637C85.4715 46.7371 85.3879 46.7142 85.3006 46.6876C85.2095 46.661 85.1184 46.6344 84.9931 46.604L84.9247 46.585C84.8905 46.5774 84.8526 46.5698 84.8184 46.5622L84.7652 46.5508C84.6741 46.528 84.583 46.509 84.4919 46.49C84.4045 46.4709 84.3134 46.4557 84.2261 46.4405C84.135 46.4253 84.04 46.4101 83.9147 46.3911L83.835 46.3797C83.8008 46.3759 83.7667 46.3721 83.7325 46.3683L83.6793 46.3607C83.5806 46.3493 83.4781 46.3379 83.3756 46.3265C83.2883 46.3189 83.2009 46.3113 83.1098 46.3075C83.0073 46.2999 82.9048 46.2961 82.8023 46.2923L82.6656 46.2847C82.5744 46.2847 82.4795 46.2847 82.3846 46.2847H79.423V46.8435V47.4023C79.5445 47.4023 79.666 47.4061 79.7951 47.4137C79.8863 47.4137 79.9774 47.4213 80.0685 47.429C80.1482 47.4328 80.228 47.4404 80.3077 47.448C80.3988 47.4556 80.49 47.467 80.5811 47.4784C80.6608 47.4898 80.7406 47.4974 80.8165 47.5088C80.9 47.5202 80.9835 47.5354 81.0671 47.5506C81.1468 47.5658 81.2266 47.5772 81.3063 47.5962C81.3898 47.6114 81.4695 47.6304 81.5531 47.6494C81.629 47.6685 81.7088 47.6837 81.7847 47.7065C81.8682 47.7293 81.948 47.7521 82.0315 47.7749C82.1074 47.7977 82.1834 47.8167 82.2593 47.8433C82.339 47.8699 82.4188 47.8966 82.4985 47.9232C82.5706 47.9498 82.6428 47.9726 82.7149 47.9992C82.8061 48.0334 82.8972 48.0676 82.9845 48.1056L83.0377 48.1285C83.087 48.1475 83.1326 48.1665 83.1819 48.1893C83.2731 48.2311 83.3642 48.2729 83.4553 48.3147L83.6338 48.3984C83.7932 48.4782 83.9527 48.5618 84.1008 48.6455L84.1312 48.6645C84.2754 48.7481 84.4197 48.8355 84.5602 48.9268L84.6703 48.999C84.8222 49.1017 84.9741 49.2043 85.1183 49.3146L85.2285 49.3982C85.3955 49.5274 85.5588 49.6605 85.7183 49.8012L85.8094 49.8848C85.9688 50.0255 86.1207 50.1737 86.2726 50.3258L86.3333 50.3866C86.4928 50.5501 86.6447 50.7212 86.7928 50.896L86.8877 51.0101C87.0358 51.1887 87.1763 51.3712 87.3243 51.5803L87.3509 51.6221C87.4762 51.8008 87.5939 51.9833 87.7078 52.1696L87.7762 52.2798C87.8939 52.4775 88.004 52.6828 88.1103 52.8881L88.1748 53.0173C88.2887 53.2492 88.3837 53.4583 88.4748 53.6788C88.5545 53.8765 88.6343 54.097 88.7216 54.3555L88.7671 54.5C88.8431 54.7395 88.9038 54.9637 88.957 55.188L88.9874 55.3249C89.0253 55.496 89.0595 55.667 89.0899 55.8419L89.1203 56.013C89.1544 56.2259 89.1848 56.4464 89.2038 56.6631C89.2152 56.7695 89.219 56.876 89.2266 57.0014L89.238 57.1725C89.2456 57.3436 89.2493 57.5184 89.2493 57.6933C89.2493 57.7959 89.2493 57.8948 89.2418 57.9974V58.0545C89.238 58.1495 89.2342 58.2483 89.2266 58.3472C89.2228 58.4308 89.2152 58.5145 89.2076 58.5943C89.2 58.6893 89.1924 58.7844 89.181 58.8794C89.1734 58.963 89.162 59.0467 89.1506 59.1303C89.1392 59.2178 89.1278 59.3052 89.1127 59.3926C89.0975 59.4763 89.0861 59.5599 89.0709 59.6435C89.0557 59.7272 89.0367 59.8146 89.0215 59.902C89.0064 59.9819 88.9874 60.0655 88.9684 60.1454C88.9494 60.229 88.9266 60.3164 88.9038 60.4001C88.881 60.4799 88.8621 60.5597 88.8393 60.6396C88.8165 60.7232 88.7899 60.8068 88.7633 60.8905C88.7406 60.9665 88.714 61.0425 88.6874 61.1186C88.657 61.2098 88.6229 61.3048 88.5849 61.4075C88.5583 61.4759 88.5355 61.5405 88.509 61.609C88.471 61.7002 88.433 61.7914 88.3951 61.8827L88.3761 61.9283C88.3533 61.9815 88.3305 62.0309 88.3077 62.0842C88.2508 62.2096 88.19 62.3389 88.1255 62.4605L88.0685 62.5784C87.985 62.738 87.8977 62.8977 87.7876 63.084L87.761 63.1296C87.6623 63.2931 87.5597 63.4566 87.4382 63.6352L87.3623 63.7493C87.2408 63.9242 87.1155 64.0952 86.9826 64.2625L86.8877 64.3765C86.8118 64.4716 86.732 64.5666 86.6523 64.6579L86.5194 64.8023C86.4473 64.8822 86.3751 64.9582 86.2992 65.0342C86.2536 65.0798 86.208 65.1255 86.1511 65.1825C86.079 65.2547 86.0068 65.3231 85.9309 65.3916C85.8777 65.441 85.8246 65.4866 85.7714 65.536C85.6955 65.6045 85.6195 65.6691 85.5436 65.7337C85.4904 65.7793 85.4335 65.825 85.3803 65.8668C85.3006 65.9314 85.2209 65.9922 85.1373 66.0531L84.9703 66.1785C84.8829 66.2393 84.7956 66.3002 84.7083 66.3572L84.5488 66.4636C84.4463 66.5283 84.34 66.5929 84.2337 66.6537L84.1122 66.7259C83.9641 66.8096 83.816 66.8894 83.6603 66.9654L83.5692 67.0073C83.4477 67.0681 83.3224 67.1251 83.1971 67.1783L83.0263 67.2468C82.9238 67.2886 82.825 67.3304 82.7187 67.3684C82.6694 67.3874 82.62 67.4026 82.5706 67.4216L82.5213 67.4368C82.4226 67.4711 82.3276 67.5053 82.2251 67.5357C82.1568 67.5547 82.0922 67.5775 82.0201 67.5965C81.9214 67.6231 81.8227 67.6497 81.7239 67.6763C81.6556 67.6954 81.5835 67.7106 81.5113 67.7258C81.4126 67.7486 81.3101 67.7676 81.2114 67.7904C81.1392 67.8056 81.0709 67.817 80.9987 67.8284C80.8924 67.8474 80.7861 67.8626 80.6798 67.874L80.6191 67.8816C80.5735 67.8892 80.5241 67.893 80.4748 67.9006C80.3571 67.912 80.2394 67.9234 80.1179 67.9311L79.9432 67.9463C79.7648 67.9577 79.5863 67.9615 79.4041 67.9615V68.5203V69.0791H82.3656C82.5668 69.0791 82.7681 69.0715 82.9655 69.0601L83.1592 69.0449C83.2921 69.0335 83.4249 69.0259 83.5578 69.0107C83.6148 69.0031 83.6717 68.9955 83.7287 68.9879L83.7856 68.9803C83.9033 68.9651 84.0249 68.9461 84.1388 68.9271C84.2147 68.9157 84.2906 68.9005 84.378 68.8815C84.4919 68.8586 84.602 68.8358 84.7159 68.8092C84.7956 68.7902 84.8753 68.7712 84.9551 68.7522C85.0652 68.7256 85.1753 68.6952 85.293 68.661C85.3689 68.6382 85.4449 68.6191 85.517 68.5963C85.6271 68.5621 85.7372 68.5241 85.8474 68.4861L85.8929 68.4709C85.9499 68.4519 86.0106 68.4291 86.0676 68.4101C86.1815 68.3682 86.2954 68.3226 86.4093 68.2732L86.47 68.2504C86.5156 68.2314 86.5574 68.2162 86.6029 68.1972C86.7434 68.1363 86.8801 68.0717 87.0472 67.9919L87.1193 67.9577C87.2902 67.874 87.4572 67.7828 87.6243 67.6877L87.761 67.6079C87.8787 67.5395 87.9964 67.4673 88.1103 67.395C88.1521 67.3684 88.1938 67.3418 88.2318 67.3152L88.2887 67.2772C88.3875 67.2125 88.4862 67.1441 88.5811 67.0757C88.6343 67.0377 88.6874 66.9997 88.7671 66.9388C88.8583 66.8704 88.9494 66.802 89.0367 66.7335C89.0975 66.6841 89.1582 66.6347 89.2228 66.5815C89.3101 66.5092 89.3936 66.437 89.4772 66.3648C89.5379 66.3116 89.5949 66.2583 89.6556 66.2051C89.7391 66.1291 89.8189 66.0493 89.9252 65.9466C89.9746 65.901 90.0201 65.8516 90.0657 65.806C90.1492 65.7223 90.2289 65.6349 90.3087 65.5474L90.453 65.3878C90.5441 65.2851 90.6276 65.1825 90.7149 65.0798L90.8213 64.9544C90.9693 64.7681 91.1098 64.578 91.2427 64.3841L91.3414 64.2359C91.4591 64.061 91.5768 63.8785 91.6869 63.6923L91.7325 63.6162C91.835 63.4451 91.9299 63.2665 92.0249 63.0878L92.0894 62.9585C92.1578 62.8217 92.2261 62.681 92.2944 62.529L92.3172 62.4757C92.3324 62.4415 92.3476 62.4073 92.359 62.3731L92.3818 62.3199C92.4235 62.221 92.4691 62.1184 92.5071 62.0157C92.5374 61.9359 92.5678 61.8599 92.5982 61.78C92.6362 61.6774 92.6741 61.5786 92.7197 61.4417L92.788 61.2212C92.8184 61.13 92.845 61.0387 92.8716 60.9437C92.8981 60.8562 92.9209 60.765 92.9437 60.6776C92.9665 60.5825 92.9931 60.4913 93.0158 60.3925L93.0766 60.1225C93.0956 60.0275 93.1146 59.9325 93.1335 59.8412C93.1487 59.75 93.1677 59.6587 93.1791 59.5637C93.1943 59.4687 93.2095 59.3698 93.2209 59.2748L93.2551 58.9973C93.2664 58.8946 93.2778 58.7882 93.2854 58.6817C93.293 58.5905 93.3006 58.4992 93.3044 58.408C93.312 58.3016 93.3158 58.1951 93.3196 58.0887V58.0316C93.3234 57.9936 93.3272 57.9556 93.3272 57.9214C93.3272 57.8454 93.3272 57.7655 93.3272 57.6895C93.3272 57.4956 93.3234 57.3055 93.312 57.1155L93.3234 57.0812Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6662 68.4785C85.4957 68.4785 90.2215 63.631 90.2215 57.6515C90.2215 51.6719 85.4957 46.8245 79.6662 46.8245C73.8366 46.8245 69.1108 51.6719 69.1108 57.6515C69.1108 63.631 73.8366 68.4785 79.6662 68.4785Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3016 49.3907C85.3082 47.4556 82.62 46.2695 79.6699 46.2695C73.5417 46.2695 68.5564 51.3751 68.5564 57.6516C68.5564 63.928 73.5455 69.0374 79.6699 69.0374C84.8906 69.0374 89.2835 65.327 90.4644 60.3431C90.6732 59.4801 90.7795 58.5792 90.7795 57.6516C90.7795 54.4012 89.443 51.4625 87.3016 49.3907ZM79.6699 68.3303C73.9328 68.3303 69.2702 63.5403 69.2702 57.6516C69.2702 51.7629 73.9366 46.9766 79.6699 46.9766C82.1872 46.9766 84.4919 47.9004 86.2954 49.4325C88.6001 51.3903 90.0657 54.348 90.0657 57.6516C90.0657 58.5411 89.9632 59.4041 89.7581 60.2291C88.6381 64.8746 84.5374 68.3303 79.6699 68.3303Z",
    fill: "#E1E1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M93.3349 57.6553V57.8872C93.3349 57.9252 93.3349 57.9632 93.3273 57.9974V58.0545C93.3273 58.1571 93.3197 58.2674 93.3121 58.3738C93.3045 58.4612 93.3007 58.5563 93.2931 58.6437C93.2817 58.7502 93.2703 58.8566 93.2589 58.9593L93.2248 59.2368C93.2134 59.328 93.1982 59.4269 93.183 59.5219C93.1678 59.6131 93.1526 59.7082 93.1336 59.7994C93.1184 59.8906 93.0957 59.9857 93.0767 60.0769L93.0159 60.3468C92.9931 60.4419 92.9704 60.5369 92.9438 60.6282C92.9286 60.689 92.9134 60.7422 92.8982 60.803L90.453 60.3316L89.3557 60.1187C89.5532 59.328 89.6519 58.4955 89.6519 57.6401C89.6519 54.4619 88.2395 51.6183 86.0259 49.7365L87.2902 49.3792L89.2874 48.8127C89.3292 48.847 89.3709 48.885 89.4089 48.9154L89.4469 48.9458C89.4469 48.9458 89.4848 48.98 89.5038 48.999C89.6899 49.1625 89.8607 49.326 90.024 49.4932L90.0961 49.5655C90.2632 49.7365 90.4303 49.9228 90.6049 50.1319L90.7112 50.2574C90.8859 50.4741 91.0378 50.6717 91.1782 50.8694L91.2086 50.915C91.3643 51.1355 91.4934 51.3408 91.6225 51.5423L91.6984 51.664C91.8237 51.8768 91.9528 52.1049 92.0705 52.3368L92.1426 52.4775C92.2641 52.7322 92.3705 52.9603 92.4616 53.1846C92.5603 53.4279 92.6514 53.6712 92.7425 53.9601L92.7957 54.116C92.8754 54.3783 92.9438 54.6292 93.0045 54.8801L93.0159 54.9219C93.0235 54.9524 93.0311 54.979 93.0349 55.0056C93.0843 55.2223 93.1222 55.4123 93.1526 55.6062L93.1868 55.7925C93.2247 56.032 93.2551 56.2677 93.2779 56.511C93.2893 56.6213 93.2931 56.7163 93.3007 56.8113L93.3083 56.9482C93.3083 56.99 93.3159 57.0318 93.3197 57.0698C93.3273 57.2599 93.3311 57.4538 93.3311 57.6477L93.3349 57.6553Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0097 56.3362C83.8578 57.3665 83.2845 57.8683 82.5251 58.0432C83.5655 58.5868 84.0932 59.4232 83.5921 60.8678C83.1364 62.1679 82.229 62.6051 81.0102 62.6051C80.547 62.6051 80.0382 62.5405 79.4952 62.4378L79.0168 64.3691L77.855 64.0801L78.3296 62.1755C78.0258 62.0995 77.7183 62.0197 77.4069 61.9322L76.9285 63.8482L75.7705 63.5593L76.2489 61.6281C75.9793 61.5559 75.7059 61.4836 75.425 61.4114L73.9138 61.035L74.4909 59.7045L75.3339 59.9136C75.3832 59.925 75.4288 59.9326 75.4705 59.9326C75.7059 59.9326 75.8161 59.7615 75.8654 59.6398L76.6248 56.591L77.1677 54.405C77.1829 54.1579 77.0956 53.8462 76.6248 53.7283L75.7819 53.5193L76.0894 52.2761L77.6917 52.6791C77.9309 52.7437 78.1777 52.8007 78.4321 52.8578L78.9067 50.9456L80.0686 51.2345L79.6015 53.1087C79.9129 53.1809 80.228 53.2531 80.5318 53.3292L80.995 51.4664L82.1568 51.7553L81.6822 53.6675C83.1516 54.1731 84.2223 54.9335 84.0097 56.3439V56.3362ZM81.3557 60.0656C81.7278 58.5564 79.2067 58.1686 78.4207 57.9709L77.7828 60.5332C78.2119 60.6397 79.1269 60.921 79.9281 60.921C80.6001 60.921 81.1924 60.7233 81.3557 60.0656ZM81.7164 56.3172C82.0581 54.9449 79.9471 54.6407 79.2902 54.4773L78.7131 56.8C79.0586 56.8875 79.7914 57.1156 80.4482 57.1156C81.033 57.1156 81.5645 56.9369 81.7164 56.3172Z",
    fill: "#E1E1E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2123 59.7007H74.4871L75.33 59.9098C75.33 59.9098 75.3603 59.9174 75.3793 59.9212C75.4059 59.925 75.4287 59.9288 75.4553 59.9288C75.4591 59.9288 75.4667 59.9288 75.4705 59.9288H76.1957C76.1539 59.9288 76.1083 59.925 76.059 59.9098L75.2161 59.7007H75.2123Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9285 63.8484H77.6537L78.1321 61.9324H77.4069L76.9285 63.8484Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4321 52.8502H79.1573C78.9067 52.7932 78.6561 52.7362 78.4207 52.6715L76.8185 52.2686H76.0933L77.6955 52.6715C77.9347 52.7362 78.1815 52.7932 78.4359 52.8502H78.4321Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0168 64.3692H79.7421L80.2205 62.438H79.4952L79.0168 64.3692Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.247 60.8944C80.2014 60.8906 80.1597 60.8868 80.1141 60.8792C80.042 60.8716 79.9736 60.8602 79.9015 60.8488C79.8559 60.8412 79.8104 60.8336 79.7648 60.826C79.742 60.8222 79.7192 60.8184 79.7002 60.8146C79.6167 60.7993 79.537 60.7841 79.4572 60.7651C79.4535 60.7651 79.4459 60.7651 79.4383 60.7651C79.3509 60.7461 79.2674 60.7271 79.1877 60.7081C79.1687 60.7043 79.1497 60.6967 79.1307 60.6929C79.0586 60.6739 78.9864 60.6587 78.9181 60.6397H78.9105C78.827 60.6169 78.751 60.5979 78.6827 60.5789C78.6181 60.5636 78.5612 60.5484 78.5118 60.5332L79.1497 57.9709H78.4245L77.7866 60.5332C77.836 60.5446 77.8967 60.5598 77.9575 60.5789C78.0258 60.5979 78.1018 60.6169 78.1853 60.6397H78.1929C78.2612 60.6587 78.3296 60.6739 78.4055 60.6929C78.4245 60.6967 78.4435 60.7043 78.4663 60.7081C78.546 60.7271 78.6295 60.7461 78.7169 60.7651C78.7207 60.7651 78.7282 60.7651 78.7358 60.7651C78.8156 60.7803 78.8953 60.7993 78.9788 60.8146C79.0016 60.8184 79.0206 60.8222 79.0434 60.826C79.0624 60.826 79.0814 60.8336 79.1041 60.8374C79.1307 60.8412 79.1573 60.845 79.1839 60.8488C79.256 60.8602 79.3244 60.8716 79.3965 60.8792C79.4421 60.883 79.4838 60.8906 79.5294 60.8944C79.5977 60.902 79.6661 60.9058 79.7344 60.9096C79.761 60.9096 79.7914 60.9134 79.818 60.9172C79.8559 60.9172 79.8977 60.9172 79.9357 60.9172H80.6609C80.5963 60.9172 80.528 60.9134 80.4596 60.9096C80.3913 60.9096 80.3229 60.902 80.2546 60.8944H80.247Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6016 53.1011C79.9129 53.1733 80.2281 53.2456 80.5318 53.3216H81.257C80.9532 53.2456 80.6381 53.1733 80.3268 53.1011L80.7938 51.2269L79.6319 50.938H78.9067L80.0686 51.2269L79.6016 53.1011Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6507 56.8571C79.571 56.8343 79.495 56.8153 79.4381 56.8001L80.0152 54.4773H79.29L78.7129 56.8001C78.7736 56.8153 78.8496 56.8343 78.9331 56.8571C78.9901 56.8723 79.047 56.8875 79.1116 56.9027C79.1381 56.9103 79.1647 56.9179 79.1951 56.9255C79.2786 56.9445 79.3622 56.9673 79.4533 56.9864C79.4571 56.9864 79.4609 56.9864 79.4685 56.9864C79.5596 57.0054 79.6545 57.0244 79.7494 57.0434C79.7608 57.0434 79.7722 57.0472 79.7836 57.051C79.8064 57.051 79.8254 57.0548 79.8482 57.0586C79.9051 57.0662 79.9583 57.0738 80.0152 57.0814C80.0532 57.0852 80.0874 57.089 80.1253 57.0928C80.1823 57.0966 80.2354 57.1004 80.2886 57.1042C80.3114 57.1042 80.3342 57.108 80.3569 57.108C80.3911 57.108 80.4215 57.108 80.4557 57.108H81.1809C81.1277 57.108 81.0707 57.108 81.0138 57.1004C80.9606 57.1004 80.9037 57.0928 80.8505 57.089C80.8126 57.089 80.7784 57.0814 80.7404 57.0776C80.6835 57.07 80.6303 57.0624 80.5734 57.0548C80.5392 57.051 80.5088 57.0434 80.4746 57.0396C80.3797 57.0244 80.2848 57.0054 80.1937 56.9826C80.1899 56.9826 80.1861 56.9826 80.1785 56.9826C80.0874 56.9635 80.0038 56.9407 79.9203 56.9217C79.8937 56.9141 79.8671 56.9065 79.8368 56.8989C79.776 56.8837 79.7153 56.8685 79.6583 56.8533L79.6507 56.8571Z",
    fill: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7538 55.9484C84.7538 55.9294 84.7538 55.9066 84.7538 55.8876C84.7538 55.88 84.7538 55.8762 84.7538 55.8686C84.7462 55.7774 84.7386 55.6899 84.7196 55.6025C84.7196 55.6025 84.7196 55.5987 84.7196 55.5949C84.7044 55.5303 84.6893 55.4656 84.6665 55.4048C84.6627 55.3896 84.6551 55.3744 84.6475 55.3554C84.6323 55.3174 84.6171 55.2756 84.6019 55.2375C84.6019 55.2299 84.5943 55.2261 84.5905 55.2185C84.5678 55.1691 84.5412 55.1235 84.5146 55.0779C84.5032 55.0589 84.4918 55.0361 84.4804 55.0171C84.4387 54.9524 84.3931 54.8878 84.3437 54.827C84.3399 54.8194 84.3323 54.8156 84.3248 54.808C84.2792 54.7547 84.2336 54.7015 84.1805 54.6521C84.1615 54.6331 84.1387 54.6141 84.1197 54.5951C84.0818 54.5571 84.04 54.5228 83.9982 54.4886C83.9906 54.4848 83.9868 54.4772 83.9792 54.4696C83.9678 54.462 83.9565 54.4544 83.9451 54.4468C83.8539 54.3746 83.759 54.3061 83.6603 54.2415C83.6527 54.2377 83.6451 54.2339 83.6413 54.2263C83.535 54.1617 83.4211 54.0971 83.3034 54.0362C83.292 54.0286 83.2806 54.021 83.2692 54.0172C83.2578 54.0134 83.2464 54.0096 83.2388 54.002C83.1211 53.945 83.0034 53.8918 82.8781 53.8385C82.8554 53.8271 82.8326 53.8195 82.806 53.8119C82.6731 53.7587 82.5402 53.7093 82.3997 53.6599L82.8744 51.7477L81.7125 51.4587H80.9873L82.1491 51.7477L81.6745 53.6599C81.815 53.7093 81.9479 53.7587 82.0808 53.8119C82.1036 53.8195 82.1264 53.8309 82.1529 53.8385C82.2782 53.8918 82.3997 53.945 82.5136 54.002C82.5364 54.0134 82.5592 54.0248 82.582 54.0362C82.6997 54.0971 82.8136 54.1579 82.9199 54.2263C82.9275 54.2301 82.9351 54.2339 82.9389 54.2415C83.0414 54.3061 83.1363 54.3746 83.2237 54.4468C83.2426 54.462 83.2578 54.4734 83.2768 54.4886C83.3186 54.5228 83.3566 54.5609 83.3983 54.5951C83.4173 54.6141 83.4401 54.6331 83.4591 54.6521C83.5084 54.7015 83.5578 54.7547 83.6034 54.808C83.6071 54.8156 83.6147 54.8194 83.6223 54.827C83.6717 54.8878 83.7173 54.9524 83.759 55.0171C83.7704 55.0361 83.7818 55.0589 83.7932 55.0779C83.8198 55.1235 83.8463 55.1691 83.8691 55.2185C83.8919 55.2642 83.9071 55.3098 83.9261 55.3554C83.9337 55.3706 83.9375 55.3858 83.9451 55.4048C83.9678 55.4694 83.983 55.5341 83.9982 55.6025C84.0172 55.6861 84.0286 55.7774 84.0324 55.8686C84.0324 55.8952 84.0324 55.9218 84.0324 55.9522C84.0324 56.0169 84.0324 56.0815 84.0324 56.1461C84.0286 56.2108 84.0248 56.2754 84.0134 56.34C83.9982 56.4427 83.9754 56.5377 83.9527 56.6289C83.9375 56.6898 83.9185 56.7506 83.8995 56.8076C83.8843 56.857 83.8653 56.9103 83.8464 56.9559C83.8198 57.0167 83.7932 57.0737 83.7628 57.1307C83.7438 57.1688 83.7248 57.2106 83.7021 57.2448C83.6413 57.3436 83.573 57.4387 83.497 57.5185C83.4894 57.5261 83.4781 57.5337 83.4705 57.5413C83.4021 57.6136 83.3262 57.6744 83.2464 57.7314C83.2199 57.7504 83.1895 57.7694 83.1591 57.7884C83.0908 57.8302 83.0186 57.8683 82.9465 57.9025C82.9161 57.9177 82.8857 57.9291 82.8554 57.9443C82.7529 57.9861 82.6465 58.0203 82.5326 58.0469C82.62 58.0926 82.7035 58.142 82.787 58.1952C82.806 58.2066 82.825 58.218 82.844 58.2332C82.9237 58.2864 82.9996 58.3397 83.068 58.3967C83.0794 58.4043 83.0908 58.4157 83.0984 58.4233C83.1439 58.4613 83.1857 58.4993 83.2275 58.5373C83.2464 58.5525 83.2616 58.5716 83.2768 58.5906C83.311 58.6248 83.3414 58.659 83.3717 58.6932C83.3869 58.7122 83.4059 58.735 83.4211 58.754C83.4477 58.7883 83.4743 58.8263 83.5008 58.8643C83.516 58.8833 83.5274 58.9061 83.5426 58.9289C83.5692 58.9707 83.592 59.0163 83.6147 59.062C83.6223 59.0772 83.6299 59.0924 83.6375 59.1114C83.6831 59.214 83.7173 59.3205 83.7438 59.4345C83.7438 59.4459 83.7514 59.4573 83.7514 59.4687C83.7666 59.5524 83.778 59.6398 83.7856 59.7272C83.7856 59.7501 83.7856 59.7691 83.7856 59.7919C83.7856 59.8641 83.7856 59.9401 83.7818 60.02C83.7818 60.0428 83.7818 60.0618 83.778 60.0846C83.7666 60.191 83.7514 60.3051 83.7248 60.4191C83.7211 60.4419 83.7135 60.4686 83.7059 60.4914C83.6755 60.613 83.6413 60.7385 83.5958 60.8677C83.5768 60.921 83.554 60.9742 83.535 61.0236C83.516 61.073 83.4932 61.1224 83.4705 61.1719C83.4553 61.2023 83.4401 61.2327 83.4287 61.2631C83.4059 61.3087 83.3793 61.3543 83.3566 61.4C83.3414 61.4266 83.33 61.4494 83.3148 61.4722C83.2616 61.5634 83.2009 61.6471 83.1401 61.7269C83.1287 61.7421 83.1136 61.7573 83.1022 61.7725C83.0376 61.8486 82.9693 61.9246 82.8971 61.9892C82.8971 61.9892 82.8895 61.993 82.8857 61.9968C82.8136 62.0614 82.7415 62.1185 82.6655 62.1717C82.6503 62.1831 82.6389 62.1907 82.6238 62.2021C82.5478 62.2515 82.4643 62.2971 82.3808 62.339C82.3656 62.3466 82.3466 62.3542 82.3314 62.3618C82.2441 62.3998 82.1529 62.4378 82.0618 62.4644C82.0618 62.4644 82.058 62.4644 82.0542 62.4644C81.9631 62.4948 81.8644 62.5138 81.7657 62.5366C81.7467 62.5366 81.7277 62.5442 81.7087 62.548C81.61 62.5671 81.5113 62.5785 81.4088 62.5861C81.3898 62.5861 81.367 62.5861 81.348 62.5899C81.2417 62.5975 81.1316 62.6013 81.0177 62.6013H81.7429C81.8568 62.6013 81.9669 62.5975 82.0732 62.5899C82.0922 62.5899 82.115 62.5899 82.134 62.5861C82.2365 62.5785 82.339 62.5633 82.4339 62.548C82.4529 62.548 82.4719 62.5404 82.4909 62.5366C82.5896 62.5176 82.6845 62.4948 82.7794 62.4644C82.7794 62.4644 82.7832 62.4644 82.787 62.4644C82.8819 62.434 82.9693 62.3998 83.0566 62.3618C83.0718 62.3542 83.0908 62.3466 83.106 62.339C83.1895 62.2971 83.2692 62.2553 83.349 62.2021C83.3641 62.1945 83.3755 62.1831 83.3907 62.1717C83.4667 62.1185 83.5426 62.0614 83.6109 61.9968C83.6109 61.9968 83.6185 61.993 83.6223 61.9892C83.6945 61.9246 83.7628 61.8486 83.8274 61.7725C83.8388 61.7573 83.8539 61.7421 83.8653 61.7269C83.9261 61.6471 83.9868 61.5634 84.04 61.4722C84.04 61.4646 84.0476 61.4608 84.0514 61.4532C84.0628 61.4342 84.0704 61.4152 84.0818 61.3962C84.1083 61.3505 84.1311 61.3087 84.1539 61.2593C84.1691 61.2289 84.1843 61.1985 84.1995 61.1681C84.2222 61.1186 84.2412 61.073 84.264 61.0198C84.2716 61.0008 84.2792 60.9856 84.2868 60.9628C84.2982 60.9286 84.3134 60.8943 84.3248 60.8601C84.3703 60.7271 84.4045 60.6054 84.4349 60.4838C84.4349 60.4686 84.4425 60.4534 84.4463 60.442C84.4463 60.4305 84.4463 60.4229 84.4501 60.4115C84.4766 60.2937 84.4918 60.1834 84.5032 60.077C84.5032 60.0694 84.5032 60.0618 84.5032 60.058C84.5032 60.0428 84.5032 60.0276 84.5032 60.0162C84.507 59.9363 84.5108 59.8603 84.507 59.7881C84.507 59.7729 84.507 59.7577 84.507 59.7463C84.507 59.7387 84.507 59.7311 84.507 59.7234C84.4994 59.6322 84.4918 59.5486 84.4728 59.4649C84.4728 59.4611 84.4728 59.4573 84.4728 59.4497C84.4728 59.4421 84.469 59.4345 84.4652 59.4307C84.4387 59.3167 84.4045 59.2102 84.3589 59.1076C84.3589 59.1076 84.3589 59.1038 84.3589 59.1C84.3513 59.0848 84.3437 59.0734 84.3361 59.0582C84.3134 59.0125 84.2906 58.9669 84.264 58.9251C84.2526 58.9023 84.2374 58.8833 84.2222 58.8605C84.1957 58.8225 84.1729 58.7844 84.1425 58.7502C84.1273 58.7312 84.1121 58.7084 84.0931 58.6894C84.0628 58.6552 84.0324 58.621 83.9982 58.5868C83.983 58.5678 83.9641 58.5526 83.9489 58.5335C83.9071 58.4955 83.8653 58.4537 83.8198 58.4195C83.8084 58.4119 83.8008 58.4043 83.7932 58.3929C83.7932 58.3929 83.7932 58.3929 83.7894 58.3929C83.7211 58.3359 83.6451 58.2826 83.5654 58.2294C83.5464 58.218 83.5274 58.2066 83.5084 58.1914C83.4287 58.142 83.3452 58.0926 83.2578 58.0469C83.3717 58.0203 83.4781 57.9861 83.5806 57.9443C83.6109 57.9329 83.6413 57.9177 83.6717 57.9025C83.7438 57.8683 83.816 57.8302 83.8843 57.7884C83.9147 57.7694 83.9413 57.7542 83.9716 57.7314C84.0514 57.6744 84.1273 57.6098 84.1957 57.5413C84.2033 57.5337 84.2146 57.5261 84.2222 57.5185C84.2982 57.4387 84.3665 57.3436 84.4273 57.2448C84.4349 57.2334 84.4425 57.2296 84.4463 57.2182C84.4614 57.1916 84.4728 57.1574 84.488 57.1307C84.5184 57.0737 84.545 57.0167 84.5716 56.9559C84.5791 56.9369 84.5867 56.9255 84.5943 56.9065C84.6057 56.876 84.6133 56.838 84.6247 56.8076C84.6437 56.7506 84.6627 56.6898 84.6779 56.6289C84.6855 56.6061 84.6931 56.5871 84.6969 56.5643C84.712 56.4921 84.7272 56.416 84.7386 56.34C84.7462 56.2906 84.7538 56.2412 84.7576 56.1917C84.7576 56.1765 84.7576 56.1613 84.7576 56.1461C84.7614 56.0777 84.7614 56.0131 84.7576 55.9522L84.7538 55.9484Z",
    fill: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M230.793 48.0106C230.793 47.946 230.785 47.8814 230.781 47.813L230.766 47.5925C230.755 47.4404 230.747 47.2921 230.728 47.1173C230.69 46.7295 230.641 46.3493 230.58 45.973L230.531 45.6727C230.478 45.3647 230.417 45.0606 230.341 44.7185C230.333 44.6766 230.326 44.631 230.314 44.5854L230.295 44.5208C230.201 44.1254 230.087 43.7186 229.958 43.3081L229.878 43.0571C229.73 42.6048 229.585 42.2132 229.426 41.8216C229.282 41.4681 229.115 41.0993 228.913 40.6925L228.803 40.4682C228.613 40.0957 228.416 39.7383 228.215 39.3962L228.093 39.2023C227.892 38.8716 227.683 38.5522 227.436 38.1987L227.387 38.1265C227.163 37.8147 226.92 37.4954 226.639 37.157L226.472 36.9556C226.191 36.621 225.925 36.3283 225.656 36.0508L225.546 35.9443C225.28 35.6744 225.006 35.4159 224.714 35.1498C224.688 35.1232 224.657 35.0928 224.627 35.0662L224.57 35.0167C224.285 34.7696 223.996 34.5339 223.7 34.3058L223.503 34.1576C223.241 33.9637 222.975 33.7774 222.679 33.5797C222.645 33.5569 222.611 33.5303 222.576 33.5113L222.508 33.4695C222.258 33.3098 222.003 33.1539 221.749 33.0095L221.699 32.9791C221.426 32.8232 221.145 32.6749 220.86 32.5343L220.8 32.5039C220.743 32.4773 220.686 32.4506 220.625 32.424L220.538 32.386C220.378 32.31 220.215 32.234 220.052 32.1617C219.968 32.1275 219.884 32.0933 219.801 32.0591L219.702 32.0173C219.543 31.9526 219.383 31.888 219.186 31.8158L218.829 31.6903C218.688 31.6409 218.544 31.5953 218.4 31.5497C218.267 31.5078 218.13 31.4698 217.997 31.4318C217.853 31.39 217.709 31.3482 217.508 31.2988L217.398 31.2683C217.341 31.2531 217.284 31.2417 217.227 31.2303L217.143 31.2113C216.999 31.1771 216.851 31.1467 216.706 31.1163C216.566 31.0897 216.426 31.0631 216.281 31.0364C216.133 31.0098 215.985 30.987 215.784 30.9566L215.659 30.9376C215.605 30.93 215.552 30.9262 215.495 30.9186L215.412 30.911C215.252 30.892 215.093 30.873 214.93 30.8578C214.789 30.8464 214.649 30.835 214.508 30.8236C214.345 30.8122 214.182 30.8045 214.018 30.7969L213.798 30.7855C213.65 30.7855 213.502 30.7817 213.354 30.7817H208.634V31.6713V32.5609C208.828 32.5609 209.022 32.5685 209.23 32.5761C209.379 32.5837 209.523 32.5913 209.667 32.5989C209.792 32.6065 209.921 32.6179 210.047 32.6293C210.191 32.6445 210.335 32.6597 210.48 32.6749C210.605 32.6901 210.73 32.7054 210.856 32.7244C210.988 32.7434 211.121 32.7662 211.254 32.789C211.379 32.8118 211.509 32.8346 211.634 32.8612C211.767 32.8878 211.896 32.9182 212.025 32.9487C212.15 32.9753 212.272 33.0057 212.397 33.0361C212.53 33.0703 212.659 33.1045 212.788 33.1425C212.91 33.1768 213.031 33.211 213.149 33.249C213.278 33.2908 213.403 33.3326 213.532 33.3782C213.65 33.4163 213.764 33.4581 213.878 33.4999C214.022 33.5531 214.166 33.6101 214.307 33.6672L214.39 33.7014C214.466 33.7318 214.542 33.7622 214.622 33.7964C214.77 33.861 214.914 33.9295 215.059 33.9979L215.343 34.131C215.598 34.2564 215.848 34.3895 216.088 34.5225L216.137 34.5529C216.369 34.686 216.596 34.8229 216.82 34.9673L216.991 35.0814C217.234 35.241 217.473 35.4121 217.709 35.5832L217.887 35.7162C218.157 35.9215 218.415 36.1344 218.669 36.3549L218.814 36.4842C219.064 36.7085 219.311 36.9442 219.55 37.1875L219.649 37.2863C219.903 37.5486 220.146 37.8223 220.382 38.0998L220.534 38.2823C220.765 38.5674 220.993 38.8564 221.229 39.1909L221.274 39.2555C221.475 39.5407 221.661 39.8296 221.844 40.1261L221.954 40.301C222.14 40.6165 222.318 40.9396 222.485 41.2666L222.588 41.4719C222.77 41.8444 222.922 42.1752 223.062 42.5249C223.192 42.8405 223.317 43.194 223.454 43.6046L223.529 43.8365C223.647 44.2166 223.75 44.5778 223.833 44.9351L223.883 45.1518C223.943 45.4218 224 45.6993 224.046 45.973L224.091 46.2429C224.145 46.585 224.194 46.931 224.224 47.2807C224.239 47.4518 224.251 47.6229 224.262 47.8206L224.281 48.0905C224.293 48.3642 224.3 48.6417 224.3 48.9192C224.3 49.0827 224.293 49.2424 224.289 49.402V49.4933C224.281 49.6491 224.274 49.8012 224.266 49.9571C224.258 50.0901 224.247 50.2232 224.236 50.3524C224.224 50.5045 224.209 50.6566 224.194 50.8048C224.179 50.9379 224.164 51.0709 224.145 51.204C224.126 51.3447 224.107 51.4853 224.084 51.6184C224.061 51.7514 224.038 51.8845 224.015 52.0213C223.989 52.1582 223.962 52.2951 223.936 52.4319C223.909 52.5612 223.879 52.6904 223.848 52.8235C223.818 52.9603 223.784 53.0934 223.746 53.2303C223.712 53.3595 223.678 53.4888 223.643 53.6142C223.605 53.7473 223.564 53.8803 223.526 54.0134C223.488 54.135 223.446 54.2567 223.408 54.3783C223.359 54.5266 223.305 54.6711 223.245 54.8383C223.203 54.9448 223.165 55.0512 223.123 55.1577C223.066 55.3059 223.005 55.4504 222.941 55.5911L222.911 55.6633C222.876 55.7469 222.842 55.8268 222.804 55.9104C222.713 56.1119 222.614 56.3134 222.516 56.5111L222.425 56.6973C222.292 56.9558 222.151 57.2067 221.977 57.4995L221.931 57.5717C221.775 57.834 221.608 58.0925 221.418 58.3776L221.293 58.5563C221.099 58.8338 220.898 59.1076 220.686 59.3737L220.538 59.5523C220.412 59.7044 220.291 59.8527 220.162 59.9971L219.953 60.2252C219.839 60.3507 219.721 60.4761 219.603 60.5978C219.531 60.67 219.459 60.7423 219.364 60.8335C219.25 60.9475 219.133 61.0578 219.011 61.168C218.928 61.2441 218.844 61.3201 218.757 61.3961C218.635 61.5026 218.514 61.6052 218.392 61.7117C218.305 61.7839 218.218 61.8561 218.13 61.9284C218.001 62.031 217.872 62.1298 217.747 62.2249L217.477 62.4226C217.341 62.5214 217.2 62.6164 217.06 62.7077L216.805 62.8788C216.642 62.9852 216.475 63.084 216.304 63.1829L216.11 63.3007C215.875 63.4338 215.636 63.563 215.393 63.6847L215.245 63.7531C215.051 63.8482 214.854 63.9394 214.652 64.0268L214.379 64.1371C214.22 64.2055 214.056 64.2701 213.893 64.331C213.817 64.3614 213.737 64.388 213.658 64.4146L213.582 64.4412C213.426 64.4944 213.27 64.5477 213.111 64.5971C213.005 64.6313 212.898 64.6617 212.784 64.6921C212.629 64.7377 212.473 64.7796 212.313 64.8176C212.203 64.8442 212.089 64.8746 211.972 64.8974C211.812 64.9354 211.653 64.9658 211.493 64.9963C211.379 65.0191 211.269 65.0419 211.155 65.0609C210.988 65.0875 210.818 65.1141 210.647 65.1369L210.548 65.1521C210.472 65.1635 210.396 65.1749 210.32 65.1825C210.134 65.2053 209.944 65.2205 209.754 65.232L209.477 65.2548C209.192 65.27 208.908 65.2814 208.619 65.2814V66.171V67.0605H213.339C213.661 67.0605 213.977 67.0491 214.295 67.0339L214.603 67.0111C214.816 66.9959 215.028 66.9769 215.237 66.9541C215.328 66.9427 215.419 66.9313 215.51 66.9199L215.605 66.9085C215.795 66.8819 215.985 66.8552 216.171 66.8248C216.293 66.8058 216.418 66.7792 216.551 66.7526C216.733 66.7184 216.912 66.6804 217.09 66.6385C217.215 66.6081 217.344 66.5777 217.47 66.5473C217.644 66.5017 217.823 66.4561 218.005 66.4029C218.127 66.3686 218.244 66.3344 218.362 66.2964C218.54 66.2432 218.715 66.1824 218.886 66.1215L218.958 66.0987C219.049 66.0645 219.144 66.0341 219.235 65.9999C219.417 65.9314 219.6 65.8592 219.778 65.7832L219.873 65.7452C219.945 65.7186 220.014 65.6881 220.082 65.6577C220.306 65.5589 220.522 65.4562 220.792 65.327L220.91 65.2738C221.179 65.1369 221.449 64.9963 221.715 64.8442L221.931 64.7149C222.117 64.6047 222.307 64.4944 222.489 64.3766C222.554 64.3348 222.618 64.2892 222.683 64.2473L222.774 64.1865C222.93 64.0801 223.089 63.9774 223.241 63.8672C223.324 63.8063 223.408 63.7455 223.537 63.6467C223.681 63.5402 223.826 63.43 223.966 63.3159C224.065 63.2361 224.164 63.1563 224.258 63.0764C224.395 62.9624 224.528 62.8483 224.665 62.7267C224.76 62.6431 224.855 62.5594 224.946 62.472C225.079 62.3503 225.208 62.2249 225.375 62.0614C225.451 61.9854 225.527 61.9131 225.599 61.8371C225.732 61.7003 225.857 61.5634 225.99 61.4227L226.221 61.1718C226.366 61.0084 226.502 60.8449 226.635 60.6814L226.802 60.4799C227.038 60.1872 227.262 59.8831 227.474 59.5714L227.634 59.3357C227.824 59.0543 228.006 58.7692 228.188 58.4689L228.26 58.351C228.424 58.0735 228.576 57.796 228.727 57.5071L228.826 57.3018C228.936 57.0813 229.043 56.8608 229.156 56.6175L229.194 56.5339C229.217 56.4806 229.24 56.4236 229.263 56.3704L229.297 56.2868C229.365 56.1271 229.434 55.9674 229.498 55.804C229.548 55.6785 229.593 55.553 229.642 55.4276C229.703 55.2641 229.76 55.1045 229.836 54.8878L229.946 54.538C229.992 54.3936 230.037 54.2453 230.079 54.097C230.121 53.9564 230.159 53.8157 230.193 53.6751C230.231 53.5268 230.269 53.3785 230.307 53.2227L230.402 52.7931C230.432 52.641 230.463 52.4928 230.489 52.3445C230.516 52.2 230.542 52.0518 230.565 51.9035C230.592 51.7476 230.611 51.5956 230.633 51.4435L230.687 51.0025C230.706 50.8352 230.721 50.668 230.736 50.4969C230.747 50.3524 230.759 50.208 230.766 50.0635C230.778 49.8924 230.782 49.7214 230.789 49.5541V49.4667C230.797 49.4058 230.8 49.3488 230.8 49.2918C230.8 49.1701 230.8 49.0447 230.8 48.9192C230.8 48.6113 230.793 48.3072 230.778 48.003L230.793 48.0106Z",
    fill: "#30CFB0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M209.405 66.3914C218.81 66.3914 226.434 58.5705 226.434 48.923C226.434 39.2755 218.81 31.4546 209.405 31.4546C200 31.4546 192.376 39.2755 192.376 48.923C192.376 58.5705 200 66.3914 209.405 66.3914Z",
    fill: "#E3F7F4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M221.574 35.7541C218.4 32.671 214.11 30.7778 209.405 30.7778C199.636 30.7778 191.689 38.9171 191.689 48.9191C191.689 58.9212 199.64 67.068 209.405 67.068C217.728 67.068 224.729 61.1565 226.613 53.2074C226.943 51.8312 227.118 50.3942 227.118 48.9191C227.118 43.7337 224.984 39.0577 221.574 35.7503V35.7541ZM209.409 66.4104C200.016 66.4104 192.376 58.5638 192.376 48.9191C192.376 39.2744 200.016 31.4355 209.409 31.4355C213.529 31.4355 217.306 32.9486 220.257 35.4614C224.027 38.6662 226.434 43.5094 226.434 48.9229C226.434 50.3789 226.263 51.7931 225.929 53.1427C224.095 60.7535 217.379 66.4142 209.409 66.4142V66.4104Z",
    fill: "#30CFB0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M230.816 48.9268V49.2956C230.808 49.3564 230.808 49.4134 230.804 49.4743V49.5617C230.797 49.729 230.793 49.9001 230.782 50.0711C230.77 50.2118 230.763 50.3601 230.751 50.5045C230.732 50.6756 230.717 50.8429 230.698 51.0101L230.645 51.4549C230.626 51.6032 230.603 51.759 230.58 51.9111C230.558 52.0594 230.535 52.2076 230.504 52.3559C230.482 52.5042 230.444 52.6524 230.417 52.8007L230.322 53.2341C230.288 53.3899 230.25 53.5382 230.208 53.6865C230.185 53.7815 230.163 53.8689 230.136 53.964L226.237 53.2113L224.49 52.8729C224.805 51.6108 224.965 50.2878 224.965 48.923C224.965 43.8593 222.713 39.3278 219.182 36.3245L221.194 35.7543L224.376 34.8533C224.441 34.9065 224.505 34.9673 224.574 35.0205L224.634 35.0662C224.665 35.089 224.695 35.1194 224.722 35.1498C225.018 35.4121 225.291 35.6706 225.549 35.9405L225.663 36.0546C225.929 36.3283 226.195 36.6248 226.476 36.9556L226.647 37.1571C226.924 37.4992 227.167 37.8147 227.395 38.1303L227.44 38.2025C227.691 38.5522 227.896 38.8792 228.097 39.2061L228.215 39.4038C228.416 39.7421 228.617 40.1033 228.807 40.4759L228.921 40.7002C229.115 41.1031 229.282 41.4719 229.43 41.8254C229.589 42.2094 229.734 42.601 229.882 43.061L229.965 43.3119C230.091 43.7262 230.201 44.1292 230.296 44.5284L230.315 44.593C230.326 44.6386 230.337 44.6804 230.345 44.7223C230.421 45.0644 230.482 45.3685 230.535 45.6765L230.588 45.973C230.649 46.3531 230.694 46.7333 230.736 47.1173C230.755 47.296 230.759 47.4442 230.77 47.5963L230.782 47.8168C230.789 47.8814 230.793 47.946 230.801 48.0107C230.812 48.3148 230.82 48.6227 230.82 48.9306L230.816 48.9268Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M204.359 40.1147L206.554 41.3845L206.432 41.4529L201.109 44.5322V55.8534L199.742 55.0627C199.233 54.7662 198.914 54.2149 198.914 53.6295V44.2205C198.914 43.6274 199.233 43.08 199.742 42.7873L204.355 40.1185L204.359 40.1147Z",
    fill: "#30CFB0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M208.707 42.6277L209.804 43.2626V54.5838L208.707 55.2186L207.605 54.5838V43.2626L207.647 43.2397L208.707 42.6277Z",
    fill: "#30CFB0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M205.456 44.5055V55.8267L210.901 58.9745L209.534 59.7652C209.284 59.9097 208.995 59.9857 208.707 59.9857C208.418 59.9857 208.129 59.9058 207.879 59.7652L203.266 57.0926V45.7714L205.46 44.5017L205.456 44.5055Z",
    fill: "#30CFB0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M208.703 37.8604C208.987 37.8604 209.276 37.9326 209.53 38.0808L214.143 40.7534V52.0746L211.949 53.3443V42.0231L206.504 38.8754L207.871 38.0846C208.125 37.9364 208.41 37.8642 208.699 37.8642L208.703 37.8604Z",
    fill: "#30CFB0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M216.297 41.9928L217.663 42.7835C218.176 43.0763 218.491 43.6275 218.491 44.2168V53.6258C218.491 54.215 218.176 54.7662 217.667 55.059L213.054 57.7277L210.859 56.458L210.977 56.3895L216.3 53.3102V41.989L216.297 41.9928Z",
    fill: "#30CFB0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M131.007 137.132H107.983V179.778H131.007V137.132Z",
    fill: "#CCEDE8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M131.008 137.132H123.869V179.778H131.008V137.132Z",
    fill: "#09363F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M161.508 122.096H138.483V179.778H161.508V122.096Z",
    fill: "#CCEDE8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M161.511 122.096H154.373V179.778H161.511V122.096Z",
    fill: "#09363F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M100.507 149.548H77.4829V179.778H100.507V149.548Z",
    fill: "#CCEDE8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M100.507 149.548H93.3691V179.778H100.507V149.548Z",
    fill: "#09363F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M70.003 163.283H46.9788V179.778H70.003V163.283Z",
    fill: "#CCEDE8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0068 163.283H62.8687V179.778H70.0068V163.283Z",
    fill: "#09363F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5028 168.993H16.4785V179.782H39.5028V168.993Z",
    fill: "#CCEDE8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5029 168.993H32.3647V179.782H39.5029V168.993Z",
    fill: "#09363F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M192.012 103.146H168.988V179.778H192.012V103.146Z",
    fill: "#CCEDE8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M192.012 103.146H184.874V179.778H192.012V103.146Z",
    fill: "#09363F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M222.512 82.0579H199.488V179.778H222.512V82.0579Z",
    fill: "#CCEDE8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M222.516 82.0579H215.378V179.778H222.516V82.0579Z",
    fill: "#09363F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M127.362 38.4874L127.7 38.7003C131.098 40.8558 132.279 45.2657 130.404 48.8316C128.661 52.1504 126.694 55.7962 125.601 57.4765C123.338 60.955 119.491 59.2784 119.491 59.2784C119.484 59.2746 118.098 61.6507 118.098 61.6507L115.311 62.0232L111.226 54.0056L117.703 42.27C119.693 38.4304 123.584 36.3889 127.362 38.4874Z",
    fill: "#CCEDE8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M119.491 59.2785C119.491 59.2785 117.202 58.0088 115.786 55.0359C115.786 55.0359 115.216 58.3661 118.91 60.2669L119.491 59.2747V59.2785Z",
    fill: "#95C9C3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M116.348 45.049C116.306 44.9844 114.392 42.8099 112.953 45.2543C111.514 47.6987 114.263 48.6415 114.309 48.5769C114.354 48.5085 116.348 45.049 116.348 45.049Z",
    fill: "#CCEDE8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M132.511 48.5808C130.833 47.9307 129.322 46.9005 128.642 45.2354C128.448 44.7564 128.3 44.2507 128.194 43.7337C128.004 42.7985 128.023 41.7797 127.507 40.9814C126.838 39.9511 125.506 39.6242 124.306 39.3771L124.37 39.3657C123.71 39.2972 123.034 39.3581 122.396 39.5443C121.272 42.0534 119.499 44.2697 117.289 45.9044C117.107 46.0375 116.879 46.1059 116.655 46.0717C115.949 45.9691 116.568 45.3076 116.226 44.9122C115.964 44.6081 115.763 44.5853 115.125 44.1899C115.254 43.441 116.093 41.6808 116.424 40.6582C116.215 39.7762 116.325 38.4343 116.78 37.5941C117.236 36.7578 118.303 35.967 118.303 35.967C119.609 35.1421 120.315 34.7467 121.462 34.971L121.477 34.9938C122.529 35.1535 123.577 35.7693 123.922 36.773C124.849 35.6021 126.561 35.2523 127.996 35.6629C129.432 36.0735 131.307 37.4497 132.215 38.6358C132.834 39.4455 133.251 40.5442 133.627 42.0002C133.677 42.1941 133.726 42.3918 133.775 42.597C133.779 42.616 133.783 42.6313 133.787 42.6503C133.954 42.9734 134.235 43.2395 134.554 43.4752C135.062 43.8516 135.503 43.8744 136.107 43.6843C136.289 43.6273 136.52 43.5512 136.649 43.6957C136.733 43.7869 136.729 43.9238 136.703 44.0417C136.57 44.6765 135.989 45.1441 135.359 45.3038C135.055 45.3798 134.743 45.395 134.428 45.376C134.428 45.376 134.531 46.0375 135.1 46.5013C135.404 46.7484 135.598 47.121 135.624 47.5125C135.64 47.7026 135.609 47.9041 135.507 48.0866C134.911 49.1244 133.604 48.999 132.511 48.5732V48.5808Z",
    fill: "#09363F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M119.078 48.8355C118.952 48.2158 119.096 47.5733 119.48 47.0221C120.277 45.8816 121.861 45.5205 123.091 46.1971C123.732 46.5469 124.162 47.1019 124.302 47.7558C124.439 48.3907 124.279 49.0636 123.858 49.649C123 50.8313 121.451 51.1735 120.255 50.4473C119.632 50.0672 119.214 49.4969 119.081 48.8393L119.078 48.8355ZM122.829 46.6761C121.838 46.1287 120.558 46.4176 119.92 47.3338C119.62 47.7634 119.51 48.2462 119.609 48.7214C119.712 49.2308 120.042 49.6794 120.536 49.9798C121.492 50.5614 122.734 50.2839 123.421 49.3335C123.755 48.8697 123.877 48.3679 123.774 47.8813C123.672 47.4099 123.368 47.0031 122.912 46.7294C122.886 46.7142 122.855 46.6952 122.829 46.6799V46.6761Z",
    fill: "#09363F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M125.263 51.4319C125.137 50.8122 125.282 50.1698 125.665 49.6185C126.462 48.478 128.046 48.1169 129.276 48.7936C129.918 49.1471 130.347 49.6984 130.487 50.3522C130.624 50.9871 130.464 51.66 130.043 52.2454C129.185 53.4277 127.636 53.7699 126.44 53.0438C125.817 52.6636 125.399 52.0934 125.266 51.4319H125.263ZM129.014 49.2726C128.023 48.7252 126.743 49.0141 126.105 49.9303C125.806 50.3598 125.695 50.8427 125.794 51.3179C125.897 51.8273 126.227 52.2759 126.721 52.5762C127.677 53.1578 128.919 52.8803 129.606 51.9299C129.94 51.4661 130.062 50.9643 129.959 50.4777C129.857 50.0063 129.553 49.6033 129.097 49.3258C129.071 49.3106 129.04 49.2916 129.014 49.2764V49.2726Z",
    fill: "#09363F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M123.953 49.2537C124.435 49.189 124.925 49.2803 125.335 49.5084C125.506 49.6034 125.661 49.7175 125.79 49.8467L126.17 49.4513C126.003 49.2879 125.809 49.1472 125.597 49.0294C125.088 48.7481 124.48 48.6378 123.888 48.7138L123.953 49.2537Z",
    fill: "#09363F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5701 119.789L48.5089 116.667L44.5449 132.919C48.0077 133.619 51.2806 125.556 51.2806 125.556L59.5692 127.901L61.5701 119.789Z",
    fill: "#375A64"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5938 116.561L49.0366 117.048L44.6208 132.961C44.6208 132.961 43.8386 132.783 43.3526 132.657C43.178 132.612 43.0717 132.425 43.1172 132.25L46.8344 117.006C46.9179 116.668 47.2634 116.466 47.5976 116.561H47.5938Z",
    fill: "#DAEDEA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2994 125.841C51.2197 125.818 51.2805 125.415 51.121 124.959C50.9729 124.503 50.6806 124.218 50.7299 124.153C50.7641 124.085 51.2083 124.316 51.3906 124.868C51.5804 125.419 51.3678 125.875 51.2994 125.841Z",
    fill: "#09363F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1795 127.373C50.0998 127.373 50.0466 126.997 49.7771 126.643C49.5189 126.282 49.1734 126.126 49.1961 126.05C49.2037 125.974 49.6783 126.031 50.0049 126.476C50.3352 126.917 50.2555 127.392 50.1795 127.373Z",
    fill: "#09363F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9051 127.841C47.9051 127.764 48.3303 127.749 48.7138 128.061C49.1011 128.369 49.1808 128.783 49.1049 128.802C49.029 128.833 48.8543 128.532 48.5354 128.285C48.2202 128.027 47.8937 127.924 47.9051 127.844V127.841Z",
    fill: "#09363F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2474 126.164C53.1828 126.115 53.3803 125.776 53.46 125.32C53.5473 124.864 53.4828 124.48 53.5625 124.453C53.6309 124.423 53.8397 124.833 53.741 125.369C53.646 125.905 53.3005 126.217 53.2474 126.164Z",
    fill: "#09363F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2673 126.248C55.2331 126.24 55.2635 125.913 55.4685 125.434C55.5711 125.195 55.7267 124.921 55.9356 124.647C56.0419 124.51 56.1634 124.374 56.2963 124.241C56.3608 124.176 56.433 124.1 56.5469 124.043C56.6494 123.974 56.8734 123.978 56.9759 124.111C57.0822 124.225 57.0974 124.385 57.0708 124.503C57.0443 124.624 56.9987 124.716 56.9531 124.799C56.8658 124.97 56.7633 125.126 56.657 125.263C56.4406 125.541 56.2013 125.746 55.9811 125.894C55.5407 126.187 55.2142 126.244 55.2028 126.21C55.1838 126.168 55.4799 126.046 55.8596 125.731C56.0495 125.575 56.2583 125.366 56.4443 125.103C56.5393 124.97 56.6266 124.83 56.7025 124.67C56.7899 124.51 56.8278 124.362 56.7595 124.301C56.7329 124.279 56.7215 124.275 56.6646 124.298C56.6076 124.324 56.5469 124.381 56.4823 124.446C56.3532 124.567 56.2355 124.693 56.133 124.815C55.9242 125.065 55.7609 125.313 55.6394 125.529C55.3964 125.963 55.3015 126.263 55.2559 126.252L55.2673 126.248Z",
    fill: "#09363F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M55.18 126.118C55.1762 126.088 55.4989 126.001 56.0191 126.096C56.2773 126.145 56.5772 126.248 56.881 126.423C57.0328 126.514 57.1809 126.62 57.3252 126.749C57.4619 126.883 57.6479 127.054 57.61 127.369C57.5758 127.533 57.4201 127.635 57.2986 127.654C57.1771 127.681 57.0784 127.669 56.9797 127.666C56.7822 127.65 56.5962 127.601 56.4329 127.533C56.0988 127.396 55.8482 127.187 55.6774 126.981C55.3356 126.559 55.3205 126.206 55.347 126.206C55.3926 126.191 55.4799 126.502 55.8254 126.844C55.9963 127.012 56.2317 127.183 56.5279 127.289C56.6759 127.342 56.8354 127.377 57.0025 127.388C57.1809 127.403 57.3366 127.373 57.3328 127.304C57.3556 127.225 57.2569 127.054 57.1354 126.955C57.0101 126.837 56.8772 126.734 56.7443 126.647C56.4747 126.472 56.2051 126.362 55.9697 126.289C55.4989 126.153 55.18 126.164 55.18 126.118Z",
    fill: "#09363F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4286 121.222L6.81543 125.837L12.469 141.58C15.8824 140.12 14.0295 131.718 14.0295 131.718L22.2307 129.091L19.4286 121.222Z",
    fill: "#375A64"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9624 126.605C12.7688 126.331 12.3511 126.244 12.0701 126.426C11.7892 126.609 11.6942 127.031 11.8841 127.312C12.0701 127.59 12.5713 127.711 12.8295 127.498C13.0877 127.286 13.1712 126.784 12.9206 126.556",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19882 125.659L8.28853 125.297L13.1827 141.104C13.1827 141.104 12.7574 141.686 12.0854 141.884C11.8652 141.948 11.6298 141.838 11.5462 141.621L6.21164 127.582C5.90409 126.776 6.36351 125.883 7.19882 125.662V125.659Z",
    fill: "#DAEDEA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2002 131.942C14.1243 131.969 13.9496 131.597 13.5661 131.308C13.1902 131.007 12.7878 130.931 12.7954 130.851C12.784 130.775 13.2852 130.726 13.7408 131.083C14.2002 131.437 14.2761 131.935 14.2002 131.942Z",
    fill: "#09363F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1091 133.84C14.0407 133.885 13.7901 133.596 13.3725 133.456C12.9586 133.3 12.5827 133.361 12.56 133.281C12.522 133.212 12.951 132.999 13.4712 133.186C13.9914 133.372 14.185 133.809 14.1129 133.84H14.1091Z",
    fill: "#09363F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4727 135.489C12.4309 135.425 12.7764 135.181 13.2662 135.227C13.7598 135.269 14.0522 135.573 14.0028 135.626C13.9534 135.691 13.6459 135.539 13.2434 135.508C12.841 135.467 12.5106 135.562 12.4727 135.489Z",
    fill: "#09363F"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0037 131.136C15.9239 131.129 15.9012 130.737 15.7151 130.315C15.5367 129.89 15.2709 129.601 15.324 129.54C15.362 129.475 15.7645 129.703 15.9771 130.205C16.1935 130.707 16.0758 131.155 16.0037 131.136Z",
    fill: "#09363F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7352 130.091C17.7048 130.103 17.5453 129.817 17.4542 129.3C17.4086 129.046 17.3859 128.73 17.4124 128.384C17.4238 128.209 17.4504 128.031 17.4884 127.844C17.5074 127.757 17.5263 127.651 17.5871 127.54C17.6365 127.426 17.8225 127.305 17.982 127.358C18.1301 127.396 18.2364 127.518 18.2781 127.632C18.3237 127.746 18.3351 127.848 18.3427 127.943C18.3617 128.133 18.3655 128.32 18.3503 128.495C18.3199 128.844 18.2364 129.152 18.1338 129.392C17.9288 129.878 17.6858 130.106 17.6592 130.087C17.6213 130.061 17.7997 129.798 17.944 129.327C18.0161 129.091 18.0731 128.802 18.0883 128.483C18.0921 128.323 18.0883 128.152 18.0655 127.981C18.0503 127.799 18.001 127.658 17.9098 127.639C17.8757 127.635 17.8643 127.639 17.8263 127.689C17.7959 127.742 17.7731 127.825 17.7542 127.913C17.7124 128.084 17.6858 128.255 17.6668 128.415C17.6289 128.738 17.6327 129.034 17.6478 129.281C17.6858 129.779 17.7693 130.084 17.7276 130.095L17.7352 130.091Z",
    fill: "#09363F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5872 130.03C17.5644 130.007 17.7846 129.757 18.2744 129.547C18.5174 129.445 18.825 129.365 19.1743 129.346C19.3489 129.338 19.535 129.346 19.7248 129.376C19.9147 129.414 20.1615 129.449 20.302 129.738C20.3627 129.89 20.2906 130.065 20.1994 130.144C20.1121 130.236 20.0248 130.277 19.9412 130.331C19.7666 130.426 19.5881 130.486 19.4097 130.521C19.0566 130.593 18.73 130.555 18.4757 130.475C17.9593 130.315 17.7505 130.026 17.7732 130.011C17.8036 129.973 18.0466 130.186 18.5212 130.281C18.7566 130.327 19.049 130.338 19.3489 130.266C19.5008 130.228 19.6527 130.171 19.797 130.087C19.9564 130.004 20.0665 129.89 20.0286 129.836C20.002 129.757 19.8273 129.669 19.6717 129.654C19.5008 129.624 19.3337 129.612 19.1743 129.612C18.8553 129.612 18.5668 129.669 18.3352 129.741C17.8644 129.886 17.61 130.072 17.5796 130.034L17.5872 130.03Z",
    fill: "#09363F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7443 84.3387C80.3874 84.3387 77.3043 83.7038 72.7443 87.8248C68.1843 91.9495 67.3413 95.1999 67.3413 95.1999L47.8937 107.905L13.2625 121.347L18.0997 132.402L53.5511 119.96C53.5511 119.96 72.2393 113.094 74.358 112.03C78.4434 109.981 93.3841 100.15 93.3841 100.15L80.7481 84.3349L80.7443 84.3387Z",
    fill: "#09363F"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1942 106.324L77.2967 120.747L56.9188 118.051L54.5762 127.609C54.5762 127.609 85.0119 135.265 87.161 134.459C89.31 133.653 90.8553 132.79 91.4742 131.342C92.0969 129.894 94.5269 97.1616 94.5269 97.1616L80.8695 101.092L77.1904 106.32L77.1942 106.324Z",
    fill: "#09363F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7477 100.336C91.7477 100.336 91.7022 100.397 91.6035 100.499C91.4857 100.617 91.3377 100.762 91.1592 100.937C90.7795 101.324 90.1796 101.826 89.4354 102.45C87.9357 103.674 85.7525 105.225 83.2655 106.818C80.7824 108.414 78.4739 109.764 76.7881 110.711C75.9451 111.186 75.2579 111.558 74.7795 111.809C74.5555 111.923 74.3732 112.014 74.2252 112.094C74.0961 112.155 74.0277 112.186 74.0239 112.178C74.0239 112.17 74.0809 112.129 74.2024 112.052C74.3467 111.965 74.5213 111.862 74.7377 111.733C75.2313 111.444 75.8996 111.053 76.7121 110.574C78.3751 109.593 80.6685 108.224 83.1478 106.631C85.6272 105.042 87.818 103.514 89.3405 102.328C90.0923 101.727 90.7074 101.241 91.1061 100.876C91.2959 100.712 91.4516 100.579 91.5769 100.469C91.687 100.378 91.7477 100.332 91.7515 100.336H91.7477Z",
    fill: "#375A64"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1833 125.525C82.1415 125.533 82.0808 125.107 81.8302 124.476C81.7087 124.161 81.5226 123.799 81.2834 123.423C81.0328 123.054 80.7253 122.667 80.3532 122.313C79.9773 121.963 79.5748 121.674 79.1913 121.446C78.8041 121.23 78.432 121.062 78.113 120.96C77.4714 120.747 77.0423 120.709 77.0499 120.667C77.0499 120.652 77.1562 120.652 77.3499 120.667C77.5435 120.675 77.8245 120.724 78.1586 120.815C78.4965 120.903 78.8838 121.058 79.2939 121.275C79.6963 121.499 80.1178 121.792 80.5089 122.157C80.8961 122.526 81.2075 122.929 81.4581 123.32C81.6973 123.716 81.8757 124.096 81.982 124.427C82.0922 124.757 82.1567 125.035 82.1757 125.225C82.1985 125.419 82.2061 125.525 82.1909 125.525H82.1833Z",
    fill: "#375A64"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3718 121.937C83.3566 121.998 82.0618 121.747 80.4747 121.382C78.8876 121.017 77.6119 120.671 77.6271 120.61C77.6423 120.549 78.937 120.8 80.5241 121.165C82.1112 121.53 83.3869 121.876 83.3718 121.937Z",
    fill: "#375A64"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0238 112.174C74.0238 112.174 73.9782 112.201 73.8871 112.243C73.7846 112.288 73.6479 112.345 73.4732 112.421C73.0935 112.581 72.5582 112.801 71.8748 113.09C70.4851 113.668 68.4652 114.482 65.9592 115.463C60.9473 117.432 53.9801 120.024 46.2345 122.754C38.485 125.484 31.4456 127.875 26.354 129.62C23.8177 130.487 21.7598 131.19 20.3208 131.68C19.6184 131.916 19.0678 132.102 18.6767 132.231C18.4983 132.288 18.354 132.334 18.2477 132.368C18.149 132.399 18.0996 132.41 18.0996 132.41C18.0996 132.41 18.1452 132.387 18.2401 132.349C18.3464 132.311 18.4869 132.258 18.6615 132.19C19.045 132.049 19.5918 131.851 20.2904 131.597C21.7218 131.091 23.7721 130.365 26.3009 129.471C31.3925 127.696 38.4091 125.248 46.1585 122.545C53.9041 119.815 60.879 117.246 65.9023 115.318C68.4158 114.352 70.4433 113.566 71.8444 113.011C72.5354 112.741 73.0784 112.531 73.458 112.379C73.6365 112.315 73.7732 112.262 73.8795 112.22C73.9744 112.186 74.0238 112.17 74.0276 112.174H74.0238Z",
    fill: "#375A64"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M155.922 46.8777L159.397 44.1862C159.397 44.1862 161.857 41.0879 162.267 40.9054C162.677 40.7229 163.034 40.7761 163.19 41.0156C163.345 41.2513 166.14 43.4183 166.299 43.654C166.455 43.8897 165.46 45.7525 165.46 45.7525L165.244 46.1858C165.244 46.1858 166.626 46.2733 166.948 46.8701C167.1 47.1552 166.368 47.8966 165.472 47.9308C164.659 47.9612 163.44 48.1437 161.811 48.809C161.443 48.9572 161.037 48.9686 160.668 48.8394C160.463 48.7671 160.3 48.6949 160.38 48.6721C160.691 48.5771 157.312 50.6603 157.312 50.6603L155.922 46.8853V46.8777Z",
    fill: "#CCEDE8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M166.945 46.8702C166.914 46.8854 166.797 46.6497 166.413 46.5166C166.041 46.376 165.475 46.3075 164.849 46.2695C164.219 46.2391 163.626 46.1593 163.231 45.9806C162.833 45.8095 162.654 45.6004 162.673 45.5814C162.696 45.551 162.901 45.7107 163.285 45.8323C163.668 45.9616 164.23 46.0148 164.86 46.0452C165.494 46.0794 166.083 46.1745 166.474 46.3683C166.671 46.4634 166.808 46.5812 166.88 46.6877C166.952 46.7903 166.956 46.8626 166.945 46.8664V46.8702Z",
    fill: "#95C9C3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M163.497 43.2929C163.524 43.2891 163.527 43.4601 163.706 43.6502C163.877 43.8479 164.241 43.9734 164.689 43.9391L164.898 43.9239L164.773 44.0988C164.579 44.3649 164.408 44.7033 164.313 45.0796C164.306 45.1062 164.302 45.129 164.294 45.1519L164.268 45.2697L164.158 45.2355C163.941 45.1633 163.812 45.0112 163.687 44.9047C163.565 44.7907 163.448 44.7147 163.334 44.7223C163.22 44.7299 163.117 44.8173 163.064 44.9162C163.011 45.015 163.003 45.1366 163.019 45.2393C163.053 45.4522 163.159 45.6119 163.227 45.7221C163.296 45.8323 163.334 45.897 163.322 45.9084C163.311 45.916 163.254 45.8704 163.159 45.7753C163.072 45.6765 162.931 45.5244 162.867 45.2697C162.836 45.1443 162.829 44.9884 162.901 44.8363C162.969 44.6881 163.11 44.5474 163.315 44.5208C163.524 44.498 163.702 44.6272 163.827 44.7413C163.96 44.8591 164.078 44.9808 164.215 45.0188L164.078 45.0986C164.086 45.072 164.089 45.0454 164.097 45.0188C164.199 44.6082 164.393 44.2509 164.61 43.9696L164.693 44.1292C164.454 44.1292 164.226 44.1026 164.036 44.0304C163.846 43.9581 163.698 43.8365 163.611 43.7186C163.432 43.4715 163.478 43.2739 163.497 43.2815V43.2929Z",
    fill: "#95C9C3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M162.282 45.1784C162.248 45.1251 162.688 44.8134 163.083 44.3002C163.288 44.0455 163.425 43.7984 163.44 43.6007C163.467 43.403 163.406 43.2814 163.433 43.2623C163.452 43.2433 163.581 43.3536 163.596 43.6045C163.619 43.8554 163.467 44.1709 163.258 44.4332C162.833 44.9883 162.309 45.2278 162.282 45.1784Z",
    fill: "#95C9C3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6327 96.8386C57.6327 96.8386 59.8767 92.9039 56.5202 91.2616C53.1638 89.6193 51.2578 92.3488 51.2578 92.3488L50.0693 91.2312C50.0693 91.2312 53.1524 87.6044 57.4543 90.5963C61.7561 93.5844 58.7414 97.9562 58.7414 97.9562L57.6289 96.8386H57.6327Z",
    fill: "#33A68F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8083 86.175L31.4229 103.575L54.7129 119.515L66.6844 102.146L43.8083 86.175Z",
    fill: "#30CFB0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0541 104.871C55.8709 106.4 53.2397 107.202 50.5895 107.468C48.6796 107.658 46.6103 107.441 45.1257 106.228C43.831 105.168 43.1817 103.507 42.8021 101.876C42.0351 98.5835 42.1604 95.086 43.1628 91.8584C43.1628 91.8584 42.4869 100.154 47.533 103.552C51.9601 106.533 58.0541 104.871 58.0541 104.871Z",
    fill: "#28BFA1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6845 102.146C66.6845 102.146 66.6541 102.165 66.5934 102.188C66.5212 102.214 66.4301 102.252 66.32 102.294C66.0618 102.389 65.7087 102.518 65.2645 102.682C64.3456 103.012 63.0205 103.503 61.3575 104.039C59.6944 104.56 57.6897 105.187 55.3736 105.407C54.2193 105.514 52.9892 105.518 51.7362 105.32C50.487 105.134 49.2113 104.719 48.0532 104.028C46.8952 103.328 45.9498 102.366 45.2397 101.317C44.5259 100.264 44.0323 99.131 43.6906 98.0209C43.0186 95.7818 42.992 93.6529 43.0793 91.9118C43.1818 90.163 43.3983 88.7602 43.5501 87.7946C43.6299 87.327 43.6906 86.9583 43.7362 86.6845C43.759 86.5705 43.7779 86.4755 43.7931 86.3956C43.8083 86.331 43.8159 86.2968 43.8197 86.3006C43.8235 86.3006 43.8197 86.3348 43.8159 86.3994C43.8083 86.4792 43.7969 86.5743 43.7817 86.6921C43.7476 86.9659 43.6982 87.3384 43.6375 87.806C43.5122 88.7754 43.3185 90.1782 43.2388 91.9194C43.1666 93.6529 43.216 95.759 43.888 97.9601C44.2298 99.055 44.7196 100.165 45.422 101.195C46.1206 102.222 47.0433 103.157 48.1709 103.837C49.2986 104.514 50.544 104.917 51.7742 105.107C53.0043 105.305 54.2156 105.305 55.3584 105.206C57.6479 105.005 59.6489 104.392 61.3157 103.894C62.9825 103.377 64.3152 102.91 65.2417 102.606C65.6935 102.457 66.0466 102.343 66.3124 102.256C66.4263 102.222 66.5174 102.195 66.5934 102.172C66.6579 102.153 66.6883 102.146 66.6921 102.15L66.6845 102.146Z",
    fill: "#09363F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5236 117.333C51.4818 117.291 54.7168 113.919 58.7528 109.802C62.7889 105.685 66.096 102.381 66.1416 102.423C66.1833 102.465 62.9484 105.837 58.9123 109.954C54.8762 114.071 51.5692 117.375 51.5274 117.333H51.5236Z",
    fill: "#09363F"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4907 102.21C66.4907 102.21 66.4565 102.279 66.3806 102.393C66.2857 102.53 66.168 102.693 66.0275 102.891C65.7161 103.324 65.2567 103.936 64.6796 104.693C63.5254 106.202 61.8927 108.255 60.0664 110.505C58.2553 112.748 56.615 114.775 55.4038 116.276C54.8267 116.998 54.3521 117.592 54.0028 118.033C53.8471 118.223 53.7218 118.378 53.6155 118.508C53.5244 118.614 53.475 118.667 53.4674 118.664C53.4598 118.66 53.5016 118.595 53.5775 118.481C53.6725 118.348 53.7902 118.181 53.9306 117.983C54.242 117.55 54.7014 116.938 55.2785 116.181C56.4328 114.672 58.0654 112.619 59.8955 110.368C61.7067 108.129 63.3469 106.099 64.5581 104.601C65.1352 103.879 65.6098 103.286 65.9592 102.845C66.1148 102.655 66.2401 102.499 66.3464 102.37C66.4376 102.263 66.4869 102.21 66.4945 102.214L66.4907 102.21Z",
    fill: "#09363F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6844 102.146C66.6844 102.146 66.597 102.104 66.4414 102.001C66.2667 101.887 66.0427 101.739 65.7655 101.556C65.1618 101.146 64.3227 100.579 63.3013 99.8798C61.2131 98.4352 58.3616 96.4659 55.214 94.2876C52.0778 92.0903 49.2415 90.0982 47.1646 88.6422C46.1584 87.9237 45.3345 87.3345 44.7384 86.9087C44.4688 86.711 44.2524 86.5513 44.0853 86.4297C43.9373 86.3194 43.8613 86.2548 43.8651 86.251C43.8689 86.2434 43.9525 86.2928 44.1081 86.3955C44.2828 86.5095 44.5068 86.6578 44.784 86.8403C45.3877 87.2508 46.2268 87.8173 47.2481 88.513C49.3364 89.9576 52.1879 91.9306 55.3355 94.1089C58.4679 96.3063 61.3042 98.2945 63.3849 99.7543C64.391 100.473 65.215 101.062 65.8111 101.488C66.0806 101.686 66.2971 101.845 66.4641 101.967C66.6122 102.077 66.6881 102.142 66.6844 102.146Z",
    fill: "#09363F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2716 83.7268C60.2716 83.7268 55.9128 86.9962 55.4154 87.6387C54.9142 88.2811 53.5207 88.9236 54.132 89.6877C54.132 89.6877 53.6536 90.1325 54.3674 90.8738C54.3674 90.8738 53.7751 91.771 54.9294 92.3945C54.9294 92.3945 55.1951 93.6148 56.0532 93.6452C56.0532 93.6452 56.6949 94.7439 57.5378 94.3029C58.3807 93.8657 59.497 93.0256 59.497 93.0256L59.797 93.9189C59.797 93.9189 60.6551 93.4095 61.0196 92.4591C61.3841 91.5087 61.0196 89.76 61.9422 88.8704C62.7547 88.0834 62.9749 87.9846 62.9749 87.9846L60.2716 83.7306V83.7268Z",
    fill: "#CCEDE8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1762 103.173L47.467 102.723L46.6287 104.05L47.3378 104.499L48.1762 103.173Z",
    fill: "#09363F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3703 80.651L60.1235 85.3727L65.7239 81.3049L66.0315 76.6479L60.3703 80.651Z",
    fill: "#375A64"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M156.352 45.8093L158.425 44.6194L160.114 49.4056L157.756 51.4319L156.352 45.8093Z",
    fill: "#FAFAFA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M156.351 45.8093C156.351 45.8093 156.412 45.9652 156.488 46.2427C156.572 46.5506 156.682 46.9422 156.811 47.4136C157.08 48.4096 157.449 49.7972 157.855 51.4053L157.684 51.3521C158.25 50.8655 158.861 50.337 159.495 49.7896C159.678 49.6337 159.86 49.4779 160.038 49.322L160.008 49.4437C159.351 47.5771 158.77 45.9006 158.349 44.646L158.463 44.6878C157.847 45.0224 157.335 45.2999 156.944 45.5128C156.575 45.7067 156.367 45.8131 156.351 45.8093C156.336 45.8017 156.522 45.6839 156.872 45.4672C157.221 45.2505 157.737 44.935 158.387 44.551L158.466 44.5054L158.5 44.5928C158.956 45.8359 159.56 47.5048 160.22 49.3676L160.247 49.4399L160.19 49.4893C160.012 49.6413 159.829 49.7972 159.647 49.9569C159.009 50.5005 158.398 51.0251 157.828 51.5117L157.699 51.622L157.658 51.4547C157.251 49.8048 156.917 48.383 156.686 47.3832C156.579 46.9156 156.492 46.524 156.424 46.2161C156.367 45.9462 156.34 45.8055 156.351 45.8093Z",
    fill: "#09363F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2769 82.1641C59.2769 82.1641 57.2228 83.8976 57.1848 83.909L61.7373 89.1704L62.9713 87.9805L59.2769 82.1641Z",
    fill: "#FAFAFA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2768 82.1642C59.2768 82.1642 59.3793 82.2934 59.5615 82.5671C59.7666 82.8751 60.0286 83.2704 60.3513 83.7532C61.0271 84.7759 61.9802 86.2319 63.0623 87.9236L63.1078 87.9958L63.0433 88.0567C62.6446 88.4406 62.2345 88.8398 61.8093 89.2504L61.7258 89.3302L61.6498 89.2428C61.5397 89.1135 61.4182 88.9766 61.2967 88.836C59.6603 86.9428 58.1833 85.2207 57.1202 83.9585L57.0708 83.9015L57.1581 83.8331C57.7808 83.3313 58.2972 82.9169 58.6845 82.6013C59.0528 82.3086 59.2616 82.1528 59.273 82.1642C59.2844 82.1756 59.0945 82.3542 58.7414 82.6698C58.5554 82.8332 58.339 83.0233 58.096 83.2362C57.9669 83.3465 57.834 83.4643 57.6897 83.586C57.6176 83.6468 57.5416 83.7114 57.4657 83.776L57.348 83.8749L57.2872 83.9243L57.2568 83.9509C57.2568 83.9509 57.2189 83.9775 57.1961 83.9889L57.2341 83.8635C58.3276 85.0952 59.8197 86.8021 61.46 88.6991C61.5815 88.8398 61.6992 88.9767 61.8131 89.1059L61.6536 89.0983C62.0789 88.6915 62.4927 88.2924 62.8914 87.9084L62.8762 88.0414C61.8321 86.3839 60.936 84.9355 60.2943 83.8825C59.9868 83.3769 59.7362 82.9625 59.5388 82.6394C59.3641 82.3428 59.2654 82.1794 59.2692 82.1642H59.2768Z",
    fill: "#09363F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4919 95.12C97.8266 97.2299 102.857 101.549 105.17 106.783C107.778 104.677 108.446 101.187 108.686 97.9028C108.925 94.6144 108.226 91.3754 107.493 88.2011C107.311 87.4103 107.11 86.5892 106.582 85.9809C105.572 84.8252 103.719 84.848 102.216 85.3575C99.9452 86.1292 98.0164 87.7677 96.5166 89.6647C95.0169 91.5579 93.8968 93.7096 92.7881 95.8499",
    fill: "#375A64"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M118.295 61.3464C118.295 61.3464 119.199 59.2784 120.198 59.6775C121.101 60.0387 121.773 60.6508 121.773 60.6508L156.268 45.1858L158.474 51.8082L140.997 61.9889L120.927 70.8315C120.927 70.8315 118.736 72.6677 118.015 73.8005C117.293 74.9334 112.209 86.4865 111.465 88.7219C110.721 90.9572 109.274 100.362 107.615 104.426C105.959 108.494 105.17 106.776 105.17 106.776L105.675 93.1621L105.804 87.053L105.435 85.5627L107.391 82.6773C107.391 82.6773 113.641 74.7547 114.332 72.987C115.023 71.2192 116.2 69.4515 116.754 68.0715C117.282 66.7523 117.027 63.7339 117.027 63.7339L118.295 61.3388V61.3464Z",
    fill: "#09363F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_35_83672",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 45,
    width: 54,
    height: 63
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M118.295 61.3464C118.295 61.3464 119.199 59.2784 120.198 59.6775C121.101 60.0387 121.773 60.6508 121.773 60.6508L156.268 45.1858L158.474 51.8082L140.997 61.9889L120.927 70.8315C120.927 70.8315 118.736 72.6677 118.015 73.8005C117.293 74.9334 112.209 86.4865 111.465 88.7219C110.721 90.9572 109.274 100.362 107.615 104.426C105.959 108.494 105.17 106.776 105.17 106.776L105.675 93.1621L105.804 87.053L105.435 85.5627L107.391 82.6773C107.391 82.6773 113.641 74.7547 114.332 72.987C115.023 71.2192 116.2 69.4515 116.754 68.0715C117.282 66.7523 117.027 63.7339 117.027 63.7339L118.295 61.3388V61.3464Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_35_83672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.856 44.8817L159.799 41.658L160.426 42.0077H160.429L160.486 45.2315L158.952 46.1553L158.318 45.8055L159.856 44.8817Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.078 41.3691L156.135 44.5929L157.384 45.2848L157.441 48.5124L158.06 48.1398L158.011 45.2772L158.003 44.9122L156.754 44.2204L156.697 40.9966L156.078 41.3691Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.135 44.5928L157.384 45.2885",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.282 44.6232L154.339 47.8469L153.709 47.501V47.4972L153.652 44.2734L155.186 43.3496L155.816 43.6994L154.282 44.6232Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.204 48.5236L156.147 45.2998L156.777 45.6496L156.834 48.8771L155.3 49.7971L154.666 49.4474L156.204 48.5236Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.528 44.9576L155.585 48.1814L155.273 48.3676L154.962 48.1928H154.958L154.901 44.9652L155.213 44.7827L155.516 44.95L155.528 44.9576Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.804 40.9243L152.369 41.7949L152.425 45.0187L152.482 48.2348L154.047 49.1054L154.669 48.7328L153.101 47.8623L153.044 44.6385L152.987 41.4223L151.423 40.5518H151.419V40.5556L150.804 40.9243Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.188 45.0338L151.131 41.8101L151.761 42.156V42.1598L151.818 45.3836L150.284 46.3074L149.654 45.9576L151.188 45.0338Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.41 41.5212L147.467 44.7412L148.72 45.4369L148.773 48.6607L149.392 48.2919L149.343 45.4293L149.335 45.0643L148.086 44.3724L148.029 41.1487L147.41 41.5212Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.467 44.7412V44.745L148.72 45.4407",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.086 44.3723L149.335 45.0642",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.614 44.7753L145.671 47.999L145.045 47.6493H145.041L144.984 44.4255L146.518 43.5017L147.152 43.8515L145.614 44.7753Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.535 48.6757L147.478 45.4519L148.109 45.8017H148.113L148.169 49.0254L146.632 49.9492L146.001 49.5995L147.535 48.6757Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86 45.106L146.916 48.3336L146.609 48.5199L146.294 48.345H146.29L146.237 45.1174L146.544 44.9312L146.848 45.1022L146.86 45.106Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.136 41.0764L143.704 41.947L143.814 48.3869L145.383 49.2575L146.001 48.8849L144.433 48.0144L144.319 41.5744L142.755 40.7039L142.751 40.7077L142.136 41.0764Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.52 45.1861L142.463 41.9585L143.093 42.3082L143.097 42.312L143.154 45.5358L141.616 46.4596L140.986 46.1099L142.52 45.1861Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.746 41.6732L138.803 44.8932L140.052 45.5889L140.109 48.8127L140.728 48.4401L140.674 45.5775L140.671 45.2163L139.418 44.5244L139.364 41.2969L138.746 41.6732Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.802 44.8933V44.8971L140.052 45.5928",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.844 41.6163L141.901 44.84L141.593 45.0263L141.278 44.8553L141.274 44.8515L141.221 41.6277L141.529 41.4414L141.832 41.6087L141.844 41.6163Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.417 44.5244L140.67 45.2163",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.95 44.9273L137.006 48.1511L136.376 47.8014H136.372L136.315 44.5776L137.853 43.6538L138.483 44.0036L136.95 44.9273Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.867 48.8278L138.814 45.604L139.44 45.9499L139.444 45.9538L139.501 49.1775L137.963 50.1013L137.333 49.7516L138.867 48.8278Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.195 45.2581L138.248 48.4857L137.94 48.672L137.625 48.4971L137.568 45.2695L137.876 45.0833L138.183 45.2543L138.195 45.2581Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.468 41.2283L135.036 42.0988L135.093 45.3226V45.3188L135.15 48.5388L136.714 49.4093L137.333 49.0368L135.765 48.1662L135.712 44.9386L135.655 41.7263L134.087 40.8557H134.083L133.468 41.2283Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.855 45.3379L133.798 42.1104L134.425 42.4601H134.428L134.485 45.6877L132.948 46.6115L132.317 46.2617L133.855 45.3379Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.077 41.8213L130.134 45.0451L131.383 45.7408L131.44 48.9645L132.059 48.592L132.006 45.7293L132.002 45.3682L130.749 44.6763L130.696 41.4487L130.077 41.8213Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.134 45.0452L131.383 45.7447",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.179 41.7681L133.232 44.9919L132.925 45.1782L132.613 45.0071L132.61 45.0033L132.553 41.7795L132.86 41.5933L133.168 41.7605L133.179 41.7681Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.749 44.6726L132.002 45.3683",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.281 45.0795L128.338 48.3032L127.708 47.9535H127.704L127.651 44.7297L129.185 43.8059L129.815 44.1557L128.281 45.0795Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.203 48.9799L130.146 45.7561L130.772 46.1021L130.776 46.1059L130.833 49.3296L129.299 50.2534L128.665 49.9037L130.203 48.9799Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.527 45.4102L129.584 48.634L129.272 48.8241L128.961 48.6492L128.957 48.6454L128.9 45.4216L129.212 45.2354L129.515 45.4064L129.527 45.4102Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.803 41.3806L126.368 42.2474L126.481 48.6911L128.046 49.5617L128.668 49.1853L127.1 48.3186L127.043 45.091L126.986 41.8786L125.422 41.0081H125.418L124.803 41.3806Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.187 45.4862L125.13 42.2625L125.76 42.6122L125.817 45.8398L124.283 46.7598L123.649 46.41L125.187 45.4862Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.409 41.9736L121.466 45.1974L122.715 45.8893L122.772 49.1169L123.391 48.7443L123.342 45.8817L123.334 45.5205L122.085 44.8248L122.028 41.6011L121.409 41.9736Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.466 45.1973L122.715 45.893",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.511 41.9202L124.568 45.144L124.257 45.3303L123.945 45.1554H123.941L123.885 41.9316L124.196 41.7454L124.5 41.9126L124.511 41.9202Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.085 44.8247L123.334 45.5204",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.613 45.2315L119.67 48.4553L119.044 48.1056H119.04L118.983 44.878L120.517 43.958L121.147 44.3078L119.613 45.2315Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.534 49.1321L121.477 45.9045L122.108 46.2543L122.112 46.2581L122.165 49.4819L120.631 50.4057L120 50.0559L121.534 49.1321Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.859 45.5623L120.916 48.7861L120.604 48.9724L120.293 48.8013L120.289 48.7975L120.232 45.5737L120.544 45.3875L120.847 45.5547L120.859 45.5623Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.135 41.5326L117.7 42.3994L117.757 45.6231L117.813 48.8393L119.382 49.7099L120 49.3373L118.432 48.4706L118.375 45.243L118.318 42.0268L116.754 41.1562V41.1601H116.75L116.135 41.5326Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.597 41.7379L114.654 44.9617L114.028 44.6157L114.024 44.6119L113.967 41.3881L115.501 40.4644L116.131 40.8141L114.597 41.7379Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.519 45.6383L116.462 42.4146L117.092 42.7643H117.096L117.149 45.9881L115.615 46.9119L114.985 46.5621L116.519 45.6383Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.741 42.1257L112.798 45.3495L114.051 46.0414L114.108 49.269L114.723 48.8964L114.673 46.0338L114.666 45.6688L113.417 44.9769L113.36 41.7532L112.741 42.1257Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.798 45.3494L114.051 46.0451",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.843 42.0723L115.9 45.2961L115.588 45.4824L115.277 45.3075H115.273L115.216 42.0799L115.528 41.8975L115.831 42.0647L115.843 42.0723Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.417 44.9768L114.666 45.6687",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.949 45.3798L111.002 48.6074L110.375 48.2577L110.371 48.2539L110.314 45.0301L111.852 44.1101L112.482 44.4599L110.949 45.3798Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.866 49.2842L112.813 46.0566L113.439 46.4064H113.443L113.5 49.634L111.962 50.5578L111.332 50.208L112.866 49.2842Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.19 45.7144L112.247 48.9382L111.939 49.1245L111.624 48.9496H111.621L111.567 45.7258L111.875 45.5396L112.179 45.7068L112.19 45.7144Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.467 41.6807L109.035 42.5512L109.145 48.9912L110.713 49.8617L111.332 49.4892L109.764 48.6186L109.711 45.3948L109.654 42.1787L108.086 41.3081V41.3119H108.082L107.467 41.6807Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.933 41.8898L105.99 45.1135L105.36 44.7638H105.356L105.299 41.54L106.837 40.6162L107.467 40.966L105.933 41.8898Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.85 45.7902L107.797 42.5664L108.424 42.9162H108.427L108.484 46.1399L106.947 47.0637L106.316 46.714L107.85 45.7902Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.076 42.2776L104.133 45.5014L105.382 46.1932L105.439 49.4208L106.058 49.0483L106.005 46.1856L106.001 45.8207L104.748 45.1288L104.695 41.905L104.076 42.2776Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.133 45.5012L105.382 46.1969",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.174 42.2205L107.231 45.4481L106.924 45.6344L106.609 45.4595L106.552 42.2319L106.859 42.0457L107.163 42.2167L107.174 42.2205Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.748 45.1289L106.001 45.8208",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.083 49.5768L158.14 52.8005L157.513 52.4508H157.51L157.453 49.227L158.987 48.3032L159.621 48.653L158.083 49.5768Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.004 53.4772L159.947 50.2534L160.577 50.5994L160.581 50.6032L160.634 53.8269L159.1 54.7507L158.47 54.401L160.004 53.4772Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.23 49.9646L156.283 53.1884L157.536 53.8803L157.593 57.104L158.212 56.7353L158.159 53.8689L158.155 53.5077L156.902 52.8158L156.845 49.592L156.23 49.9646Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.283 53.1882L157.536 53.8839",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.902 52.8157L158.155 53.5076",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.434 53.2186L154.487 56.4424L153.861 56.0964L153.857 56.0926L153.8 52.8689L155.338 51.9451L155.968 52.2948L154.434 53.2186Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.352 57.119L156.298 53.8953L156.925 54.245H156.929L156.986 57.4688L155.448 58.3926L154.818 58.0428L156.352 57.119Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.676 53.5532L155.733 56.777L155.425 56.9632L155.11 56.7884L155.053 53.5608L155.361 53.3745L155.664 53.5456L155.676 53.5532Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.952 49.5198L152.521 50.3903L152.577 53.6141L152.634 56.8303L154.199 57.7008L154.818 57.3283L153.249 56.4577L153.196 53.234L153.139 50.0178L151.571 49.1472L151.567 49.151L150.952 49.5198Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.419 49.7289L149.475 52.9526L148.845 52.6029H148.841L148.784 49.3753L150.322 48.4553L150.952 48.8051L149.419 49.7289Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.336 53.6294L151.283 50.4019L151.909 50.7516L151.913 50.7554L151.97 53.9792L150.432 54.903L149.802 54.5532L151.336 53.6294Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.562 50.1166L147.619 53.3366L148.868 54.0323L148.925 57.256L149.544 56.8835L149.491 54.0247L149.487 53.6597L148.234 52.9678L148.181 49.7402L147.562 50.1166Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.619 53.3367V53.3405L148.868 54.0362",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.664 50.0596L150.717 53.2834L150.409 53.4697L150.094 53.2986V53.2948L150.037 50.071L150.345 49.8848L150.652 50.052L150.664 50.0596Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.234 52.9678L149.487 53.6597",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.766 53.3707L145.823 56.5945L145.192 56.2447H145.189L145.135 53.021L146.669 52.0972L147.3 52.4469L145.766 53.3707Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.687 57.2711L147.63 54.0474L148.256 54.3971H148.26L148.317 57.6209L146.783 58.5447L146.149 58.1949L147.687 57.2711Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.011 53.7015L147.068 56.9291L146.757 57.1153L146.446 56.9405H146.442L146.385 53.7129L146.696 53.5266L147 53.6977L147.011 53.7015Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.284 49.6719L143.852 50.5424L143.966 56.9824L145.531 57.8529L146.149 57.4804L144.585 56.6098L144.471 50.1699L142.903 49.2993L142.284 49.6719Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.75 49.881L140.807 53.1047L140.177 52.755H140.173L140.12 49.5274L141.654 48.6074L142.284 48.9572L140.75 49.881Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.672 53.7815L142.615 50.554L143.241 50.9037L143.245 50.9075L143.302 54.1313L141.768 55.0551L141.134 54.7053L142.672 53.7815Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.894 50.2649L138.951 53.4887L140.2 54.1844L140.257 57.4081L140.876 57.0356L140.826 54.1729L140.819 53.8118L139.569 53.1199L139.512 49.8923L138.894 50.2649Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.95 53.4888V53.4926L140.2 54.1883",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.996 50.2117L142.053 53.4355L141.741 53.6218L141.43 53.4507L141.426 53.4469L141.369 50.2231L141.68 50.0369L141.984 50.2041L141.996 50.2117Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.569 53.116L140.819 53.8117",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.098 53.5228L137.155 56.7466L136.528 56.3968H136.524L136.467 53.1731L138.001 52.2493L138.631 52.599L137.098 53.5228Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.019 57.4232L138.962 54.1995L139.592 54.5454V54.5492L139.649 57.773L138.115 58.6968L137.485 58.347L139.019 57.4232Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.343 53.8536L138.4 57.0812L138.089 57.2674L137.777 57.0926L137.774 57.0888L137.717 53.865L138.028 53.6787L138.332 53.8498L138.343 53.8536Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.619 49.824L135.184 50.6907L135.241 53.9183V53.9145L135.298 57.1345L136.866 58.005L137.485 57.6287L135.916 56.7619L135.86 53.5344L135.803 50.322L134.238 49.4514H134.234L133.619 49.824Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.082 50.0292L132.139 53.2567L131.512 52.907L131.508 52.9032L131.451 49.6794L132.985 48.7556L133.616 49.1092L132.082 50.0292Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.003 53.9296L133.946 50.7058L134.576 51.0556H134.58L134.633 54.2831L133.099 55.2069L132.469 54.8572L134.003 53.9296Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.225 50.417L130.282 53.6408L131.535 54.3365L131.592 57.5602L132.207 57.1877L132.158 54.325L132.15 53.9639L130.901 53.272L130.844 50.0444L130.225 50.417Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.282 53.6406L131.535 54.3363",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.327 50.3636L133.384 53.5874L133.073 53.7736L132.761 53.5988H132.758L132.701 50.375L133.012 50.1887L133.316 50.356L133.327 50.3636Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.901 53.2681L132.15 53.9638",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.433 53.6749L128.486 56.8987L127.86 56.5489H127.856L127.799 53.3214L129.337 52.4014L129.967 52.7511L128.433 53.6749Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.351 57.5755L130.294 54.3479L130.924 54.6976L130.928 54.7014L130.985 57.9252L129.447 58.849L128.817 58.4993L130.351 57.5755Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.675 54.0057L129.732 57.2294L129.424 57.4157L129.109 57.2447L129.105 57.2409L129.052 54.0171L129.36 53.8308L129.663 53.9981L129.675 54.0057Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.951 49.9761L126.52 50.8428L126.63 57.2828L128.198 58.1533L128.817 57.7808L127.249 56.914L127.195 53.6865L127.138 50.4703L125.57 49.6035H125.567L124.951 49.9761Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.418 50.1813L123.471 53.405L122.844 53.0591L122.84 53.0553L122.783 49.8315L124.321 48.9077L124.951 49.2575L123.418 50.1813Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.335 54.0817L125.278 50.8579L125.908 51.2077H125.912L125.969 54.4352L124.431 55.3552L123.801 55.0055L125.335 54.0817Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.561 50.5691L121.618 53.7929L122.867 54.4848L122.924 57.7123L123.543 57.3398L123.49 54.4772L123.486 54.116L122.233 53.4203L122.18 50.1965L121.561 50.5691Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.618 53.7927L122.867 54.4884",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.659 50.5157L124.716 53.7395L124.408 53.9257L124.093 53.7509H124.09L124.036 50.5233L124.344 50.3408L124.648 50.5081L124.659 50.5157Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.233 53.4202L123.486 54.1159",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.765 53.8232L119.822 57.0508L119.192 56.701L119.188 56.6972L119.131 53.4735L120.669 52.5535L121.299 52.9032L119.765 53.8232Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.686 57.7276L121.629 54.5L122.256 54.8497L122.259 54.8535L122.316 58.0773L120.779 59.0011L120.148 58.6514L121.686 57.7276Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.01 54.1578L121.063 57.3816L120.756 57.5678L120.445 57.3968L120.441 57.393L120.384 54.1692L120.691 53.9829L120.999 54.1502L121.01 54.1578Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.283 50.1243L117.851 50.9948L117.908 54.2186L117.965 57.4348L119.53 58.3053L120.148 57.9328L118.584 57.0622L118.527 53.8384L118.47 50.6223L116.902 49.7517V49.7555H116.898L116.283 50.1243Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.749 50.3334L114.806 53.5571L114.176 53.2074H114.172L114.115 49.9836L115.653 49.0598L116.283 49.4096L114.749 50.3334Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.671 54.2338L116.614 51.01L117.24 51.3598H117.244L117.301 54.5835L115.763 55.5073L115.133 55.1576L116.671 54.2338Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.893 50.7212L112.95 53.9412L114.199 54.6369L114.256 57.8644L114.875 57.4919L114.821 54.6292L114.818 54.2643L113.568 53.5724L113.511 50.3486L112.893 50.7212Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.949 53.9412V53.945L114.199 54.6407",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.995 50.6641L116.048 53.8917L115.74 54.078L115.429 53.9031H115.425L115.368 50.6755L115.676 50.4893L115.983 50.6603L115.995 50.6641Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.568 53.5723L114.818 54.2642",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.097 53.9752L111.154 57.2028L110.523 56.853L110.519 56.8492L110.466 53.6254L112 52.7017L112.631 53.0552L111.097 53.9752Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.018 57.8756L112.961 54.6519L113.587 55.0016H113.591L113.648 58.2292L112.114 59.1492L111.48 58.7994L113.018 57.8756Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.342 54.3096L112.399 57.5334L112.088 57.7197L111.776 57.5448H111.773L111.716 54.321L112.027 54.1348L112.331 54.302L112.342 54.3096Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.619 50.2761L109.183 51.1467L109.297 57.5866L110.861 58.4572L111.484 58.0846L109.916 57.2141L109.859 53.9903L109.802 50.7741L108.238 49.9036L108.234 49.9074L107.619 50.2761Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.081 50.4852L106.138 53.709L105.507 53.3592L105.45 50.1355L106.984 49.2117L107.615 49.5614L106.081 50.4852Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.002 54.3856L107.945 51.1619L108.575 51.5078V51.5116L108.632 54.7354L107.098 55.6592L106.464 55.3094L108.002 54.3856Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.224 50.8731L104.281 54.0968L105.53 54.7887L105.587 58.0125L106.206 57.6437L106.157 54.7773L106.149 54.4162L104.9 53.7243L104.843 50.5005L104.224 50.8731Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.281 54.0967L105.53 54.7924",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.326 50.816L107.383 54.0436L107.072 54.2298L106.76 54.055H106.757L106.7 50.8274L107.011 50.6411L107.315 50.8122L107.326 50.816Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.9 53.7244L106.149 54.4163",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.235 58.172L158.292 61.3957L157.661 61.046H157.658L157.604 57.8222L159.138 56.8984L159.769 57.2482L158.235 58.172Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.156 62.0724L160.099 58.8486L160.726 59.1946L160.729 59.1984L160.786 62.4221L159.252 63.3459L158.618 62.9962L160.156 62.0724Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.378 58.5597L156.435 61.7797L157.684 62.4754L157.741 65.6991L158.36 65.3266L158.311 62.464L158.303 62.1028L157.054 61.4109L156.997 58.1833L156.378 58.5597Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.435 61.7798V61.7836L157.684 62.4793",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.054 61.4111L158.303 62.103",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.582 61.8141L154.639 65.0378L154.009 64.6881L153.952 61.4643L155.486 60.5405L156.116 60.8903L154.582 61.8141Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.503 65.7145L156.446 62.4907L157.077 62.8405L157.134 66.0642L155.6 66.988L154.966 66.6383L156.503 65.7145Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.828 62.1448L155.885 65.3724L155.573 65.5587L155.262 65.3838H155.258L155.201 62.1563L155.513 61.97L155.816 62.141L155.828 62.1448Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.104 58.115L152.669 58.9856L152.726 62.2093V62.2055L152.783 65.4255L154.347 66.2961L154.97 65.9235L153.402 65.0529L153.345 61.8292L153.288 58.613L151.723 57.7424H151.72V57.7462L151.104 58.115Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.567 58.3241L149.624 61.5478L148.993 61.1981L148.936 57.9705L150.47 57.0505L151.1 57.4003L149.567 58.3241Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.488 62.2246L151.431 58.9971L152.061 59.3468V59.3506L152.118 62.5744L150.584 63.4982L149.95 63.1484L151.488 62.2246Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.71 58.708L147.767 61.9318L149.02 62.6275L149.073 65.8512L149.692 65.4787L149.643 62.6161L149.635 62.2549L148.386 61.563L148.329 58.3354L147.71 58.708Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.767 61.9319V61.9357L149.02 62.6314",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.812 58.6549L150.869 61.8786L150.558 62.0649L150.246 61.8938L150.243 61.89L150.186 58.6663L150.497 58.48L150.801 58.6473L150.812 58.6549Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.386 61.5593L149.635 62.255",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.914 61.9662L145.971 65.1899L145.344 64.8402H145.341L145.284 61.6164L146.818 60.6926L147.448 61.0424L145.914 61.9662Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.835 65.8666L147.778 62.6428L148.409 62.9888L148.412 62.9926L148.465 66.2163L146.932 67.1401L146.301 66.7904L147.835 65.8666Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.159 62.2969L147.216 65.5245L146.905 65.7108L146.594 65.5359L146.59 65.5321L146.533 62.3083L146.844 62.1221L147.148 62.2931L147.159 62.2969Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.436 58.2671L144.004 59.1377L144.114 65.5776L145.682 66.4482L146.301 66.0718L144.733 65.205L144.619 58.7651L143.055 57.8945H143.051L142.436 58.2671Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.898 58.4724L140.955 61.6999L140.329 61.3502L140.325 61.3464L140.268 58.1226L141.802 57.2026L142.436 57.5524L140.898 58.4724Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.82 62.3767L142.763 59.1492L143.393 59.4989H143.397L143.454 62.7265L141.916 63.6503L141.286 63.3005L142.82 62.3767Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.045 58.8601L139.099 62.0839L140.352 62.7796L140.408 66.0033L141.027 65.6308L140.974 62.7682L140.97 62.407L139.717 61.7151L139.661 58.4875L139.045 58.8601Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.099 62.084L140.352 62.7797",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.144 58.807L142.201 62.0307L141.893 62.217L141.578 62.0421H141.574L141.521 58.8184L141.829 58.6321L142.132 58.7994L142.144 58.807Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.718 61.7114L140.97 62.4071",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.25 62.1183L137.303 65.342L136.676 64.9923H136.672L136.615 61.7647L138.153 60.8447L138.783 61.1945L137.25 62.1183Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.167 66.0187L139.114 62.7949L139.74 63.1409L139.744 63.1447L139.801 66.3684L138.263 67.2922L137.633 66.9425L139.167 66.0187Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.491 62.449L138.548 65.6728L138.241 65.8591L137.925 65.688V65.6842L137.868 62.4605L138.176 62.2742L138.48 62.4414L138.491 62.449Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.768 58.4192L135.336 59.286L135.393 62.5097L135.45 65.7297L137.014 66.5965L137.633 66.2239L136.065 65.3571L136.012 62.1296L135.955 58.9172L134.387 58.0466H134.383L133.768 58.4192Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.234 58.6244L132.291 61.8481L131.661 61.5022L131.657 61.4984L131.6 58.2746L133.138 57.3508L133.768 57.7006L132.234 58.6244Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.151 62.5248L134.098 59.301L134.725 59.6508H134.728L134.785 62.8783L133.248 63.7983L132.617 63.4486L134.151 62.5248Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.377 59.0122L130.434 62.236L131.683 62.9279L131.74 66.1554L132.359 65.7829L132.306 62.9203L132.302 62.5591L131.049 61.8634L130.996 58.6396L130.377 59.0122Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.434 62.2358L131.683 62.9315",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.479 58.9588L133.532 62.1826L133.225 62.3689L132.91 62.194L132.853 58.9702L133.16 58.7839L133.468 58.9512L133.479 58.9588Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.049 61.8633L132.302 62.559",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.581 62.2701L128.638 65.4939L128.008 65.1441H128.004L127.951 61.9166L129.485 60.9966L130.115 61.3463L128.581 62.2701Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.502 66.1707L130.445 62.9431L131.072 63.2929L131.076 63.2967L131.133 66.5204L129.599 67.4442L128.965 67.0945L130.502 66.1707Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.827 62.6009L129.884 65.8247L129.572 66.0109L129.261 65.8399L129.257 65.8361L129.2 62.6123L129.512 62.426L129.815 62.5933L129.827 62.6009Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.104 58.5712L126.668 59.438L126.782 65.8779L128.346 66.7485L128.969 66.3759L127.401 65.5091L127.344 62.2816L127.287 59.0654L125.722 58.1948L125.719 58.1986L125.104 58.5712Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.566 58.7765L123.623 62.0002L122.992 61.6543L122.988 61.6505L122.935 58.4267L124.469 57.5029L125.1 57.8527L123.566 58.7765Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.487 62.6769L125.43 59.4531L126.056 59.8029H126.06L126.117 63.0266L124.583 63.9504L123.949 63.6007L125.487 62.6769Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.709 59.1643L121.766 62.3881L123.015 63.08L123.072 66.3075L123.691 65.935L123.642 63.0724L123.634 62.7074L122.385 62.0155L122.328 58.7917L121.709 59.1643Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.766 62.3879L123.015 63.0836",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.811 59.111L124.868 62.3348L124.557 62.5211L124.245 62.3462H124.242L124.185 59.1186L124.496 58.9324L124.8 59.1034L124.811 59.111Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.385 62.0156L123.634 62.7075",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.913 62.4186L119.97 65.6461L119.343 65.2964L119.34 65.2926L119.283 62.0688L120.817 61.145L121.447 61.4986L119.913 62.4186Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.834 66.3228L121.777 63.0952L122.408 63.445L122.465 66.6725L120.931 67.5963L120.3 67.2466L121.834 66.3228Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.158 62.753L121.215 65.9768L120.904 66.163L120.593 65.9882H120.589L120.532 62.7644L120.843 62.5781L121.147 62.7454L121.158 62.753Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.435 58.7195L117.999 59.5901L118.056 62.8138L118.113 66.03L119.681 66.9006L120.3 66.528L118.732 65.6574L118.675 62.4337L118.618 59.2175L117.054 58.3469L117.05 58.3507L116.435 58.7195Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.897 58.9286L114.954 62.1523L114.328 61.8026H114.324L114.267 58.5788L115.801 57.655L116.431 58.0048L114.897 58.9286Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.819 62.829L116.762 59.6052L117.392 59.955H117.396L117.449 63.1787L115.915 64.1025L115.285 63.7528L116.819 62.829Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.041 59.3164L113.098 62.5364L114.351 63.2321L114.408 66.4596L115.023 66.0871L114.973 63.2245L114.966 62.8595L113.717 62.1676L113.66 58.9438L113.041 59.3164Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.098 62.5364V62.5402L114.351 63.2359",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.143 59.2593L116.2 62.4869L115.888 62.6732L115.577 62.4983H115.573L115.516 59.2708L115.828 59.0845L116.131 59.2555L116.143 59.2593Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.717 62.1677L114.966 62.8596",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.249 62.5707L111.302 65.7944L110.675 65.4485L110.671 65.4447L110.615 62.2209L112.152 61.2971L112.783 61.6469L111.249 62.5707Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.166 66.4711L113.109 63.2473L113.739 63.5971H113.743L113.8 66.8246L112.262 67.7446L111.632 67.3949L113.166 66.4711Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.49 62.9051L112.547 66.1289L112.24 66.3151L111.924 66.1403H111.921L111.867 62.9165L112.175 62.7302L112.479 62.8975L112.49 62.9051Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.767 58.8716L109.335 59.7421L109.445 66.1821L111.013 67.0527L111.632 66.6801L110.064 65.8095L110.011 62.5858L109.954 59.3696L108.386 58.499L108.382 58.5028L107.767 58.8716Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.233 59.0807L106.286 62.3044L105.66 61.9547H105.656L105.599 58.7309L107.137 57.8071L107.767 58.1569L106.233 59.0807Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.15 62.9811L108.097 59.7573L108.724 60.1033L108.728 60.1071L108.784 63.3308L107.247 64.2546L106.616 63.9049L108.15 62.9811Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.376 59.4685L104.433 62.6923L105.682 63.3842L105.739 66.6079L106.358 66.2392L106.305 63.3728L106.301 63.0116L105.048 62.3197L104.995 59.0959L104.376 59.4685Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.433 62.6921L105.682 63.3878",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.474 59.4114L107.531 62.639L107.224 62.8253L106.909 62.6504L106.905 62.6466L106.852 59.4228L107.159 59.2366L107.463 59.4076L107.474 59.4114Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.048 62.3196L106.301 63.0115",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.502 66.6229L104.445 63.3992L105.071 63.7489H105.075L105.132 66.9727L103.594 67.8965L102.964 67.5467L104.502 66.6229Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.383 66.7674L158.44 69.9912L157.813 69.6415H157.81L157.753 66.4139L159.287 65.4939L159.917 65.8436L158.383 66.7674Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.304 70.668L160.247 67.4404L160.878 67.7902L160.881 67.794L160.934 71.0177L159.401 71.9415L158.77 71.5918L160.304 70.668Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.53 67.1552L156.583 70.3751L157.836 71.0708L157.889 74.2946L158.512 73.922L158.459 71.0594L158.451 70.6983L157.202 70.0064L157.145 66.7788L156.53 67.1552Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.583 70.3752V70.379L157.836 71.0747",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.202 70.0066L158.451 70.6985",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.734 70.4095L154.787 73.6333L154.161 73.2835H154.157L154.1 70.0598L155.638 69.136L156.268 69.4857L154.734 70.4095Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.652 74.3099L156.595 71.0862L157.225 71.4359H157.229L157.286 74.6597L155.748 75.5835L155.118 75.2337L156.652 74.3099Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.976 70.7403L156.033 73.9679L155.725 74.1542L155.41 73.9793H155.406L155.353 70.7517L155.661 70.5654L155.964 70.7365L155.976 70.7403Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.252 66.7104L152.821 67.581L152.874 70.8048L152.878 70.801L152.934 74.021L154.499 74.8915L155.118 74.519L153.55 73.6484L153.496 70.4208L153.436 67.2085L151.871 66.3379H151.868L151.252 66.7104Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.719 66.9157L149.772 70.1433L149.145 69.7936L149.141 69.7898L149.084 66.566L150.622 65.646L151.252 65.9957L149.719 66.9157Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.636 70.8201L151.583 67.5925L152.209 67.9423L152.213 67.9461L152.27 71.1698L150.732 72.0936L150.102 71.7439L151.636 70.8201Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.862 67.3035L147.919 70.5272L149.168 71.2229L149.225 74.4467L149.844 74.0741L149.791 71.2115L149.787 70.8504L148.534 70.1585L148.481 66.9309L147.862 67.3035Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.919 70.5273V70.5311L149.168 71.2268",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.96 67.2503L151.017 70.4741L150.709 70.6604L150.394 70.4893V70.4855L150.337 67.2617L150.645 67.0754L150.949 67.2427L150.96 67.2503Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.534 70.1548L149.787 70.8505",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.066 70.5616L146.123 73.7854L145.493 73.4356H145.489L145.432 70.2119L146.97 69.2881L147.6 69.6378L146.066 70.5616Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.987 74.462L147.93 71.2383L148.557 71.5842L148.561 71.588L148.617 74.8118L147.08 75.7356L146.449 75.3858L147.987 74.462Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.311 70.8924L147.364 74.1162L147.057 74.3063L146.746 74.1314L146.742 74.1276L146.685 70.9038L146.992 70.7175L147.3 70.8886L147.311 70.8924Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.584 66.8628L144.152 67.7296L144.266 74.1733L145.831 75.0439L146.449 74.6675L144.881 73.8007L144.771 67.3608L143.203 66.4902L142.584 66.8628Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.05 67.068L141.107 70.2955L140.477 69.9458L140.473 69.942L140.42 66.7182L141.954 65.7944L142.584 66.148L141.05 67.068Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.972 70.9684L142.915 67.7446L143.541 68.0944H143.545L143.602 71.3219L142.068 72.2419L141.434 71.8922L142.972 70.9684Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.194 67.4558L139.251 70.6796L140.5 71.3753L140.557 74.599L141.176 74.2265L141.126 71.3639L141.119 71.0027L139.869 70.3108L139.812 67.0833L139.194 67.4558Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.25 70.6794L140.5 71.3751",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.296 67.4024L142.353 70.6262L142.041 70.8125L141.73 70.6376H141.726L141.669 67.4138L141.981 67.2275L142.284 67.3948L142.296 67.4024Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.869 70.3069L141.119 71.0026",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.398 70.7137L137.455 73.9375L136.824 73.5877L136.767 70.3602L138.301 69.4402L138.932 69.7899L137.398 70.7137Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.319 74.6143L139.262 71.3867L139.892 71.7365V71.7403L139.949 74.964L138.415 75.8878L137.781 75.5381L139.319 74.6143Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.643 71.0445L138.7 74.2683L138.389 74.4546L138.077 74.2835L138.074 74.2797L138.017 71.0559L138.328 70.8696L138.632 71.0369L138.643 71.0445Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.919 67.0145L135.484 67.8813L135.541 71.1051L135.598 74.3212L137.162 75.1918L137.785 74.8193L136.217 73.9525L136.16 70.7249L136.103 67.5088L134.538 66.6382L134.535 66.642L133.919 67.0145Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.382 67.2198L132.439 70.4436L131.812 70.0976L131.808 70.0939L131.751 66.8701L133.285 65.9463L133.916 66.296L132.382 67.2198Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.303 71.1203L134.246 67.8965L134.876 68.2462L134.933 71.4738L133.399 72.3938L132.769 72.044L134.303 71.1203Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.525 67.6077L130.582 70.8314L131.835 71.5233L131.888 74.7509L132.507 74.3783L132.458 71.5157L132.45 71.1546L131.201 70.4589L131.144 67.2351L130.525 67.6077Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.582 70.8313L131.835 71.527",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.627 67.5543L133.684 70.778L133.373 70.9643L133.061 70.7894H133.058L133.001 67.5619L133.312 67.3794L133.616 67.5467L133.627 67.5543Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.201 70.4587L132.45 71.1544",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.729 70.8618L128.786 74.0893L128.16 73.7396L128.156 73.7358L128.099 70.512L129.633 69.592L130.267 69.9418L128.729 70.8618Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.651 74.7661L130.594 71.5386L131.224 71.8883H131.228L131.281 75.1159L129.747 76.0397L129.117 75.6899L130.651 74.7661Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.975 71.1964L130.032 74.4201L129.724 74.6064L129.409 74.4353L129.405 74.4315L129.352 71.2078L129.66 71.0215L129.963 71.1888L129.975 71.1964Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.251 67.1628L126.82 68.0334L126.93 74.4733L128.498 75.3439L129.117 74.9714L127.549 74.1008L127.495 70.877L127.435 67.6608L125.87 66.7903V66.7941H125.867L125.251 67.1628Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.718 67.3719L123.771 70.5957L123.144 70.2459H123.14L123.083 67.0222L124.621 66.0984L125.252 66.4481L123.718 67.3719Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.635 71.2724L125.578 68.0486L126.208 68.3983H126.212L126.269 71.6221L124.731 72.5459L124.101 72.1961L125.635 71.2724Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.861 67.7598L121.914 70.9835L123.167 71.6754L123.224 74.903L123.843 74.5304L123.79 71.6678L123.786 71.3029L122.533 70.611L122.48 67.3872L121.861 67.7598Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.914 70.9834L123.167 71.6791",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.959 67.7027L125.016 70.9303L124.709 71.1166L124.393 70.9417H124.39L124.336 67.7141L124.644 67.5278L124.948 67.6989L124.959 67.7027Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.533 70.6111L123.786 71.303",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.065 71.014L120.122 74.2378L119.491 73.8918L119.488 73.888L119.431 70.6643L120.968 69.7405L121.599 70.0902L120.065 71.014Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.982 74.9144L121.929 71.6907L122.556 72.0404H122.559L122.616 75.268L121.079 76.188L120.448 75.8382L121.982 74.9144Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.31 71.3485L121.363 74.5722L121.056 74.7585L120.741 74.5836L120.684 71.3599L120.991 71.1736L121.299 71.3409L121.31 71.3485Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.583 67.3149L118.151 68.1855L118.208 71.4093L118.265 74.6254L119.83 75.496L120.448 75.1235L118.88 74.2529L118.827 71.0291L118.77 67.813L117.202 66.9424L117.198 66.9462L116.583 67.3149Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.049 67.524L115.106 70.7478L114.476 70.398H114.472L114.415 67.1743L115.953 66.2505L116.583 66.6002L115.049 67.524Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.971 71.4245L116.914 68.2007L117.54 68.5466L117.544 68.5504L117.601 71.7742L116.063 72.698L115.433 72.3482L116.971 71.4245Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.193 67.9119L113.25 71.1318L114.499 71.8275L114.556 75.0513L115.175 74.6825L115.121 71.8199L115.118 71.455L113.865 70.7631L113.812 67.5393L113.193 67.9119Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.25 71.1318V71.1356L114.499 71.8313",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.295 67.8548L116.348 71.0824L116.04 71.2687L115.729 71.0938L115.725 71.09L115.668 67.8662L115.976 67.6799L116.283 67.851L116.295 67.8548Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.865 70.7632L115.117 71.4551",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.397 71.1661L111.454 74.3899L110.823 74.0439L110.82 74.0401L110.766 70.8164L112.3 69.8926L112.931 70.2423L111.397 71.1661Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.318 75.0665L113.261 71.8428L113.887 72.1925H113.891L113.948 75.4163L112.414 76.3401L111.78 75.9903L113.318 75.0665Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.642 71.5006L112.699 74.7243L112.388 74.9106L112.076 74.7357H112.073L112.016 71.5082L112.327 71.3257L112.631 71.493L112.642 71.5006Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.918 67.467L109.483 68.3376L109.597 74.7775L111.161 75.6481L111.784 75.2755L110.216 74.405L110.159 71.1812L110.102 67.965L108.537 67.0945H108.534V67.0983L107.918 67.467Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.381 67.6761L106.438 70.8999L105.807 70.5501H105.804L105.75 67.3226L107.284 66.4026L107.915 66.7523L106.381 67.6761Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.302 71.5765L108.245 68.3528L108.875 68.6987V68.7025L108.932 71.9263L107.398 72.8501L106.764 72.5003L108.302 71.5765Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.524 68.0639L104.581 71.2838L105.83 71.9795L105.887 75.2033L106.506 74.8307L106.457 71.9681L106.449 71.607L105.2 70.9151L105.143 67.6875L104.524 68.0639Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.581 71.2839V71.2877L105.83 71.9796",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.626 68.0069L107.683 71.2307L107.372 71.4208L107.061 71.2459L107.057 71.2421L107 68.0183L107.311 67.832L107.615 67.9993L107.626 68.0069Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.2 70.915L106.449 71.6069",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.65 75.2184L104.593 71.9946L105.223 72.3444H105.227L105.28 75.5681L103.746 76.4919L103.116 76.1422L104.65 75.2184Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.535 75.3629L158.592 78.5867L157.961 78.2369H157.958L157.901 75.0093L159.438 74.0894L160.069 74.4391L158.535 75.3629Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.678 75.7468L156.735 78.9706L157.984 79.6663L158.041 82.8901L158.66 82.5175L158.611 79.6549L158.603 79.2937L157.354 78.6018L157.297 75.3743L156.678 75.7468Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.735 78.9707V78.9745L157.984 79.6702",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.354 78.5981L158.603 79.2938",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.882 79.005L154.939 82.2288L154.309 81.879H154.305L154.252 78.6552L155.786 77.7314L156.416 78.0812L154.882 79.005Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.803 82.9054L156.746 79.6816L157.373 80.0276L157.376 80.0314L157.433 83.2552L155.899 84.1789L155.265 83.8292L156.803 82.9054Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.127 79.3358L156.184 82.5633L155.873 82.7496L155.562 82.5747L155.558 82.5709L155.501 79.3472L155.812 79.1609L156.116 79.332L156.127 79.3358Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.4 75.3062L152.969 76.1729L153.025 79.4005V79.3967L153.082 82.6167L154.647 83.4872L155.266 83.1109L153.701 82.2441L153.644 79.0165L153.587 75.8042L152.023 74.9336H152.019L151.4 75.3062Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.866 75.5113L149.923 78.7389L149.293 78.3892V78.3854L149.236 75.1616L150.77 74.2378L151.4 74.5913L149.866 75.5113Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.788 79.4156L151.731 76.188L152.361 76.5377L152.418 79.7653L150.884 80.6891L150.25 80.3393L151.788 79.4156Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.01 75.8992L148.067 79.1229L149.32 79.8186L149.373 83.0424L149.992 82.6698L149.942 79.8072L149.935 79.4461L148.686 78.7542L148.629 75.5266L148.01 75.8992Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.067 79.1228L149.32 79.8185",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.112 75.8458L151.169 79.0695L150.857 79.2558L150.546 79.0809H150.542L150.485 75.8572L150.797 75.6709L151.1 75.8382L151.112 75.8458Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.686 78.7502L149.935 79.4459",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.214 79.1571L146.271 82.3809L145.644 82.0311H145.64L145.583 78.8035L147.117 77.8835L147.748 78.2333L146.214 79.1571Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.135 83.0576L148.078 79.8301L148.708 80.1798L148.712 80.1836L148.765 83.4074L147.231 84.3312L146.601 83.9814L148.135 83.0576Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.459 79.4879L147.516 82.7116L147.205 82.8979L146.894 82.7268L146.89 82.723L146.833 79.4993L147.144 79.313L147.448 79.4803L147.459 79.4879Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.736 75.4583L144.304 76.325L144.414 82.765L145.978 83.6355H145.982L146.601 83.263L145.033 82.3962L144.919 75.9525L143.355 75.0857H143.351L142.736 75.4583Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.198 75.6634L141.255 78.8872L140.629 78.5413L140.625 78.5375L140.568 75.3137L142.102 74.3899L142.736 74.7396L141.198 75.6634Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.119 79.5639L143.062 76.3401L143.693 76.6898H143.697L143.75 79.9174L142.216 80.8374L141.585 80.4876L143.119 79.5639Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.345 76.0513L139.398 79.275L140.651 79.9669L140.704 83.1945L141.327 82.8219L141.274 79.9593L141.27 79.5982L140.017 78.9025L139.96 75.6787L139.345 76.0513Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.398 79.2749L140.651 79.9706",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.443 75.9979L142.5 79.2216L142.189 79.4079L141.878 79.233H141.874L141.817 76.0093L142.128 75.823L142.432 75.9903L142.443 75.9979Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.017 78.9023L141.267 79.598",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.549 79.3092L137.603 82.533L136.976 82.1832L136.972 82.1794L136.915 78.9556L138.453 78.0356L139.083 78.3854L137.549 79.3092Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.467 83.2097L139.414 79.9822L140.04 80.3319L140.044 80.3357L140.101 83.5595L138.563 84.4833L137.933 84.1335L139.467 83.2097Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.791 79.64L138.848 82.8637L138.54 83.05L138.225 82.8789L138.221 82.8751L138.168 79.6514L138.476 79.4651L138.78 79.6324L138.791 79.64Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.068 75.61L135.636 76.4768L135.689 79.7005H135.693L135.75 82.9167L137.314 83.7873L137.933 83.4147L136.365 82.5479L136.312 79.3204L136.251 76.1042L134.687 75.2336V75.2374H134.683L134.068 75.61Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.534 75.8153L132.591 79.0391L131.96 78.6893H131.957L131.9 75.4655L133.437 74.5417L134.068 74.8915L132.534 75.8153Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.451 79.7157L134.398 76.4919L135.024 76.8417H135.028L135.085 80.0655L133.548 80.9892L132.917 80.6395L134.451 79.7157Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.677 76.2031L130.734 79.4269L131.983 80.1188L132.04 83.3464L132.659 82.9738L132.606 80.1112L132.602 79.7462L131.349 79.0543L131.296 75.8306L130.677 76.2031Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.734 79.4268L131.983 80.1225",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.779 76.1461L133.832 79.3736L133.525 79.5599L133.21 79.385L133.153 76.1575L133.46 75.9712L133.764 76.1423L133.779 76.1461Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.349 79.0544L132.602 79.7463",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.881 79.4574L128.938 82.6849L128.308 82.3352L128.304 82.3314L128.247 79.1076L129.785 78.1838L130.415 78.5374L128.881 79.4574Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.802 83.3578L130.745 80.134L131.372 80.4838H131.376L131.433 83.7114L129.899 84.6351L129.265 84.2854L130.802 83.3578Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.126 79.7918L130.183 83.0156L129.872 83.2019L129.561 83.027H129.557L129.5 79.8032L129.811 79.6169L130.115 79.7842L130.126 79.7918Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.399 75.7583L126.968 76.6289L127.081 83.0688L128.646 83.9394L129.265 83.5668L127.7 82.6962L127.643 79.4725L127.586 76.2563L126.022 75.3857L126.018 75.3895L125.399 75.7583Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.865 75.9674L123.922 79.1912L123.292 78.8414H123.288L123.235 75.6176L124.769 74.6938L125.399 75.0436L123.865 75.9674Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.787 79.8678L125.73 76.644L126.356 76.9938H126.36L126.417 80.2176L124.883 81.1414L124.249 80.7916L125.787 79.8678Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.009 76.3552L122.066 79.579L123.315 80.2709L123.372 83.4985L123.991 83.1259L123.941 80.2633L123.934 79.8983L122.685 79.2064L122.628 75.9827L122.009 76.3552Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.066 79.5789L123.315 80.2746",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.111 76.2982L125.168 79.5257L124.856 79.712L124.545 79.5371H124.541L124.484 76.3096L124.796 76.1233L125.099 76.2944L125.111 76.2982Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.685 79.2065L123.934 79.8984",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.213 79.6095L120.27 82.8332L119.639 82.4873V82.4835L119.583 79.2597L121.116 78.3359L121.747 78.6857L120.213 79.6095Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.134 83.5099L122.077 80.2861L122.707 80.6359L122.764 83.8635L121.23 84.7834L120.596 84.4337L122.134 83.5099Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.458 79.9439L121.515 83.1677L121.204 83.354L120.893 83.1791H120.889L120.832 79.9515L121.143 79.769L121.447 79.9363L121.458 79.9439Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.735 75.9104L118.299 76.781L118.356 80.0047L118.413 83.2209L119.977 84.0915L120.6 83.7189L119.032 82.8483L118.975 79.6246L118.918 76.4084L117.354 75.5378H117.35V75.5416L116.735 75.9104Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.197 76.1195L115.254 79.3433L114.628 78.9935H114.624L114.567 75.7697L116.101 74.8459L116.731 75.1957L115.197 76.1195Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.118 80.0199L117.061 76.7961L117.692 77.1421V77.1459L117.749 80.3697L116.215 81.2935L115.584 80.9437L117.118 80.0199Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.341 76.5073L113.398 79.7273L114.65 80.423L114.704 83.6468L115.323 83.278L115.273 80.4154L115.266 80.0504L114.016 79.3585L113.959 76.1348L113.341 76.5073Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.397 79.7273V79.7311L114.65 80.4268",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.443 76.4503L116.5 79.6778L116.188 79.8641L115.877 79.6892L115.873 79.6854L115.816 76.4617L116.128 76.2754L116.431 76.4465L116.443 76.4503Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.016 79.3586L115.266 80.0505",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.545 79.7616L111.602 82.9853L110.975 82.6356H110.971L110.914 79.4118L112.448 78.488L113.082 78.8378L111.545 79.7616Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.466 83.662L113.409 80.4382L114.039 80.788H114.043L114.096 84.0118L112.562 84.9355L111.932 84.5858L113.466 83.662Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.79 80.0924L112.847 83.3199L112.539 83.5062L112.224 83.3313H112.22L112.167 80.1038L112.475 79.9175L112.779 80.0886L112.79 80.0924Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.067 76.0625L109.635 76.9331L109.745 83.373L111.313 84.2436L111.932 83.871L110.364 83.0004L110.311 79.7767L110.25 76.5605L108.686 75.6899L108.682 75.6937L108.067 76.0625Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.533 76.2716L106.586 79.4954L105.959 79.1456H105.956L105.899 75.918L107.436 74.998L108.067 75.3478L106.533 76.2716Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.45 80.1722L108.393 76.9446L109.024 77.2943L109.027 77.2981L109.084 80.5219L107.547 81.4457L106.916 81.0959L108.45 80.1722Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.676 76.6593L104.733 79.8793L105.982 80.575L106.039 83.7987L106.658 83.4262L106.605 80.5636L106.601 80.2024L105.348 79.5105L105.295 76.283L104.676 76.6593Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.733 79.8794V79.8832L105.982 80.5751",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 76.6024L107.831 79.8261L107.524 80.0124L107.209 79.8413L107.205 79.8375L107.152 76.6138L107.459 76.4275L107.763 76.5948L107.774 76.6024Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.348 79.5105L106.601 80.2024",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.798 83.8139L104.744 80.5901L105.371 80.936L105.375 80.9398L105.432 84.1636L103.894 85.0874L103.264 84.7376L104.798 83.8139Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.683 83.9546L158.74 87.1821L158.113 86.8324L158.11 86.8286L158.053 83.6048L159.587 82.6848L160.217 83.0346L158.683 83.9546Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.83 84.3423L156.883 87.566L158.136 88.2618L158.189 91.4855L158.812 91.113L158.759 88.2503L158.751 87.8892L157.502 87.1973L157.445 83.9697L156.83 84.3423Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.883 87.5662L158.136 88.2657",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.502 87.1936L158.751 87.8893",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.034 87.6004L155.087 90.8242L154.461 90.4745H154.457L154.4 87.2507L155.938 86.3269L156.568 86.6767L155.034 87.6004Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.952 91.5009L156.895 88.2771L157.525 88.623L157.529 88.6269L157.586 91.8506L156.048 92.7744L155.418 92.4247L156.952 91.5009Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.276 87.9312L156.333 91.155L156.025 91.3451L155.71 91.1702L155.706 91.1664L155.653 87.9426L155.961 87.7563L156.264 87.9274L156.276 87.9312Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.552 83.9016L153.121 84.7684L153.174 87.9959L153.178 87.9921L153.231 91.2121L154.799 92.0789L155.418 91.7063L153.85 90.8396L153.793 87.612L153.736 84.3996L152.171 83.5291H152.168L151.552 83.9016Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.019 84.1068L150.072 87.3306L149.445 86.9846L149.441 86.9808L149.385 83.757L150.922 82.8333L151.553 83.183L150.019 84.1068Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.936 88.0072L151.883 84.7834L152.509 85.1332H152.513L152.57 88.3608L151.032 89.2808L150.402 88.931L151.936 88.0072Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.162 84.4946L148.215 87.7184L149.468 88.4103L149.525 91.6379L150.144 91.2653L150.091 88.4027L150.087 88.0415L148.834 87.3458L148.777 84.1221L148.162 84.4946Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.215 87.7183L149.468 88.414",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.26 84.4412L151.317 87.665L151.01 87.8513L150.694 87.6764H150.691L150.637 84.4526L150.945 84.2664L151.249 84.4336L151.26 84.4412Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.834 87.3457L150.087 88.0414",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.366 87.7525L146.423 90.9763L145.793 90.6266H145.789L145.732 87.399L147.27 86.479L147.9 86.8287L146.366 87.7525Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.287 91.6531L148.23 88.4255L148.857 88.7753L148.861 88.7791L148.918 92.0029L147.38 92.9266L146.75 92.5769L148.287 91.6531Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.611 88.0833L147.665 91.3071L147.357 91.4934L147.042 91.3223V91.3185L146.985 88.0947L147.292 87.9084L147.6 88.0757L147.611 88.0833Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.884 84.0536L144.452 84.9204L144.566 91.3603L146.131 92.2309L146.749 91.8583L145.181 90.9916L145.071 84.5478L143.503 83.6772V83.681L142.884 84.0536Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.35 84.2589L141.407 87.4827L140.777 87.1367L140.773 87.1329L140.716 83.9091L142.254 82.9854L142.884 83.3351L141.35 84.2589Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.272 88.1593L143.215 84.9355L143.841 85.2853H143.845L143.902 88.5091L142.364 89.4328L141.734 89.0831L143.272 88.1593Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.494 84.6467L139.551 87.8705L140.8 88.5624L140.857 91.79L141.476 91.4174L141.426 88.5548L141.419 88.1898L140.169 87.4979L140.113 84.2742L139.494 84.6467Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.551 87.8704L140.8 88.5661",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.596 84.5933L142.649 87.8171L142.341 88.0034L142.03 87.8285H142.026L141.969 84.6009L142.277 84.4185L142.584 84.5857L142.596 84.5933Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.169 87.4978L141.419 88.1897",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.698 87.9008L137.755 91.1284L137.124 90.7787L137.121 90.7749L137.067 87.5511L138.601 86.6311L139.232 86.9808L137.698 87.9008Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.619 91.8052L139.562 88.5776L140.192 88.9274L140.249 92.155L138.715 93.0787L138.081 92.729L139.619 91.8052Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.943 88.2354L139 91.4592L138.689 91.6455L138.377 91.4706H138.374L138.317 88.2468L138.628 88.0605L138.932 88.2278L138.943 88.2354Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.216 84.2017L135.784 85.0722L135.841 88.296L135.898 91.5122L137.462 92.3827L138.081 92.0102L136.517 91.1396L136.46 87.9158L136.403 84.6997L134.839 83.8291L134.835 83.8329L134.216 84.2017Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.682 84.4107L132.739 87.6345L132.108 87.2848L132.052 84.061L133.585 83.1372L134.216 83.487L132.682 84.4107Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.603 88.3112L134.546 85.0874L135.176 85.4371L135.233 88.6609L133.7 89.5847L133.065 89.235L134.603 88.3112Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.825 84.7986L130.882 88.0185L132.135 88.7142L132.188 91.9418L132.807 91.5693L132.758 88.7066L132.75 88.3417L131.501 87.6498L131.444 84.426L130.825 84.7986Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.882 88.0186V88.0224L132.135 88.7181",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.927 84.7415L133.984 87.9691L133.673 88.1554L133.362 87.9805H133.358L133.301 84.7529L133.612 84.5667L133.916 84.7377L133.927 84.7415Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.501 87.6499L132.75 88.3418",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.029 88.0528L129.086 91.2766L128.46 90.9307L128.456 90.9269L128.399 87.7031L129.933 86.7793L130.563 87.1291L129.029 88.0528Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.951 91.9533L130.894 88.7295L131.524 89.0792H131.528L131.581 92.3068L130.047 93.2268L129.417 92.8771L130.951 91.9533Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.275 88.3873L130.332 91.611L130.021 91.7973L129.709 91.6224H129.705L129.648 88.3987L129.96 88.2124L130.264 88.3797L130.275 88.3873Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.552 84.3538L127.12 85.2243L127.23 91.6643L128.794 92.5348H128.798L129.417 92.1623L127.849 91.2917L127.792 88.0679L127.735 84.8518L126.17 83.9812L126.167 83.985L125.552 84.3538Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.014 84.5628L124.071 87.7866L123.444 87.4369H123.44L123.384 84.2131L124.917 83.2893L125.552 83.6391L124.014 84.5628Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.935 88.4633L125.878 85.2395L126.508 85.5855L126.512 85.5893L126.565 88.813L125.031 89.7368L124.401 89.3871L125.935 88.4633Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.161 84.9507L122.214 88.1745L123.467 88.8663L123.524 92.0901L124.143 91.7214L124.09 88.8549L124.086 88.4938L122.833 87.8019L122.776 84.5781L122.161 84.9507Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.214 88.1743L123.467 88.87",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.259 84.8936L125.316 88.1212L125.009 88.3075L124.693 88.1326L124.69 88.1288L124.636 84.905L124.944 84.7188L125.248 84.8898L125.259 84.8936Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.833 87.802L124.086 88.4939",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.365 88.2049L120.418 91.4287L119.792 91.0828L119.788 91.0789L119.731 87.8552L121.269 86.9314L121.899 87.2811L120.365 88.2049Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.282 92.1054L122.229 88.8816L122.856 89.2313H122.86L122.917 92.4551L121.379 93.3789L120.749 93.0292L122.282 92.1054Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.607 88.5395L121.664 91.7633L121.356 91.9496L121.041 91.7747L120.984 88.5471L121.291 88.3608L121.595 88.5319L121.607 88.5395Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.883 84.5059L118.451 85.3764L118.505 88.6002H118.508L118.565 91.8164L120.13 92.6869L120.749 92.3144L119.18 91.4438L119.127 88.22L119.07 85.0039L117.502 84.1333L117.498 84.1371L116.883 84.5059Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.349 84.7149L115.406 87.9387L114.776 87.589H114.772L114.715 84.3614L116.253 83.4414L116.883 83.7912L115.349 84.7149Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.267 88.6155L117.214 85.3879L117.84 85.7377L117.844 85.7415L117.901 88.9653L116.363 89.8891L115.733 89.5393L117.267 88.6155Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.493 85.1027L113.55 88.3226L114.799 89.0183L114.856 92.2421L115.475 91.8696L115.421 89.0107L115.418 88.6458L114.165 87.9539L114.112 84.7263L113.493 85.1027Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.55 88.3228V88.3266L114.799 89.0223",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.595 85.0457L116.648 88.2695L116.34 88.4558L116.025 88.2847V88.2809L115.968 85.0571L116.276 84.8708L116.583 85.0381L116.595 85.0457Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.165 87.9541L115.418 88.646",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.697 88.357L111.754 91.5808L111.123 91.2311H111.12L111.066 88.0073L112.6 87.0835L113.231 87.4332L111.697 88.357Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.618 92.2575L113.561 89.0337L114.187 89.3834H114.191L114.248 92.6072L112.714 93.531L112.08 93.1812L113.618 92.2575Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.942 88.6878L112.999 91.9154L112.688 92.1017L112.376 91.9268H112.373L112.316 88.6992L112.627 88.5129L112.931 88.684L112.942 88.6878Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.215 84.658L109.783 85.5285L109.897 91.9685L111.461 92.839L112.08 92.4665L110.516 91.5959L110.459 88.3721L110.402 85.156L108.838 84.2854H108.834L108.215 84.658Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.681 84.867L106.738 88.0908L106.107 87.7411H106.104L106.051 84.5135L107.584 83.5935L108.215 83.9433L106.681 84.867Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.602 88.7676L108.545 85.54L109.172 85.8898L109.176 85.8936L109.232 89.1174L107.699 90.0411L107.064 89.6914L108.602 88.7676Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.824 85.251L104.881 88.4748L106.13 89.1704L106.187 92.3942L106.806 92.0217L106.757 89.159L106.749 88.7979L105.5 88.106L105.443 84.8784L104.824 85.251Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.881 88.4749V88.4786L106.13 89.1705",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.926 85.1978L107.983 88.4216L107.672 88.6079L107.361 88.4368L107.357 88.433L107.3 85.2092L107.611 85.0229L107.915 85.1902L107.926 85.1978Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5 88.1021L106.749 88.7977",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.95 92.4093L104.893 89.1855L105.523 89.5315V89.5353L105.58 92.7591L104.046 93.6828L103.416 93.3331L104.95 92.4093Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.835 92.5502L158.892 95.7777L158.261 95.428L158.258 95.4242L158.201 92.2004L159.738 91.2766L160.369 91.6302L158.835 92.5502Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.978 92.938L157.035 96.1618L158.284 96.8575L158.341 100.081L158.96 99.7087L158.911 96.846L158.903 96.4849L157.654 95.793L157.597 92.5654L156.978 92.938Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.035 96.1616L158.284 96.8573",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.654 95.7891L158.903 96.4848",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.182 96.1959L155.239 99.4197L154.609 99.0699H154.605L154.552 95.8423L156.086 94.9224L156.716 95.2721L155.182 96.1959Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.103 100.096L157.046 96.8689L157.673 97.2187L157.676 97.2224L157.733 100.446L156.2 101.37L155.565 101.02L157.103 100.096Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.428 96.5267L156.484 99.7504L156.173 99.9367L155.862 99.7656L155.858 99.7619L155.801 96.5381L156.112 96.3518L156.416 96.5191L156.428 96.5267Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.7 92.4971L153.269 93.3638L153.326 96.5876L153.382 99.8038L154.947 100.674L155.566 100.302L154.001 99.435L153.944 96.2075L153.887 92.9913L152.323 92.1245H152.319L151.7 92.4971Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.166 92.7023L150.223 95.926L149.593 95.5801L149.589 95.5763L149.536 92.3525L151.07 91.4287L151.7 91.7785L150.166 92.7023Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.088 96.6027L152.031 93.3789L152.657 93.7286H152.661L152.718 96.9562L151.184 97.8762L150.55 97.5265L152.088 96.6027Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.31 93.0901L148.367 96.3139L149.616 97.0057L149.673 100.233L150.292 99.8608L150.242 96.9981L150.235 96.637L148.986 95.9413L148.929 92.7175L148.31 93.0901Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.367 96.3137L149.616 97.0094",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.412 93.0367L151.469 96.2605L151.157 96.4467L150.846 96.2719H150.842L150.785 93.0443L151.097 92.8618L151.4 93.0291L151.412 93.0367Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.986 95.9412L150.235 96.6369",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.514 96.3442L146.571 99.5718L145.944 99.222L145.94 99.2182L145.884 95.9945L147.417 95.0745L148.048 95.4242L146.514 96.3442Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.435 100.249L148.378 97.021L149.008 97.3707V97.3746L149.065 100.598L147.531 101.522L146.901 101.172L148.435 100.249Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.759 96.6788L147.816 99.9025L147.505 100.089L147.194 99.9177L147.19 99.914L147.133 96.6902L147.444 96.5039L147.748 96.6712L147.759 96.6788Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.036 92.6453L144.6 93.5158L144.714 99.9558L146.278 100.826H146.282L146.901 100.454L145.333 99.5832L145.219 93.1433L143.655 92.2727V92.2765H143.651L143.036 92.6453Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.498 92.8544L141.555 96.0781L140.929 95.7284H140.925L140.868 92.5046L142.402 91.5808L143.032 91.9306L141.498 92.8544Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.419 96.7548L143.362 93.531L143.993 93.8808H143.997L144.05 97.1045L142.516 98.0283L141.885 97.6786L143.419 96.7548Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.645 93.2422L139.698 96.466L140.951 97.1578L141.005 100.385L141.627 100.013L141.574 97.1502L141.566 96.7853L140.317 96.0934L140.26 92.8696L139.645 93.2422Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.698 96.4658L140.951 97.1615",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.743 93.1851L142.8 96.4127L142.489 96.599L142.178 96.4241H142.174L142.117 93.1965L142.428 93.0103L142.732 93.1813L142.743 93.1851Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.317 96.0933L141.567 96.7852",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.849 96.4962L137.903 99.7238L137.276 99.374L137.272 99.3702L137.215 96.1464L138.753 95.2227L139.383 95.5762L137.849 96.4962Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.767 100.397L139.71 97.1729L140.34 97.5226H140.344L140.401 100.75L138.863 101.67L138.233 101.32L139.767 100.397Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.091 96.8306L139.148 100.054L138.84 100.241L138.525 100.066H138.521L138.468 96.842L138.776 96.6558L139.08 96.823L139.091 96.8306Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.368 92.7971L135.936 93.6677L135.989 96.8915H135.993L136.046 100.108L137.614 100.978L138.233 100.606L136.665 99.7351L136.608 96.5113L136.551 93.2951L134.987 92.4246L134.983 92.4284L134.368 92.7971Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.834 93.0062L132.887 96.23L132.26 95.8802H132.257L132.2 92.6565L133.737 91.7327L134.368 92.0824L132.834 93.0062Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.751 96.9066L134.698 93.6829L135.325 94.0288L135.328 94.0326L135.385 97.2564L133.848 98.1802L133.217 97.8304L134.751 96.9066Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.977 93.394L131.03 96.614L132.283 97.3097L132.34 100.533L132.959 100.165L132.906 97.3021L132.902 96.9371L131.649 96.2453L131.592 93.0215L130.977 93.394Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.03 96.614V96.6178L132.283 97.3135",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.075 93.337L134.132 96.5646L133.825 96.7508L133.51 96.576L133.506 96.5722L133.453 93.3484L133.76 93.1621L134.064 93.3332L134.075 93.337Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.649 96.2454L132.902 96.9372",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.181 96.6483L129.238 99.8721L128.608 99.5261L128.604 99.5223L128.547 96.2985L130.085 95.3748L130.715 95.7245L129.181 96.6483Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.102 100.549L131.045 97.325L131.672 97.6747H131.676L131.733 100.902L130.195 101.822L129.565 101.473L131.102 100.549Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.427 96.9827L130.48 100.207L130.172 100.393L129.861 100.218H129.857L129.8 96.9903L130.108 96.8079L130.415 96.9751L130.427 96.9827Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.699 92.9492L127.268 93.8198L127.381 100.26L128.946 101.13L129.565 100.758L128 99.8872L127.943 96.6634L127.886 93.4472L126.318 92.5767V92.5805L125.699 92.9492Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.166 93.1583L124.223 96.3821L123.592 96.0323H123.588L123.531 92.8086L125.069 91.8848L125.7 92.2345L124.166 93.1583Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.087 97.0587L126.03 93.835L126.656 94.1809L126.66 94.1847L126.717 97.4085L125.183 98.3323L124.549 97.9825L126.087 97.0587Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.309 93.546L122.366 96.766L123.615 97.4617L123.672 100.685L124.291 100.313L124.241 97.4503L124.234 97.0892L122.985 96.3973L122.928 93.1697L122.309 93.546Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.366 96.7661V96.7699L123.615 97.4656",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.411 93.4891L125.468 96.7129L125.157 96.9029L124.845 96.7281L124.841 96.7243L124.784 93.5005L125.096 93.3142L125.4 93.4853L125.411 93.4891Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.985 96.3975L124.234 97.0894",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.513 96.8004L120.57 100.024L119.94 99.6744L119.883 96.4506L121.417 95.5269L122.047 95.8766L120.513 96.8004Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.434 100.701L122.377 97.4771L123.007 97.8268L123.064 101.051L121.53 101.974L120.896 101.625L122.434 100.701Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.758 97.1312L121.815 100.359L121.504 100.545L121.193 100.37H121.189L121.132 97.1426L121.443 96.9563L121.747 97.1274L121.758 97.1312Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.035 93.1013L118.599 93.9719L118.656 97.1957V97.1918L118.713 100.412L120.277 101.282L120.896 100.91L119.332 100.039L119.275 96.8155L119.218 93.5993L117.654 92.7288H117.65V92.7326L117.035 93.1013Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.497 93.3104L115.554 96.5342L114.924 96.1844L114.867 92.9568L116.401 92.0369L117.031 92.3866L115.497 93.3104Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.419 97.211L117.362 93.9834L117.992 94.3332V94.3369L118.049 97.5607L116.515 98.4845L115.881 98.1348L117.419 97.211Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.641 93.6943L113.698 96.9181L114.951 97.6138L115.004 100.838L115.623 100.465L115.573 97.6024L115.566 97.2412L114.316 96.5493L114.26 93.3218L113.641 93.6943Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.698 96.9182V96.922L114.95 97.6177",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.743 93.6412L116.8 96.865L116.488 97.0512L116.177 96.8802L116.173 96.8764L116.116 93.6526L116.428 93.4663L116.731 93.6336L116.743 93.6412Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.316 96.5457L115.566 97.2414",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.845 96.9525L111.902 100.176L111.275 99.8265H111.271L111.214 96.6027L112.748 95.679L113.379 96.0287L111.845 96.9525Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.766 100.853L113.709 97.6292L114.339 97.9751L114.343 97.9789L114.396 101.203L112.862 102.126L112.232 101.777L113.766 100.853Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.09 97.2833L113.147 100.511L112.836 100.697L112.524 100.522L112.521 100.518L112.464 97.2947L112.775 97.1084L113.079 97.2795L113.09 97.2833Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.367 93.2534L109.935 94.124L110.045 100.564L111.613 101.434L112.232 101.058L110.664 100.191L110.607 96.9638L110.55 93.7514L108.986 92.8809H108.982L108.367 93.2534Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.829 93.4587L106.886 96.6863L106.259 96.3365L106.256 96.3327L106.199 93.109L107.733 92.189L108.367 92.5387L106.829 93.4587Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75 97.3631L108.693 94.1355L109.324 94.4853H109.327L109.384 97.7128L107.847 98.6366L107.216 98.2869L108.75 97.3631Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.976 93.8464L105.029 97.0702L106.282 97.7659L106.339 100.99L106.958 100.617L106.905 97.7545L106.901 97.3933L105.648 96.7014L105.591 93.4739L104.976 93.8464Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.029 97.0703L106.282 97.766",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.074 93.7933L108.131 97.0171L107.824 97.2033L107.509 97.0285H107.505L107.452 93.8047L107.759 93.6184L108.063 93.7857L108.074 93.7933Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.648 96.6975L106.901 97.3932",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.098 101.005L105.044 97.781L105.671 98.127L105.675 98.1308L105.732 101.355L104.194 102.278L103.564 101.929L105.098 101.005Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.983 101.146L159.04 104.369L158.413 104.023L158.409 104.02L158.352 100.796L159.886 99.8721L160.517 100.222L158.983 101.146Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.126 101.533L157.183 104.757L158.436 105.449L158.489 108.677L159.108 108.304L159.059 105.441L159.051 105.08L157.802 104.385L157.745 101.161L157.126 101.533Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.183 104.757L158.436 105.453",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.802 104.385L159.051 105.08",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.33 104.791L155.387 108.015L154.761 107.665H154.757L154.7 104.438L156.234 103.518L156.868 103.868L155.33 104.791Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.251 108.692L157.195 105.464L157.825 105.814L157.829 105.818L157.882 109.042L156.348 109.965L155.718 109.616L157.251 108.692Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.576 105.122L156.633 108.346L156.325 108.532L156.01 108.361L156.006 108.357L155.953 105.134L156.26 104.947L156.564 105.115L156.576 105.122Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.852 101.092L153.42 101.959L153.474 105.183H153.477L153.531 108.399L155.099 109.27L155.718 108.897L154.149 108.03L154.092 104.803L154.035 101.587L152.471 100.716V100.72H152.467L151.852 101.092Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.318 101.298L150.372 104.521L149.745 104.176L149.741 104.172L149.684 100.948L151.222 100.024L151.852 100.374L150.318 101.298Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.236 105.198L152.179 101.974L152.809 102.324H152.813L152.87 105.548L151.332 106.472L150.702 106.122L152.236 105.198Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.462 101.686L148.515 104.909L149.768 105.601L149.825 108.829L150.444 108.456L150.39 105.594L150.383 105.229L149.134 104.537L149.077 101.313L148.462 101.686Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.515 104.909L149.768 105.605",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.56 101.632L151.617 104.856L151.309 105.042L150.994 104.867H150.99L150.937 101.64L151.245 101.454L151.549 101.625L151.56 101.632Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.134 104.537L150.383 105.229",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.666 104.94L146.723 108.167L146.092 107.817L146.089 107.814L146.032 104.59L147.569 103.666L148.2 104.02L146.666 104.94Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.583 108.844L148.53 105.616L149.157 105.966H149.16L149.217 109.194L147.68 110.117L147.049 109.768L148.583 108.844Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.911 105.274L147.964 108.498L147.657 108.684L147.342 108.509L147.285 105.285L147.592 105.099L147.896 105.266L147.911 105.274Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.184 101.241L144.752 102.111L144.862 108.551L146.43 109.422L147.049 109.049L145.481 108.179L145.371 101.739L143.803 100.868V100.872L143.184 101.241Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.65 101.45L141.707 104.674L141.077 104.324H141.073L141.016 101.1L142.554 100.176L143.184 100.526L141.65 101.45Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.571 105.35L143.514 102.126L144.141 102.476H144.145L144.202 105.7L142.664 106.624L142.034 106.274L143.571 105.35Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.793 101.838L139.85 105.061L141.1 105.753L141.157 108.981L141.775 108.608L141.726 105.746L141.718 105.381L140.469 104.689L140.412 101.465L139.793 101.838Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.85 105.061L141.1 105.757",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.896 101.781L142.949 105.008L142.641 105.194L142.33 105.02H142.326L142.269 101.792L142.577 101.606L142.884 101.777L142.896 101.781Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.469 104.689L141.718 105.381",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.997 105.092L138.054 108.315L137.424 107.969L137.42 107.966L137.367 104.742L138.901 103.818L139.531 104.168L137.997 105.092Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.919 108.992L139.862 105.768L140.488 106.118H140.492L140.549 109.346L139.015 110.266L138.381 109.916L139.919 108.992Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.243 105.426L139.3 108.65L138.989 108.836L138.677 108.661H138.673L138.616 105.438L138.928 105.251L139.232 105.418L139.243 105.426Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.516 101.393L136.084 102.263L136.141 105.487L136.198 108.703L137.762 109.574L138.381 109.201L136.817 108.331L136.76 105.107L136.703 101.891L135.138 101.02H135.135V101.024L134.516 101.393Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.982 101.602L133.039 104.825L132.408 104.476H132.404L132.351 101.252L133.885 100.328L134.516 100.678L132.982 101.602Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.903 105.502L134.846 102.278L135.476 102.624V102.628L135.533 105.852L133.999 106.776L133.365 106.426L134.903 105.502Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.125 101.99L131.182 105.209L132.431 105.905L132.488 109.129L133.107 108.76L133.058 105.898L133.05 105.533L131.801 104.841L131.744 101.617L131.125 101.99Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.182 105.209V105.213L132.435 105.909",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.227 101.932L134.284 105.16L133.973 105.346L133.661 105.171L133.658 105.168L133.601 101.944L133.912 101.758L134.216 101.929L134.227 101.932Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.801 104.841L133.05 105.533",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.329 105.244L129.386 108.468L128.76 108.118H128.756L128.699 104.894L130.233 103.97L130.863 104.32L129.329 105.244Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.25 109.144L131.194 105.92L131.824 106.27H131.828L131.881 109.494L130.347 110.418L129.717 110.068L131.25 109.144Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.575 105.575L130.632 108.802L130.32 108.988L130.009 108.814H130.005L129.948 105.586L130.26 105.4L130.563 105.571L130.575 105.575Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.851 101.545L127.416 102.415L127.53 108.855L129.094 109.726H129.098L129.717 109.353L128.148 108.483L128.091 105.259L128.035 102.043L126.47 101.172L126.466 101.176L125.851 101.545Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.314 101.754L124.371 104.978L123.744 104.628H123.74L123.683 101.4L125.217 100.48L125.848 100.83L124.314 101.754Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.235 105.654L126.178 102.427L126.808 102.777L126.812 102.78L126.865 106.004L125.331 106.928L124.701 106.578L126.235 105.654Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.461 102.141L122.514 105.361L123.767 106.057L123.82 109.281L124.443 108.908L124.39 106.046L124.382 105.685L123.133 104.993L123.076 101.765L122.461 102.141Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.514 105.362V105.365L123.767 106.061",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.559 102.085L125.616 105.308L125.304 105.495L124.993 105.324L124.989 105.32L124.932 102.096L125.244 101.91L125.547 102.077L125.559 102.085Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.133 104.993L124.382 105.685",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.665 105.396L120.718 108.62L120.092 108.27H120.088L120.031 105.046L121.568 104.122L122.199 104.472L120.665 105.396Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.582 109.296L122.525 106.073L123.156 106.422H123.159L123.216 109.646L121.679 110.57L121.048 110.22L122.582 109.296Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.906 105.727L121.963 108.954L121.656 109.14L121.341 108.966H121.337L121.284 105.738L121.591 105.552L121.895 105.723L121.906 105.727Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.183 101.697L118.751 102.567L118.804 105.791L118.808 105.787L118.861 109.007L120.429 109.878L121.048 109.505L119.48 108.635L119.423 105.407L119.366 102.195L117.802 101.324H117.798L117.183 101.697Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.649 101.902L115.702 105.13L115.076 104.78L115.072 104.776L115.015 101.552L116.553 100.632L117.183 100.982L115.649 101.902Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.567 105.806L117.513 102.579L118.14 102.929L118.144 102.932L118.201 106.156L116.663 107.08L116.033 106.73L117.567 105.806Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.792 102.29L113.846 105.514L115.099 106.209L115.156 109.433L115.774 109.06L115.721 106.198L115.717 105.837L114.465 105.145L114.408 101.917L113.792 102.29Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.846 105.514V105.517L115.099 106.213",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.891 102.237L116.948 105.46L116.64 105.647L116.325 105.476V105.472L116.268 102.248L116.576 102.062L116.879 102.229L116.891 102.237Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.464 105.141L115.717 105.837",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.996 105.548L112.053 108.772L111.423 108.422H111.419L111.362 105.198L112.9 104.274L113.53 104.624L111.996 105.548Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.918 109.448L113.861 106.225L114.487 106.571L114.491 106.574L114.548 109.798L113.01 110.722L112.38 110.372L113.918 109.448Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.242 105.879L113.295 109.103L112.987 109.293L112.676 109.118L112.672 109.114L112.615 105.89L112.923 105.704L113.23 105.875L113.242 105.879Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.515 101.849L110.083 102.716L110.197 109.159L111.761 110.03L112.38 109.654L110.816 108.787L110.759 105.559L110.702 102.347L109.137 101.476H109.134L108.515 101.849Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.981 102.054L107.038 105.282L106.407 104.932L106.403 104.928L106.35 101.704L107.884 100.781L108.515 101.134L106.981 102.054Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.902 105.954L108.845 102.731L109.472 103.08H109.475L109.532 106.308L107.998 107.228L107.364 106.878L108.902 105.954Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.124 102.442L105.181 105.666L106.43 106.361L106.487 109.585L107.106 109.213L107.057 106.35L107.049 105.989L105.8 105.297L105.743 102.069L105.124 102.442Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.181 105.666L106.43 106.361",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.226 102.388L108.283 105.612L107.972 105.799L107.66 105.624H107.657L107.6 102.4L107.911 102.214L108.215 102.381L108.226 102.388Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.8 105.293L107.049 105.989",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.328 105.7L103.385 108.924L102.755 108.574L102.698 105.346L104.232 104.426L104.862 104.776L103.328 105.7Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.249 109.6L105.192 106.373L105.823 106.723V106.726L105.88 109.95L104.346 110.874L103.712 110.524L105.249 109.6Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  })))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M111.4 53.1501L110.155 54.7126L109.809 54.7278L105.671 58.94L89.8948 97.3249L92.7348 99.4728C92.7348 99.4728 97.1544 97.1614 99.1705 95.0135C101.187 92.8656 106.24 86.1672 106.24 86.1672L115.706 70.5996L117.771 66.6079C118.371 65.4446 118.36 64.0608 117.741 62.9127L118.538 61.3312L117.589 61.4073L111.4 53.154V53.1501Z",
    fill: "#FAFAFA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M110.239 54.7582C110.239 54.7582 110.326 54.5872 110.516 54.302C110.736 53.9827 111.009 53.5797 111.336 53.1045L111.397 53.0171L111.465 53.1045C112.198 54.0473 113.189 55.3513 114.275 56.7997C115.729 58.7347 116.978 60.4454 117.635 61.3692L117.585 61.3464C118.197 61.3122 118.538 61.3046 118.538 61.3274C118.538 61.3502 118.204 61.3958 117.593 61.4605H117.563L117.544 61.4377C116.837 60.5481 115.55 58.8678 114.096 56.9327C113.01 55.4843 112.034 54.1652 111.336 53.1996H111.461C111.112 53.6558 110.819 54.0435 110.584 54.3515C110.371 54.6214 110.25 54.7658 110.239 54.7582Z",
    fill: "#09363F"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M115.691 64.1104C115.691 64.1104 115.653 64.3613 115.546 64.8023C115.444 65.2471 115.269 65.882 115.041 66.6613C114.586 68.2237 113.861 70.3564 112.889 72.6412C111.913 74.926 110.873 76.9256 110.064 78.336C109.658 79.0431 109.32 79.6058 109.073 79.9859C108.826 80.3699 108.686 80.5752 108.674 80.5676C108.663 80.56 108.777 80.3357 109.001 79.9403C109.225 79.5449 109.544 78.9709 109.931 78.2562C110.705 76.8306 111.719 74.8271 112.691 72.5538C113.659 70.2766 114.404 68.1591 114.901 66.6157C115.148 65.8439 115.341 65.2167 115.471 64.7795C115.603 64.3461 115.683 64.1066 115.698 64.1104H115.691Z",
    fill: "#09363F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M108.796 80.7842C108.796 80.7842 113.732 74.8841 113.64 75.116C113.549 75.3479 105.72 91.1893 105.72 91.1893L105.921 84.8596L108.796 80.7842Z",
    fill: "#09363F"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M100.644 91.1854C100.644 91.1854 100.75 91.0257 100.97 90.7672C101.225 90.4745 101.54 90.1133 101.916 89.68C102.713 88.76 103.807 87.4826 104.968 86.038C106.134 84.5934 107.148 83.2552 107.877 82.2782C108.219 81.8182 108.507 81.4343 108.739 81.1225C108.944 80.8526 109.065 80.7043 109.077 80.7119C109.088 80.7196 108.993 80.883 108.811 81.1719C108.629 81.4609 108.351 81.8676 108.006 82.3695C107.311 83.3693 106.309 84.7265 105.143 86.1749C103.977 87.6233 102.865 88.8892 102.033 89.7826C101.62 90.2312 101.278 90.5847 101.035 90.8242C100.792 91.0637 100.655 91.193 100.644 91.1816V91.1854Z",
    fill: "#375A64"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M115.691 73.7285C115.691 73.7285 115.679 73.8805 115.604 74.1428C115.528 74.4052 115.399 74.7777 115.193 75.2225C114.791 76.1083 114.024 77.264 112.893 78.2448C111.917 79.104 110.949 79.7844 110.25 80.3813C109.54 80.9667 109.096 81.4572 108.91 81.632L108.875 81.6016C108.929 81.5484 108.959 81.5218 108.967 81.5256C108.974 81.5294 108.955 81.5674 108.913 81.6282L108.879 81.5978C109.024 81.3887 109.441 80.8603 110.14 80.2444C110.827 79.6172 111.788 78.9215 112.748 78.0737C113.857 77.1081 114.62 76.0018 115.053 75.1465C115.49 74.2873 115.657 73.7095 115.695 73.7209L115.691 73.7285Z",
    fill: "#375A64"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M118.166 62.0649C118.166 62.0649 118.292 62.217 118.47 62.5249C118.645 62.8329 118.884 63.2853 119.135 63.8707C119.378 64.4562 119.651 65.1671 119.78 66.0072C119.829 66.4254 119.89 66.8778 119.761 67.3454C119.636 67.7978 119.435 68.235 119.192 68.6569C118.455 69.9381 117.597 70.9987 116.879 71.8617C116.158 72.7209 115.554 73.3671 115.193 73.7321L115.178 73.6637C115.486 73.8005 115.649 73.8804 115.641 73.8956C115.638 73.9108 115.463 73.8537 115.148 73.7435L115.095 73.7245L115.136 73.6789C115.467 73.2873 116.044 72.622 116.743 71.7515C117.434 70.8771 118.28 69.8126 119.002 68.5543C119.241 68.1437 119.435 67.7179 119.556 67.2998C119.681 66.8854 119.628 66.4444 119.586 66.0414C119.476 65.2279 119.222 64.517 118.998 63.9353C118.77 63.3499 118.554 62.8899 118.402 62.5706C118.25 62.2512 118.163 62.0801 118.174 62.0725L118.166 62.0649Z",
    fill: "#375A64"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M121.61 67.4784C121.58 67.467 121.705 67.0906 121.91 66.4824C122.107 65.8779 122.388 65.0378 122.491 64.0798C122.59 63.1218 122.423 62.2474 122.176 61.6733C121.933 61.0917 121.659 60.799 121.69 60.7724C121.701 60.7648 121.777 60.8256 121.899 60.9624C122.02 61.0993 122.172 61.316 122.32 61.6087C122.616 62.1904 122.814 63.1065 122.711 64.1026C122.609 65.0948 122.293 65.9426 122.058 66.5356C121.815 67.1325 121.64 67.486 121.614 67.4746L121.61 67.4784Z",
    fill: "#375A64"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M110.379 83.3084C110.371 83.3655 109.771 83.3236 109.077 83.0879C108.378 82.856 107.873 82.5367 107.903 82.4835C107.934 82.4265 108.469 82.6545 109.145 82.8788C109.821 83.1069 110.387 83.2438 110.379 83.3084Z",
    fill: "#375A64"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M107.945 85.5666C107.884 85.5742 107.759 85.0154 107.66 84.3197C107.566 83.624 107.535 83.0499 107.596 83.0423C107.657 83.0347 107.782 83.5935 107.881 84.2892C107.976 84.9849 108.006 85.559 107.945 85.5666Z",
    fill: "#375A64"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M101.84 54.0132C101.84 54.0132 101.946 54.1652 102.086 54.4694C102.227 54.7697 102.402 55.2259 102.553 55.8037C102.857 56.9518 102.99 58.6664 102.47 60.4341C101.946 62.2019 100.902 63.5666 100.021 64.365C99.5805 64.7679 99.1894 65.0531 98.9046 65.2317C98.6237 65.4066 98.4566 65.4903 98.449 65.4789C98.4225 65.4408 99.0717 65.0797 99.9108 64.2547C100.75 63.4412 101.745 62.0954 102.253 60.3733C102.762 58.6511 102.656 56.9784 102.398 55.8418C102.143 54.6899 101.794 54.036 101.836 54.017L101.84 54.0132Z",
    fill: "#375A64"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2019 86.4067C69.331 88.8435 81.5721 103.244 81.5721 103.244C81.5721 103.244 86.3296 101.932 93.2817 98.0853C100.238 94.2418 108.792 80.7841 108.792 80.7841C108.792 80.7841 110.717 68.4593 110.793 62.9812C110.869 57.503 109.84 54.6328 109.84 54.6328L99.4137 53.1426L88.4445 71.9149L85.7943 78.0317C85.7943 78.0317 84.959 77.9177 84.8261 78.2522C84.6932 78.5868 84.5337 78.986 84.5337 78.986L69.1943 86.4029L69.2019 86.4067Z",
    fill: "#09363F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_35_83672",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 53,
    width: 42,
    height: 51
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2019 86.4067C69.331 88.8435 81.5721 103.244 81.5721 103.244C81.5721 103.244 86.3296 101.932 93.2817 98.0853C100.238 94.2418 108.792 80.7841 108.792 80.7841C108.792 80.7841 110.717 68.4593 110.793 62.9812C110.869 57.503 109.84 54.6328 109.84 54.6328L99.4137 53.1426L88.4445 71.9149L85.7943 78.0317C85.7943 78.0317 84.959 77.9177 84.8261 78.2522C84.6932 78.5868 84.5337 78.986 84.5337 78.986L69.1943 86.4029L69.2019 86.4067Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_35_83672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5339 51.6791L73.477 48.4553L74.1073 48.8051H74.1111L74.1642 52.0288L72.6303 52.9526L72 52.6029L73.5339 51.6791Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.087 52.1239L110.14 55.3515L109.513 55.0017L109.51 54.9979L109.453 51.7741L110.99 50.8503L111.621 51.2039L110.087 52.1239Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.004 56.0243L111.947 52.8005L112.577 53.1503H112.581L112.638 56.3779L111.1 57.2978L110.47 56.9519L112.004 56.0243Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.23 52.5117L108.283 55.7355L109.536 56.4312L109.593 59.655L110.212 59.2824L110.159 56.4198L110.151 56.0586L108.902 55.3667L108.845 52.1392L108.23 52.5117Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.283 55.7354L109.536 56.431",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.328 52.4583L111.385 55.6821L111.078 55.8684L110.763 55.6935H110.759L110.706 52.4697L111.013 52.2834L111.317 52.4507L111.328 52.4583Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.902 55.3628L110.151 56.0585",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.434 55.7696L106.491 58.9934L105.861 58.6436H105.857L105.8 55.4161L107.338 54.4961L107.968 54.8458L106.434 55.7696Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.352 59.6702L108.298 56.4426L108.925 56.7924L108.929 56.7962L108.986 60.0199L107.448 60.9437L106.818 60.594L108.352 59.6702Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.679 56.1004L107.733 59.3242L107.425 59.5105L107.11 59.3394V59.3356L107.053 56.1118L107.361 55.9255L107.668 56.0928L107.679 56.1004Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.952 52.0708L104.521 52.9376L104.634 59.3775L106.199 60.2481L106.818 59.8755L105.253 59.0087L105.196 55.7812L105.139 52.565L103.571 51.6982L102.952 52.0708Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.418 52.276L101.475 55.4998L100.845 55.1538L100.841 55.15L100.784 51.9262L102.322 51.0024L102.952 51.3522L101.418 52.276Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.34 56.1764L103.283 52.9526L103.909 53.3024H103.913L103.97 56.53L102.432 57.4499L101.802 57.1002L103.34 56.1764Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5618 52.6638L99.6187 55.8876L100.868 56.5795L100.925 59.8071L101.544 59.4345L101.494 56.5719L101.487 56.2107L100.238 55.515L100.181 52.2913L99.5618 52.6638Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6187 55.8875L100.868 56.5831",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.664 52.6104L102.717 55.8342L102.409 56.0205L102.098 55.8456H102.094L102.037 52.618L102.345 52.4355L102.652 52.6028L102.664 52.6104Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.238 55.5149L101.487 56.2106",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7658 55.9179L97.8227 59.1455L97.1924 58.7958L97.1887 58.7919L97.1355 55.5682L98.6694 54.6482L99.2997 54.9979L97.7658 55.9179Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6869 59.8223L99.6299 56.5947L100.256 56.9445L100.26 56.9483L100.317 60.172L98.7833 61.0958L98.1492 60.7461L99.6869 59.8223Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0112 56.2525L99.0682 59.4763L98.7569 59.6626L98.4455 59.4915L98.4417 59.4877L98.3848 56.2639L98.6961 56.0776L98.9999 56.2449L99.0112 56.2525Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2842 52.219L95.8523 53.0896L95.9092 56.3133L95.9662 59.5295L97.5305 60.4001L98.1494 60.0275L96.5851 59.1569L96.5281 55.9332L96.4712 52.717L94.9069 51.8464L94.9031 51.8502L94.2842 52.219Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7502 52.4281L92.8071 55.6518L92.1768 55.3021L92.1199 52.0783L93.6538 51.1545L94.2841 51.5043L92.7502 52.4281Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6715 56.3285L94.6146 53.1047L95.2449 53.4545L95.3018 56.6783L93.7679 57.602L93.1338 57.2523L94.6715 56.3285Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8936 52.8159L90.9505 56.0359L92.2035 56.7316L92.2566 59.9592L92.8755 59.5866L92.8262 56.724L92.8186 56.359L91.5694 55.6671L91.5124 52.4434L90.8936 52.8159Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9504 56.0359V56.0397L92.2034 56.7354",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9956 52.7589L94.0526 55.9864L93.7412 56.1727L93.4299 55.9978H93.4261L93.3691 52.7703L93.6805 52.584L93.9842 52.7551L93.9956 52.7589Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5693 55.667L92.8185 56.3589",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0976 56.0699L89.1545 59.2975L88.528 58.9477L88.5242 58.9439L88.4673 55.7202L90.0012 54.7964L90.6315 55.1499L89.0976 56.0699Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0188 59.9703L90.9619 56.7466L91.5921 57.0963H91.5959L91.6491 60.3239L90.1151 61.2439L89.4849 60.8941L91.0188 59.9703Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.343 56.4044L90.4 59.6281L90.0887 59.8144L89.7773 59.6395H89.7735L89.7166 56.4158L90.0279 56.2295L90.3317 56.3968L90.343 56.4044Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6196 52.3708L87.1877 53.2414L87.2978 59.6814L88.8622 60.5519H88.866L89.4848 60.1794L87.9167 59.3088L87.8598 56.085L87.8028 52.8689L86.2385 51.9983L86.2347 52.0021L85.6196 52.3708Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0819 52.5799L84.1389 55.8037L83.5124 55.454H83.5086L83.4517 52.2302L84.9856 51.3064L85.6159 51.6561L84.0819 52.5799Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0032 56.4804L85.9462 53.2566L86.5765 53.6025L86.5803 53.6063L86.6335 56.8301L85.0995 57.7539L84.4692 57.4042L86.0032 56.4804Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.229 52.9678L82.2822 56.1915L83.5351 56.8834L83.5883 60.1072L84.211 59.7384L84.1578 56.872L84.1502 56.5109L82.901 55.819L82.8441 52.5952L82.229 52.9678Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2822 56.1914L83.5352 56.8871",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3272 52.9107L85.3841 56.1383L85.0728 56.3246L84.7614 56.1497L84.7576 56.1459L84.7007 52.9221L85.012 52.7358L85.3158 52.9069L85.3272 52.9107Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9011 55.8191L84.1503 56.511",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4331 56.222L80.4863 59.4458L79.8598 59.0999L79.856 59.096L79.7991 55.8723L81.3368 54.9485L81.9671 55.2982L80.4331 56.222Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3506 60.1224L82.2974 56.8987L82.9239 57.2484H82.9277L82.9847 60.4722L81.4469 61.396L80.8167 61.0462L82.3506 60.1224Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6747 56.5565L81.7316 59.7802L81.4241 59.9665L81.109 59.7916H81.1052L81.052 56.5641L81.3595 56.3816L81.6633 56.5489L81.6747 56.5565Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9514 52.523L78.5195 53.3935L78.5727 56.6173H78.5765L78.6334 59.8335L80.1977 60.704L80.8166 60.3315L79.2485 59.4609L79.1954 56.2371L79.1346 53.021L77.5703 52.1504L77.5665 52.1542L76.9514 52.523Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4175 52.732L75.4707 55.9558L74.8442 55.6061H74.8404L74.7834 52.3823L76.3212 51.4585L76.9515 51.8082L75.4175 52.732Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.335 56.6325L77.2818 53.4087L77.9083 53.7546L77.9121 53.7584L77.969 56.9822L76.4313 57.906L75.801 57.5562L77.335 56.6325Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5608 53.1198L73.6139 56.3397L74.8669 57.0354L74.9239 60.2592L75.5428 59.8866L75.4858 56.6629L74.2328 55.971L74.1797 52.7434L73.5608 53.1198Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.614 56.3398L73.6178 56.3436L74.867 57.0393",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6591 53.0628L76.716 56.2866L76.4085 56.4767L76.0933 56.3018V56.298L76.0364 53.0742L76.3439 52.8879L76.6477 53.0552L76.6591 53.0628Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2327 55.9673L75.4856 56.663",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7647 56.3741L71.8216 59.5979L71.1914 59.2481H71.1876L71.1306 56.0244L72.6684 55.1006L73.2986 55.4503L71.7647 56.3741Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6859 60.2745L73.629 57.0508L74.2555 57.4005H74.2593L74.3162 60.6243L72.7785 61.5481L72.1482 61.1983L73.6859 60.2745Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.01 56.7049L73.0632 59.9325L72.7556 60.1188L72.4443 59.9439H72.4405L72.3835 56.7163L72.6911 56.53L72.9986 56.7011L73.01 56.7049Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.283 52.675L69.8511 53.5456L69.965 59.9855L71.5293 60.8561L72.1482 60.4836L70.5839 59.613L70.5269 56.3892L70.47 53.1731L68.9056 52.3025H68.9019L68.283 52.675Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6703 56.7847L68.6134 53.5571L69.2398 53.9069L69.2436 53.9107L69.3006 57.1344L67.7666 58.0582L67.1326 57.7085L68.6703 56.7847Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.235 60.7191L110.291 63.9429L109.661 63.5969L109.657 63.5931L109.604 60.3694L111.138 59.4456L111.768 59.7953L110.235 60.7191Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.156 64.6195L112.099 61.3958L112.725 61.7455H112.729L112.786 64.9731L111.252 65.8931L110.618 65.5433L112.156 64.6195Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.378 61.1069L108.435 64.3307L109.684 65.0226L109.741 68.2502L110.36 67.8776L110.311 65.015L110.303 64.6538L109.054 63.9581L108.997 60.7344L108.378 61.1069Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.435 64.3306L109.684 65.0263",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.48 61.0535L111.537 64.2773L111.226 64.4636L110.914 64.2887H110.91L110.854 61.0649L111.165 60.8787L111.469 61.0459L111.48 61.0535Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.054 63.958L110.303 64.6537",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.582 64.3648L106.639 67.5886L106.013 67.2389H106.009L105.952 64.0113L107.486 63.0913L108.116 63.4411L106.582 64.3648Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.503 68.2654L108.446 65.0378L109.077 65.3876V65.3914L109.134 68.6152L107.6 69.539L106.969 69.1892L108.503 68.2654Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.828 64.6956L107.885 67.9194L107.573 68.1057L107.262 67.9346L107.258 67.9308L107.201 64.707L107.513 64.5208L107.816 64.688L107.828 64.6956Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.104 60.6659L104.669 61.5327L104.782 67.9726L106.347 68.8432H106.351L106.969 68.4706L105.401 67.6039L105.344 64.3763L105.287 61.1601L103.723 60.2896V60.2934H103.719L103.104 60.6659Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.566 60.8712L101.623 64.095L100.997 63.749L100.993 63.7452L100.936 60.5214L102.47 59.5977L103.1 59.9474L101.566 60.8712Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.488 64.7716L103.431 61.5479L104.061 61.8976H104.065L104.118 65.1214L102.584 66.0452L101.954 65.6954L103.488 64.7716Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7097 61.259L99.7667 64.4828L101.02 65.1747L101.073 68.4023L101.692 68.0297L101.642 65.1671L101.635 64.8021L100.386 64.1102L100.329 60.8865L99.7097 61.259Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7666 64.4827L101.02 65.1784",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.812 61.202L102.869 64.4295L102.557 64.6158L102.246 64.4409H102.242L102.185 61.2134L102.497 61.0271L102.8 61.1982L102.812 61.202Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.386 64.1104L101.635 64.8022",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9178 64.5133L97.9709 67.7409L97.3444 67.3911L97.3406 67.3873L97.2837 64.1635L98.8214 63.2397L99.4517 63.5933L97.9178 64.5133Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8352 68.4175L99.7783 65.1899L100.409 65.5397H100.412L100.469 68.7673L98.9316 69.6911L98.3013 69.3413L99.8352 68.4175Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1593 64.8477L99.2163 68.0715L98.9087 68.2578L98.5936 68.0829H98.5898L98.5366 64.8591L98.8442 64.6729L99.1479 64.8401L99.1593 64.8477Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.436 60.8142L96.0041 61.6848L96.0573 64.9085H96.0611L96.1143 68.1247L97.6824 68.9953L98.3013 68.6227L96.7331 67.7522L96.6762 64.5284L96.6192 61.3122L95.0549 60.4417V60.4454H95.0511L94.436 60.8142Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9021 61.0233L92.9553 64.2471L92.3288 63.8973H92.325L92.2681 60.6736L93.8058 59.7498L94.4361 60.0995L92.9021 61.0233Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8196 64.9237L94.7626 61.7L95.3929 62.0497H95.3967L95.4537 65.2735L93.9159 66.1973L93.2856 65.8475L94.8196 64.9237Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0454 61.4111L91.0986 64.6311L92.3515 65.3268L92.4085 68.5544L93.0274 68.1818L92.9742 65.3192L92.9666 64.9542L91.7175 64.2623L91.6605 61.0386L91.0454 61.4111Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0986 64.6311V64.6349L92.3516 65.3306",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1437 61.3541L94.2006 64.5816L93.8931 64.7679L93.578 64.5931H93.5742L93.521 61.3655L93.8285 61.1792L94.1323 61.3503L94.1437 61.3541Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7173 64.2625L92.9665 64.9543",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2493 64.6654L89.3063 67.8892L88.676 67.5432L88.6722 67.5394L88.6152 64.3156L90.153 63.3918L90.7833 63.7416L89.2493 64.6654Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1667 68.5658L91.1136 65.342L91.7401 65.6918H91.7439L91.8008 68.9194L90.2631 69.8393L89.6328 69.4896L91.1667 68.5658Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4946 64.9998L90.5478 68.2236L90.2403 68.4099L89.9251 68.235L89.8682 65.0112L90.1757 64.825L90.4833 64.9922L90.4946 64.9998Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7676 60.9663L87.3357 61.8369L87.4496 68.2768L89.0139 69.1474L89.6328 68.7748L88.0685 67.9042L88.0115 64.6805L87.9546 61.4643L86.3865 60.5938V60.5975L85.7676 60.9663Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2337 61.1754L84.2906 64.3992L83.6604 64.0494H83.6566L83.5996 60.8256L85.1373 59.9019L85.7676 60.2516L84.2337 61.1754Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1549 65.0758L86.098 61.8521L86.7245 62.198L86.7282 62.2018L86.7852 65.4256L85.2475 66.3494L84.6172 65.9996L86.1549 65.0758Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.377 61.5632L82.4339 64.787L83.6831 65.4789L83.74 68.7027L84.3589 68.3339L84.3096 65.4675L84.302 65.1063L83.0528 64.4144L82.9958 61.1907L82.377 61.5632Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4338 64.7869L83.683 65.4826",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.479 61.5062L85.5322 64.7337L85.2246 64.92L84.9133 64.7451L84.9095 64.7413L84.8525 61.5176L85.1601 61.3313L85.4676 61.5024L85.479 61.5062Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.053 64.4143L84.3021 65.1062",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5812 64.8172L80.6382 68.041L80.0079 67.6913H80.0041L79.9509 64.4675L81.4849 63.5437L82.1151 63.8935L80.5812 64.8172Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5023 68.7177L82.4454 65.4939L83.0757 65.8436L83.1326 69.0674L81.5987 69.9912L80.9646 69.6415L82.5023 68.7177Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8267 65.148L81.8836 68.3756L81.5723 68.5619L81.2609 68.387H81.2571L81.2002 65.1594L81.5115 64.9731L81.8153 65.1442L81.8267 65.148Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0994 61.1184L78.6675 61.989L78.7244 65.2127L78.7814 68.4289L80.3457 69.2995L80.9646 68.9269L79.4003 68.0564L79.3433 64.8326L79.2864 61.6164L77.7221 60.7458H77.7183V60.7497L77.0994 61.1184Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5653 61.3275L75.6223 64.5513L74.992 64.2015L74.9351 60.9739L76.469 60.054L77.0993 60.4037L75.5653 61.3275Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4867 65.2281L77.4298 62.0005L78.06 62.3502V62.354L78.117 65.5778L76.5831 66.5016L75.949 66.1518L77.4867 65.2281Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7087 61.7152L73.7657 64.9352L75.0187 65.6309L75.0718 68.8547L75.6907 68.4821L75.6338 65.2583L74.3846 64.5664L74.3276 61.3389L73.7087 61.7152Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7656 64.9353V64.9391L75.0186 65.6348",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8108 61.6583L76.8678 64.882L76.5564 65.0683L76.2451 64.8973L76.2413 64.8934L76.1843 61.6697L76.4957 61.4834L76.7994 61.6507L76.8108 61.6583Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3845 64.5625L75.6337 65.2582",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9127 64.9693L71.9697 68.1931L71.3432 67.8434H71.3394L71.2825 64.6196L72.8164 63.6958L73.4467 64.0455L71.9127 64.9693Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.834 68.8698L73.777 65.646L74.4073 65.9957H74.4111L74.4643 69.2195L72.9303 70.1433L72.3 69.7936L73.834 68.8698Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1582 65.3001L73.2152 68.5277L72.9038 68.714L72.5925 68.5391H72.5887L72.5317 65.3115L72.8431 65.1252L73.1468 65.2963L73.1582 65.3001Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4348 61.2705L70.0029 62.1411L70.113 68.581L71.6773 69.4516H71.6811L72.3 69.079L70.7319 68.2084L70.675 64.9809L70.618 61.7685L69.0537 60.8979H69.0499L68.4348 61.2705Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8184 65.3802L68.7614 62.1526L69.3917 62.5023L69.3955 62.5061L69.4486 65.7299L67.9147 66.6537L67.2844 66.3039L68.8184 65.3802Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.383 69.3146L110.44 72.5383L109.813 72.1924L109.809 72.1886L109.752 68.9648L111.286 68.041L111.92 68.3908L110.383 69.3146Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.304 73.215L112.247 69.9912L112.877 70.341H112.881L112.934 73.5647L111.4 74.4885L110.77 74.1388L112.304 73.215Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.53 69.7024L108.583 72.9262L109.836 73.6181L109.893 76.8456L110.512 76.4731L110.459 73.6105L110.451 73.2493L109.202 72.5536L109.145 69.3298L108.53 69.7024Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.583 72.926L109.836 73.6217",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.202 72.5535L110.451 73.2492",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.734 72.9565L106.787 76.1841L106.161 75.8343L106.157 75.8305L106.1 72.6068L107.638 71.6868L108.268 72.0365L106.734 72.9565Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.651 76.8609L108.598 73.6333L109.225 73.983H109.228L109.285 77.2106L107.748 78.1344L107.117 77.7847L108.651 76.8609Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.975 73.2911L108.032 76.5149L107.725 76.7011L107.41 76.5263L107.353 73.3025L107.66 73.1162L107.964 73.2835L107.975 73.2911Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.252 69.2576L104.82 70.1281L104.93 76.5681L106.499 77.4386L107.117 77.0661L105.553 76.1955L105.496 72.9717L105.439 69.7556L103.871 68.885V68.8888H103.867L103.252 69.2576Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.718 69.4667L101.775 72.6904L101.145 72.3407H101.141L101.084 69.1169L102.622 68.1931L103.252 68.5429L101.718 69.4667Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.636 73.3671L103.583 70.1433L104.209 70.4931H104.213L104.27 73.7168L102.732 74.6406L102.102 74.2909L103.636 73.3671Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8616 69.8545L99.9185 73.0783L101.168 73.7702L101.225 76.9977L101.844 76.6252L101.794 73.7625L101.787 73.3976L100.537 72.7057L100.48 69.4819L99.8616 69.8545Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9185 73.0781L101.168 73.7738",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.964 69.7974L103.017 73.025L102.709 73.2113L102.394 73.0364L102.337 69.8088L102.645 69.6226L102.952 69.7936L102.964 69.7974Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.537 72.7058L101.787 73.3977",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0656 73.1087L98.1225 76.3325L97.4923 75.9866L97.4885 75.9828L97.4353 72.759L98.9692 71.8352L99.5995 72.185L98.0656 73.1087Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9867 77.0092L99.9298 73.7854L100.556 74.1351H100.56L100.617 77.3627L99.083 78.2827L98.449 77.933L99.9867 77.0092Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3111 73.4432L99.368 76.667L99.0567 76.8532L98.7453 76.6784H98.7415L98.6846 73.4546L98.9959 73.2683L99.2997 73.4356L99.3111 73.4432Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.584 69.4097L96.1521 70.2802L96.209 73.504L96.266 76.7202L97.8303 77.5907L98.4492 77.2182L96.8849 76.3476L96.8279 73.1238L96.771 69.9077L95.2029 69.0371V69.0409L94.584 69.4097Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05 69.6188L93.1069 72.8425L92.4766 72.4928H92.4728L92.4197 69.269L93.9536 68.3452L94.5839 68.695L93.05 69.6188Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9713 73.5192L94.9144 70.2954L95.5409 70.6414L95.5447 70.6452L95.6016 73.8689L94.0677 74.7927L93.4336 74.443L94.9713 73.5192Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1934 70.0066L91.2503 73.2266L92.4995 73.9223L92.5564 77.146L93.1753 76.7773L93.126 73.9146L93.1184 73.5497L91.8692 72.8578L91.8123 69.634L91.1934 70.0066Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2502 73.2266V73.2304L92.4994 73.9261",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2954 69.9495L94.3524 73.1771L94.041 73.3634L93.7297 73.1885L93.7259 73.1847L93.6689 69.9609L93.9803 69.7747L94.284 69.9457L94.2954 69.9495Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8691 72.8579L93.1183 73.5498",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3974 73.2608L89.4543 76.4846L88.8278 76.1387L88.824 76.1349L88.7671 72.9111L90.301 71.9873L90.9313 72.3371L89.3974 73.2608Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3186 77.1613L91.2617 73.9375L91.8919 74.2872L91.9489 77.511L90.415 78.4348L89.7847 78.0851L91.3186 77.1613Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6428 73.5953L90.6998 76.8191L90.3884 77.0053L90.0771 76.8305H90.0733L90.0164 73.6029L90.3277 73.4204L90.6314 73.5877L90.6428 73.5953Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9192 69.5618L87.4835 70.4323L87.5974 76.8723L89.1617 77.7428H89.1655L89.7844 77.3703L88.2163 76.4997L88.1593 73.2759L88.1024 70.0598L86.5381 69.1892L86.5343 69.193L85.9192 69.5618Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3815 69.7709L84.4385 72.9946L83.812 72.6449H83.8082L83.7512 69.4173L85.2852 68.4973L85.9154 68.8471L84.3815 69.7709Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3027 73.6713L86.2458 70.4475L86.8761 70.7935L86.8799 70.7973L86.933 74.021L85.3991 74.9448L84.7688 74.5951L86.3027 73.6713Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5249 70.1586L82.5819 73.3786L83.8348 74.0743L83.888 77.298L84.5107 76.9255L84.4575 74.0628L84.4499 73.7017L83.2007 73.0098L83.1438 69.7822L82.5249 70.1586Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5818 73.3787V73.3825L83.8348 74.0744",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.627 70.1016L85.6839 73.3254L85.3726 73.5117L85.0612 73.3406L85.0574 73.3368L85.0005 70.113L85.3118 69.9268L85.6156 70.094L85.627 70.1016Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2009 73.0098L84.4501 73.7017",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.733 73.4127L80.7861 76.6365L80.1596 76.2867H80.1558L80.0989 73.063L81.6366 72.1392L82.2669 72.4889L80.733 73.4127Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6504 77.3131L82.5934 74.0894L83.2237 74.4391H83.2275L83.2845 77.6629L81.7467 78.5867L81.1165 78.2369L82.6504 77.3131Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9745 73.7435L82.0315 76.971L81.7239 77.1573L81.4088 76.9825H81.405L81.3518 73.7549L81.6594 73.5686L81.9631 73.7397L81.9745 73.7435Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2512 69.7139L78.8193 70.5844L78.8725 73.8082L78.8763 73.8044L78.9294 77.0244L80.4975 77.8949L81.1164 77.5224L79.5483 76.6518L79.4914 73.428L79.4344 70.2119L77.8701 69.3413H77.8663L77.2512 69.7139Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7173 69.923L75.7705 73.1467L75.144 72.797H75.1402L75.0833 69.5694L76.621 68.6494L77.2513 68.9992L75.7173 69.923Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6348 73.8235L77.5816 70.5959L78.2081 70.9457L78.2119 70.9495L78.2688 74.1733L76.7311 75.0971L76.1008 74.7473L77.6348 73.8235Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8606 70.3069L73.9138 73.5306L75.1667 74.2263L75.2237 77.4501L75.8426 77.0776L75.7856 73.8538L74.5326 73.1619L74.4757 69.9343L73.8606 70.3069Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9138 73.5308V73.5346L75.1668 74.2303",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9589 70.2537L77.0158 73.4775L76.7083 73.6638L76.3931 73.4927L76.3893 73.4889L76.3362 70.2651L76.6437 70.0789L76.9475 70.2461L76.9589 70.2537Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5325 73.158L75.7854 73.8537",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0645 73.5648L72.1214 76.7886L71.4912 76.4388H71.4874L71.4304 73.215L72.9681 72.2913L73.5984 72.641L72.0645 73.5648Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9857 77.4652L73.9288 74.2415L74.5553 74.5874L74.5591 74.5912L74.616 77.815L73.0783 78.7388L72.448 78.389L73.9857 77.4652Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3098 73.8956L73.363 77.1231L73.0554 77.3094L72.7441 77.1346L72.7403 77.1308L72.6833 73.907L72.9909 73.7207L73.2984 73.8918L73.3098 73.8956Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5828 69.866L70.1509 70.7327L70.2648 77.1765L71.8291 78.047L72.448 77.6707L70.8837 76.8039L70.8267 73.5763L70.7698 70.364L69.2017 69.4934L68.5828 69.866Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9701 73.9754L68.9132 70.7478L69.5396 71.0976H69.5434L69.6004 74.3251L68.0665 75.2489L67.4324 74.8992L68.9701 73.9754Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.535 77.91L110.592 81.1338L109.961 80.784H109.957L109.904 77.5603L111.438 76.6365L112.069 76.9862L110.535 77.91Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.456 81.8104L112.399 78.5867L113.025 78.9364H113.029L113.086 82.1602L111.552 83.084L110.918 82.7342L112.456 81.8104Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.678 78.2979L108.735 81.5178L109.984 82.2135L110.041 85.4411L110.66 85.0685L110.611 82.2059L110.603 81.841L109.354 81.1491L109.297 77.9253L108.678 78.2979Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.735 81.5178V81.5216L109.984 82.2173",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.354 81.1492L110.603 81.8411",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.882 81.5521L106.939 84.7797L106.309 84.4299V84.4261L106.252 81.2024L107.786 80.2786L108.416 80.6321L106.882 81.5521Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.803 85.4525L108.746 82.2288L109.377 82.5785L109.434 85.8061L107.9 86.7261L107.266 86.3801L108.803 85.4525Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.128 81.8865L108.185 85.1103L107.873 85.2966L107.562 85.1217H107.558L107.501 81.8979L107.813 81.7117L108.116 81.8789L108.128 81.8865Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.404 77.853L104.969 78.7236L105.083 85.1635L106.647 86.0341H106.651L107.27 85.6615L105.701 84.791L105.644 81.5672L105.587 78.351L104.023 77.4805V77.4843H104.019L103.404 77.853Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.866 78.0621L101.923 81.2859L101.297 80.9361H101.293L101.236 77.7124L102.77 76.7886L103.4 77.1383L101.866 78.0621Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.788 81.9625L103.731 78.7388L104.361 79.0885L104.418 82.3123L102.884 83.2361L102.254 82.8863L103.788 81.9625Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.01 78.4499L100.067 81.6737L101.316 82.3656L101.373 85.5894L101.992 85.2206L101.942 82.3542L101.935 81.993L100.686 81.3012L100.629 78.0774L100.01 78.4499Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.067 81.6736L101.316 82.3693",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.112 78.3929L103.169 81.6205L102.857 81.8067L102.546 81.6319H102.542L102.485 78.4043L102.797 78.218L103.1 78.3891L103.112 78.3929Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.686 81.3013L101.935 81.9932",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2138 81.7042L98.2707 84.928L97.6442 84.582L97.6404 84.5782L97.5835 81.3545L99.1174 80.4307L99.7515 80.7804L98.2138 81.7042Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.135 85.6046L100.078 82.3809L100.708 82.7306H100.712L100.765 85.9582L99.2314 86.8782L98.6011 86.5284L100.135 85.6046Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4593 82.0386L99.5162 85.2624L99.2049 85.4487L98.8935 85.2738H98.8897L98.8328 82.0463L99.1441 81.8638L99.4479 82.031L99.4593 82.0386Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7361 78.0051L96.3004 78.8757L96.3574 82.0995H96.3611L96.4143 85.3156L97.9824 86.1862L98.6013 85.8136L97.0332 84.9431L96.9762 81.7193L96.9193 78.5031L95.355 77.6326L95.3512 77.6364L94.7361 78.0051Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2022 78.2142L93.2553 81.438L92.6289 81.0882H92.6251L92.5681 77.8645L94.1059 76.9407L94.7361 77.2904L93.2022 78.2142Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1196 82.1146L95.0627 78.8909L95.693 79.2368L95.6968 79.2406L95.7537 82.4644L94.216 83.3882L93.5857 83.0384L95.1196 82.1146Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3455 78.602L91.3986 81.822L92.6516 82.5177L92.7085 85.7415L93.3274 85.3727L93.2743 82.5101L93.2667 82.1452L92.0175 81.4533L91.9606 78.2295L91.3455 78.602Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3987 81.822V81.8258L92.6517 82.5215",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4437 78.545L94.5007 81.7688L94.1931 81.9588L93.878 81.784L93.8742 81.7802L93.821 78.5564L94.1286 78.3701L94.4323 78.5412L94.4437 78.545Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0173 81.4534L93.2665 82.1453",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5494 81.8563L89.6063 85.0801L88.976 84.7303H88.9722L88.9153 81.5066L90.453 80.5828L91.0833 80.9325L89.5494 81.8563Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4668 85.7567L91.4136 82.533L92.0401 82.8827H92.0439L92.1009 86.1065L90.5631 87.0303L89.9329 86.6805L91.4668 85.7567Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7947 82.1871L90.8479 85.4146L90.5403 85.6009L90.2252 85.4261L90.1682 82.1985L90.4758 82.0122L90.7795 82.1833L90.7947 82.1871Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0676 78.1572L87.6357 79.0278L87.7459 85.4677L89.314 86.3383L89.9328 85.9657L88.3685 85.0952L88.3116 81.8714L88.2546 78.6552L86.6865 77.7847L86.6827 77.7885L86.0676 78.1572Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5337 78.3663L84.5907 81.5901L83.9604 81.2403H83.9566L83.8997 78.0128L85.4374 77.0928L86.0677 77.4425L84.5337 78.3663Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.455 82.2669L86.398 79.0393L87.0245 79.3891L87.0283 79.3929L87.0853 82.6166L85.5475 83.5404L84.9172 83.1907L86.455 82.2669Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.677 78.7502L82.734 81.974L83.9831 82.6697L84.0401 85.8935L84.659 85.5209L84.6096 82.6583L84.602 82.2971L83.3528 81.6053L83.2959 78.3777L82.677 78.7502Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7339 81.9741V81.9779L83.9831 82.6698",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7791 78.6971L85.8322 81.9209L85.5247 82.1071L85.2133 81.9361L85.2095 81.9323L85.1526 78.7085L85.4601 78.5222L85.7677 78.6895L85.7791 78.6971Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.353 81.6013L84.6022 82.297",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8813 82.0082L80.9382 85.2319L80.3079 84.8822H80.3041L80.251 81.6584L81.7849 80.7346L82.4152 81.0844L80.8813 82.0082Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8024 85.9086L82.7454 82.6848L83.3719 83.0308L83.3757 83.0346L83.4327 86.2583L81.8987 87.1821L81.2646 86.8324L82.8024 85.9086Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1267 82.3389L82.1837 85.5665L81.8723 85.7528L81.561 85.5779L81.5572 85.5741L81.5002 82.3503L81.8116 82.1641L82.1153 82.3351L82.1267 82.3389Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3994 78.3093L78.9675 79.1799L79.0245 82.4037V82.3999L79.0814 85.6198L80.6457 86.4904L81.2646 86.1178L79.7003 85.2473L79.6434 82.0197L79.5864 78.8073L78.0183 77.9368L77.3994 78.3093Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8654 78.5146L75.9223 81.7422L75.2921 81.3924L75.2883 81.3886L75.2351 78.1649L76.769 77.2449L77.3993 77.5946L75.8654 78.5146Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7868 82.419L77.7298 79.1914L78.3601 79.5412L78.417 82.7687L76.8831 83.6925L76.249 83.3428L77.7868 82.419Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0088 78.9023L74.0657 82.1261L75.3149 82.8218L75.3719 86.0456L75.9908 85.673L75.9338 82.4492L74.6846 81.7574L74.6277 78.5298L74.0088 78.9023Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0657 82.1262L75.3148 82.8257",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1109 78.8492L77.1678 82.073L76.8565 82.2592L76.5451 82.0844H76.5413L76.4844 78.8606L76.7957 78.6743L77.0995 78.8416L77.1109 78.8492Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6846 81.7534L75.9337 82.4491",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2128 82.1603L72.2698 85.384L71.6433 85.0343H71.6395L71.5825 81.8105L73.1165 80.8867L73.7467 81.2365L72.2128 82.1603Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.134 86.0607L74.0771 82.8369L74.7074 83.1829L74.7112 83.1867L74.7643 86.4104L73.2304 87.3342L72.6001 86.9845L74.134 86.0607Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4583 82.491L73.5152 85.7148L73.2039 85.9049L72.8925 85.73L72.8887 85.7262L72.8318 82.5024L73.1431 82.3162L73.4469 82.4834L73.4583 82.491Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7349 78.4614L70.2992 79.3282L70.4131 85.7719L71.9774 86.6387H71.9812L72.6001 86.2661L71.032 85.3994L70.975 82.1718L70.9181 78.9594L69.3538 78.0889H69.35L68.7349 78.4614Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1184 82.567L69.0615 79.3433L69.6917 79.693H69.6955L69.7487 82.9206L68.2148 83.8406L67.5845 83.4908L69.1184 82.567Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.683 86.5055L110.739 89.7292L110.113 89.3795H110.109L110.052 86.1557L111.586 85.2319L112.216 85.5817L110.683 86.5055Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.604 90.4059L112.547 87.1821L113.177 87.5319H113.181L113.234 90.7557L111.7 91.6794L111.07 91.3297L112.604 90.4059Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.826 86.8933L108.883 90.1133L110.136 90.809L110.193 94.0365L110.808 93.664L110.759 90.8014L110.751 90.4364L109.502 89.7445L109.445 86.5208L108.826 86.8933Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.883 90.1133V90.1171L110.136 90.8128",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.502 89.7446L110.751 90.4365",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.034 90.1476L107.087 93.3713L106.461 93.0254L106.457 93.0216L106.4 89.7978L107.938 88.874L108.568 89.2238L107.034 90.1476Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.951 94.048L108.898 90.8242L109.525 91.174H109.529L109.585 94.4015L108.048 95.3215L107.417 94.9718L108.951 94.048Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.276 90.482L108.332 93.7058L108.025 93.8921L107.71 93.7172H107.706L107.653 90.4934L107.96 90.3071L108.264 90.4744L108.276 90.482Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.552 86.4485L105.12 87.3191L105.23 93.759L106.799 94.6296L107.417 94.257L105.849 93.3864L105.796 90.1627L105.739 86.9465L104.171 86.0759L104.167 86.0797L103.552 86.4485Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.018 86.6576L102.075 89.8813L101.445 89.5316H101.441L101.384 86.3078L102.922 85.384L103.552 85.7338L102.018 86.6576Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.936 90.558L103.883 87.3342L104.509 87.6802L104.513 87.684L104.57 90.9077L103.032 91.8315L102.402 91.4818L103.936 90.558Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.162 87.0454L100.219 90.2692L101.468 90.9611L101.525 94.1848L102.144 93.8161L102.09 90.9497L102.087 90.5885L100.834 89.8966L100.781 86.6729L100.162 87.0454Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.219 90.269L101.468 90.9647",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.26 86.9884L103.317 90.2159L103.009 90.4022L102.694 90.2273V90.2235L102.637 86.9998L102.945 86.8135L103.248 86.9846L103.26 86.9884Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.833 89.8967L102.086 90.5886",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3655 90.2997L98.4225 93.5234L97.7922 93.1775L97.7884 93.1737L97.7314 89.9499L99.2692 89.0261L99.8995 89.3759L98.3655 90.2997Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.287 94.2001L100.23 90.9763L100.856 91.3261H100.86L100.917 94.5498L99.3831 95.4736L98.749 95.1239L100.287 94.2001Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6109 90.6304L99.6678 93.858L99.3565 94.0443L99.0451 93.8694H99.0413L98.9844 90.6418L99.2957 90.4556L99.5995 90.6266L99.6109 90.6304Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.884 86.6006L96.4521 87.4712L96.5091 90.6949L96.5661 93.9111L98.1304 94.7817L98.7492 94.4091L97.1849 93.5385L97.128 90.3148L97.071 87.0986L95.5029 86.228V86.2318L94.884 86.6006Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.35 86.8097L93.407 90.0334L92.7767 89.6837H92.7729L92.7197 86.4561L94.2537 85.5361L94.8839 85.8859L93.35 86.8097Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2714 90.7102L95.2144 87.4827L95.8409 87.8324L95.8447 87.8362L95.9017 91.06L94.3677 91.9838L93.7336 91.634L95.2714 90.7102Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4934 87.1974L91.5504 90.4174L92.7995 91.1131L92.8565 94.3368L93.4754 93.9643L93.426 91.1055L93.4184 90.7405L92.1693 90.0486L92.1123 86.821L91.4934 87.1974Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5503 90.4175V90.4213L92.7995 91.117",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5955 87.1404L94.6524 90.3642L94.3411 90.5505L94.0297 90.3794L94.0259 90.3756L93.969 87.1519L94.2803 86.9656L94.5841 87.1328L94.5955 87.1404Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1692 90.0486L93.4184 90.7405",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6974 90.4515L89.7544 93.6753L89.1241 93.3255L89.0671 90.1018L90.6011 89.178L91.2314 89.5277L89.6974 90.4515Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6185 94.3519L91.5616 91.1282L92.1919 91.4779L92.2488 94.7017L90.7149 95.6255L90.0808 95.2757L91.6185 94.3519Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9429 90.7823L90.9998 94.0099L90.6885 94.1961L90.3772 94.0213H90.3734L90.3164 90.7937L90.6278 90.6074L90.9315 90.7785L90.9429 90.7823Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2195 86.7527L87.7838 87.6233L87.8977 94.0632L89.462 94.9338H89.4658L90.0847 94.5612L88.5166 93.6906L88.4596 90.4669L88.4027 87.2507L86.8384 86.3801H86.8346L86.2195 86.7527Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6816 86.958L84.7385 90.1855L84.112 89.8358L84.1082 89.832L84.0513 86.6082L85.5852 85.6882L86.2155 86.038L84.6816 86.958Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6028 90.8623L86.5458 87.6348L87.1761 87.9845V87.9883L87.2331 91.2121L85.6991 92.1359L85.0688 91.7861L86.6028 90.8623Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.825 87.3457L82.8819 90.5695L84.1349 91.2652L84.188 94.4889L84.8069 94.1164L84.7576 91.2538L84.75 90.8926L83.5008 90.2007L83.4438 86.9731L82.825 87.3457Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8818 90.5696V90.5734L84.1348 91.2653",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.927 87.2925L85.984 90.5163L85.6726 90.7026L85.3613 90.5315L85.3575 90.5277L85.3005 87.304L85.6119 87.1177L85.9156 87.2849L85.927 87.2925Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.501 90.1968L84.7502 90.8925",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0292 90.6036L81.0862 93.8274L80.4597 93.4776H80.4559L80.3989 90.2539L81.9329 89.3301L82.5669 89.6798L81.0292 90.6036Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9504 94.504L82.8935 91.2803L83.5238 91.6262L83.5276 91.63L83.5807 94.8538L82.0468 95.7776L81.4165 95.4278L82.9504 94.504Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2745 90.9344L82.3315 94.162L82.0239 94.3482L81.7088 94.1734L81.705 94.1696L81.6519 90.9458L81.9594 90.7595L82.2632 90.9306L82.2745 90.9344Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5513 86.9048L79.1194 87.7716L79.1725 90.9991L79.1763 90.9953L79.2295 94.2153L80.7976 95.0859L81.4165 94.7095L79.8484 93.8427L79.7914 90.6152L79.7345 87.4028L78.1702 86.5322H78.1664L77.5513 86.9048Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0174 87.11L76.0705 90.3375L75.4441 89.9878L75.4403 89.984L75.3833 86.7602L76.921 85.8364L77.5513 86.19L76.0174 87.11Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9348 91.0104L77.8779 87.7866L78.5081 88.1364H78.5119L78.5689 91.3639L77.0312 92.2839L76.4009 91.938L77.9348 91.0104Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1606 87.4978L74.2138 90.7216L75.4668 91.4173L75.5237 94.641L76.1426 94.2685L76.0857 91.0447L74.8327 90.3528L74.7757 87.1252L74.1606 87.4978Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2139 90.7214L75.4668 91.4171",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2589 87.4444L77.3159 90.6682L77.0083 90.8544L76.6932 90.6796H76.6894L76.6362 87.4558L76.9438 87.2695L77.2475 87.4368L77.2589 87.4444Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8325 90.3489L76.0855 91.0446",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3645 90.7557L72.4215 93.9795L71.7912 93.6297H71.7874L71.7305 90.4022L73.2682 89.4822L73.8985 89.8319L72.3645 90.7557Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.282 94.6563L74.2288 91.4287L74.8553 91.7785L74.8591 91.7823L74.9161 95.006L73.3783 95.9298L72.748 95.5801L74.282 94.6563Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6099 91.0865L73.663 94.3103L73.3555 94.4965L73.0403 94.3255V94.3217L72.9834 91.0979L73.2909 90.9116L73.5985 91.0789L73.6099 91.0865Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8828 87.0569L70.4509 87.9237L70.5648 94.3636L72.1291 95.2342L72.748 94.8616L71.1837 93.9948L71.1268 90.7673L71.0698 87.5511L69.5017 86.6843L68.8828 87.0569Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3489 87.2621L67.4059 90.4858L66.7756 90.1399L66.7718 90.1361L66.7148 86.9123L68.2526 85.9885L68.8829 86.3383L67.3489 87.2621Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2702 91.1625L69.2132 87.9387L69.8397 88.2885H69.8435L69.9004 91.516L68.3627 92.436L67.7324 92.0863L69.2702 91.1625Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.835 95.1009L110.891 98.3247L110.261 97.975H110.257L110.2 94.7512L111.738 93.8274L112.368 94.1771L110.835 95.1009Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.978 95.4888L109.035 98.7087L110.284 99.4044L110.341 102.628L110.96 102.259L110.907 99.3968L110.903 99.0319L109.654 98.34L109.597 95.1162L108.978 95.4888Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.035 98.7087V98.7125L110.284 99.4082",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.654 98.3401L110.903 99.032",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.182 98.743L107.239 101.967L106.609 101.621L106.605 101.617L106.552 98.3933L108.086 97.4695L108.716 97.8192L107.182 98.743Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.103 102.643L109.046 99.4197L109.673 99.7694H109.676L109.733 102.993L108.2 103.917L107.565 103.567L109.103 102.643Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.428 99.0775L108.484 102.301L108.173 102.488L107.862 102.313H107.858L107.801 99.0851L108.112 98.9026L108.416 99.0699L108.428 99.0775Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.704 95.0439L105.268 95.9145L105.382 102.354L106.946 103.225L107.569 102.852L106.001 101.982L105.944 98.7581L105.887 95.542L104.323 94.6714H104.319V94.6752L103.704 95.0439Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.166 95.253L102.223 98.4768L101.593 98.1271L101.536 94.9033L103.07 93.9795L103.7 94.3292L102.166 95.253Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.088 99.1535L104.031 95.9297L104.661 96.2756V96.2794L104.718 99.5032L103.184 100.427L102.55 100.077L104.088 99.1535Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.31 95.6408L100.367 98.8607L101.616 99.5564L101.673 102.78L102.292 102.408L102.242 99.545L102.235 99.1839L100.985 98.492L100.928 95.2644L100.31 95.6408Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.366 98.8608V98.8646L101.616 99.5603",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.412 95.5838L103.469 98.8076L103.157 98.9977L102.846 98.8228L102.842 98.819L102.785 95.5952L103.097 95.4089L103.4 95.5762L103.412 95.5838Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.985 98.4922L102.235 99.1841",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5136 98.8951L98.5705 102.119L97.9441 101.769H97.9403L97.8833 98.5454L99.4172 97.6216L100.048 97.9713L98.5136 98.8951Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.435 102.796L100.378 99.5718L101.008 99.9215H101.012L101.065 103.145L99.5312 104.069L98.9009 103.719L100.435 102.796Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7591 99.2259L99.816 102.453L99.5047 102.64L99.1933 102.465H99.1895L99.1326 99.2373L99.4439 99.051L99.7477 99.2221L99.7591 99.2259Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0359 95.196L96.6002 96.0666L96.6572 99.2904L96.661 99.2866L96.7141 102.507L98.2822 103.377L98.9011 103.005L97.333 102.134L97.276 98.9102L97.2191 95.6941L95.6548 94.8235H95.651L95.0359 95.196Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.498 95.4051L93.5549 98.6289L92.9284 98.2792H92.9246L92.8677 95.0516L94.4016 94.1316L95.0357 94.4813L93.498 95.4051Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4192 99.3057L95.3622 96.0781L95.9925 96.4279L95.9963 96.4317L96.0495 99.6554L94.5155 100.579L93.8853 100.229L95.4192 99.3057Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6414 95.7891L91.6983 99.0128L92.9513 99.7085L93.0082 102.932L93.6233 102.56L93.574 99.6971L93.5664 99.336L92.3172 98.6441L92.2602 95.4165L91.6414 95.7891Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6982 99.0129V99.0167L92.9512 99.7124",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7433 95.7359L94.8002 98.9597L94.4927 99.146L94.1776 98.9749L94.1738 98.9711L94.1206 95.7473L94.4282 95.561L94.7319 95.7283L94.7433 95.7359Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3171 98.6404L93.5663 99.3361",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8492 99.0472L89.9023 102.271L89.2758 101.921H89.272L89.2151 98.6975L90.7528 97.7737L91.3831 98.1234L89.8492 99.0472Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7666 102.948L91.7135 99.7239L92.3399 100.07L92.3437 100.074L92.4007 103.297L90.8629 104.221L90.2327 103.871L91.7666 102.948Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0907 99.378L91.1477 102.606L90.8401 102.792L90.525 102.617V102.613L90.468 99.3894L90.7756 99.2031L91.0793 99.3742L91.0907 99.378Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3674 95.3481L87.9355 96.2149L88.0456 102.659L89.6138 103.529L90.2326 103.153L88.6683 102.286L88.6114 99.0585L88.5544 95.8462L86.9863 94.9756H86.9825L86.3674 95.3481Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8335 95.5534L84.8905 98.781L84.2602 98.4313L84.2564 98.4274L84.1995 95.2037L85.7372 94.2837L86.3675 94.6334L84.8335 95.5534Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.751 99.4578L86.6978 96.2302L87.3243 96.58H87.3281L87.3851 99.8075L85.8473 100.731L85.217 100.382L86.751 99.4578Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9768 95.9412L83.0338 99.1649L84.2829 99.8606L84.3399 103.084L84.9588 102.712L84.9056 99.8492L84.9018 99.4881L83.6527 98.7962L83.5957 95.5686L82.9768 95.9412Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0337 99.165L84.2829 99.8607",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0789 95.888L86.132 99.1118L85.8245 99.2981L85.5093 99.1232L85.4524 95.8994L85.7599 95.7131L86.0675 95.8804L86.0789 95.888Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6528 98.7922L84.902 99.4879",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1811 99.1991L81.238 102.423L80.6077 102.073H80.6039L80.5508 98.8455L82.0847 97.9255L82.715 98.2753L81.1811 99.1991Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1022 103.1L83.0452 99.8757L83.6717 100.222L83.6755 100.225L83.7325 103.449L82.1985 104.373L81.5645 104.023L83.1022 103.1Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4265 99.5299L82.4835 102.754L82.1721 102.94L81.8608 102.769L81.857 102.765L81.8 99.5413L82.1114 99.355L82.4151 99.5223L82.4265 99.5299Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6992 95.5002L79.2673 96.367L79.3243 99.5908L79.3812 102.811L80.9455 103.678L81.5644 103.305L80.0001 102.438L79.9432 99.2106L79.8862 95.9982L78.3181 95.1277L77.6992 95.5002Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1652 95.7054L76.2221 98.9292L75.5919 98.5833L75.5881 98.5794L75.5349 95.3557L77.0688 94.4319L77.6991 94.7816L76.1652 95.7054Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0866 99.6059L78.0296 96.3821L78.6561 96.7318H78.6599L78.7168 99.9594L77.1829 100.879L76.5488 100.53L78.0866 99.6059Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3086 96.0933L74.3655 99.317L75.6147 100.009L75.6717 103.236L76.2906 102.864L76.2336 99.6402L74.9844 98.9445L74.9275 95.7207L74.3086 96.0933Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3655 99.3169L75.6146 100.013",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4107 96.0399L77.4676 99.2636L77.1563 99.4499L76.8449 99.275H76.8411L76.7842 96.0513L77.0955 95.865L77.3993 96.0323L77.4107 96.0399Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9844 98.9443L76.2335 99.64",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5126 99.3512L72.5696 102.575L71.9431 102.225H71.9393L71.8823 98.9976L73.4163 98.0776L74.0465 98.4274L72.5126 99.3512Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4338 103.252L74.3769 100.024L75.0072 100.374V100.378L75.0641 103.601L73.5302 104.525L72.8999 104.176L74.4338 103.252Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7581 99.682L73.815 102.906L73.5037 103.092L73.1923 102.921L73.1885 102.917L73.1316 99.6934L73.4429 99.5071L73.7467 99.6744L73.7581 99.682Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0347 95.6522L70.599 96.519L70.7129 102.959L72.2772 103.83H72.281L72.8999 103.457L71.3318 102.59L71.2748 99.3626L71.2179 96.1465L69.6536 95.2759V95.2797H69.6498L69.0347 95.6522Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.497 95.8575L67.5539 99.0813L66.9275 98.7354L66.9237 98.7315L66.8667 95.5078L68.4006 94.584L69.0309 94.9337L67.497 95.8575Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4182 99.758L69.3613 96.5342L69.9915 96.8839H69.9953L70.0485 100.108L68.5146 101.031L67.8843 100.682L69.4182 99.758Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.983 103.696L111.04 106.92L110.413 106.57H110.409L110.352 103.347L111.886 102.423L112.517 102.773L110.983 103.696Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.852 103.639L105.42 104.51L105.531 110.95L107.099 111.82L107.718 111.448L106.149 110.577L106.096 107.354L106.039 104.137L104.471 103.267L104.467 103.271L103.852 103.639Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.318 103.848L102.372 107.072L101.745 106.723H101.741L101.684 103.495L103.222 102.575L103.852 102.925L102.318 103.848Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1841 103.791L96.7522 104.662L96.8091 107.886V107.882L96.8661 111.102L98.4304 111.973L99.0493 111.6L97.485 110.729L97.428 107.502L97.3711 104.29L95.803 103.419H95.7992L95.1841 103.791Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6502 103.997L93.7071 107.224L93.0769 106.875L93.0731 106.871L93.0161 103.647L94.5538 102.727L95.1841 103.077L93.6502 103.997Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9816 104.149L85.0386 107.376L84.4083 107.027V107.023L84.3513 103.799L85.8853 102.875L86.5155 103.229L84.9816 104.149Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3134 104.301L76.3703 107.525L75.7439 107.179L75.7401 107.175L75.6831 103.951L77.217 103.027L77.8511 103.377L76.3134 104.301Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.649 104.453L67.7059 107.677L67.0756 107.327H67.0718L67.0149 104.103L68.5526 103.179L69.1829 103.529L67.649 104.453Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  })))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9199 81.6016C58.9199 81.6016 81.5341 64.8631 84.0249 62.9128C86.8953 60.6661 98.8061 52.3481 99.7667 53.1959C100.724 54.0437 103.359 58.3737 99.6338 63.3082C95.9091 68.2427 93.0007 70.4704 93.0007 70.4704L85.2437 74.0744L63.1345 88.2316L59.1895 82.0235L58.9199 81.6016Z",
    fill: "#09363F"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M107.41 82.434C107.41 82.434 107.368 82.4873 107.277 82.5747C107.186 82.6621 107.049 82.7876 106.867 82.9473C106.506 83.2628 105.978 83.7228 105.268 84.2132C104.562 84.6998 103.655 85.2434 102.523 85.4981C101.392 85.7719 100.078 85.6008 98.8403 85.1484C96.3686 84.2208 94.3334 82.9511 92.94 81.9436C92.2414 81.438 91.706 80.997 91.3415 80.6815C91.1593 80.5256 91.0226 80.3964 90.9315 80.3089C90.8403 80.2215 90.7948 80.1721 90.7986 80.1683C90.8099 80.1569 91.0188 80.3203 91.3947 80.6169C91.7744 80.9096 92.3211 81.3354 93.0273 81.8182C94.4322 82.7838 96.4749 84.0231 98.9125 84.9393C100.131 85.3803 101.384 85.5476 102.478 85.2967C103.571 85.061 104.467 84.5439 105.177 84.0801C105.891 83.6087 106.43 83.1716 106.806 82.875C107.182 82.5785 107.391 82.415 107.402 82.4264L107.41 82.434Z",
    fill: "#375A64"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M108.443 81.2214C108.443 81.2214 108.389 81.1415 108.31 80.9781C108.222 80.7956 108.109 80.5561 107.964 80.2634C107.672 79.6399 107.254 78.7351 106.81 77.587C106.373 76.4389 105.899 75.0361 105.667 73.4129C105.417 71.7896 105.534 69.9762 105.77 68.1134C106.009 66.2506 106.271 64.4829 106.499 62.871C106.742 61.2667 106.882 59.8031 107.228 58.6056C107.562 57.4043 108.188 56.5565 108.731 56.1231C109.001 55.9026 109.24 55.7734 109.403 55.6973C109.487 55.6593 109.551 55.6365 109.597 55.6213C109.642 55.6061 109.665 55.6023 109.665 55.6061C109.68 55.6289 109.297 55.7392 108.784 56.1878C108.272 56.6287 107.683 57.4651 107.376 58.6474C107.057 59.8221 106.931 61.2933 106.696 62.8976C106.476 64.5095 106.237 66.281 105.986 68.1362C105.751 69.9914 105.629 71.7782 105.865 73.3786C106.085 74.9791 106.537 76.3781 106.954 77.5262C107.38 78.6743 107.774 79.5905 108.044 80.2216C108.169 80.5219 108.272 80.7652 108.352 80.9515C108.42 81.1187 108.45 81.21 108.446 81.2138L108.443 81.2214Z",
    fill: "#375A64"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5071 98.4313C92.5071 98.4313 92.4084 98.4845 92.2147 98.572C91.9983 98.6632 91.7136 98.7811 91.3567 98.9331C90.5859 99.2449 89.5114 99.682 88.1939 100.218C86.8498 100.754 85.2551 101.393 83.4895 102.096C83.0415 102.26 82.6087 102.484 82.0923 102.586C81.8379 102.632 81.5493 102.632 81.2911 102.522C81.033 102.415 80.8241 102.229 80.6381 102.047C79.9053 101.309 79.1535 100.541 78.4093 99.7277C75.4174 96.4887 73.0253 93.2763 71.4231 90.8775C70.6181 89.68 70.0106 88.6802 69.593 87.9883C69.3993 87.6537 69.2437 87.3838 69.1298 87.1823C69.0272 86.9961 68.9741 86.8972 68.9817 86.8934C68.9893 86.8896 69.0538 86.9809 69.1677 87.1595C69.293 87.3572 69.4601 87.6157 69.6689 87.9427C70.1093 88.6193 70.7358 89.604 71.556 90.7863C73.1886 93.1585 75.592 96.3442 78.5764 99.5756C79.3168 100.385 80.0685 101.153 80.7937 101.891C80.976 102.069 81.1621 102.233 81.3747 102.324C81.5873 102.412 81.8265 102.419 82.0581 102.377C82.5251 102.29 82.9732 102.066 83.4174 101.906C85.1905 101.218 86.7852 100.598 88.1369 100.074C89.4658 99.5642 90.5517 99.1498 91.3263 98.8533C91.687 98.7202 91.9793 98.6138 92.1996 98.534C92.4008 98.4617 92.5071 98.4275 92.5071 98.4351V98.4313Z",
    fill: "#375A64"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M107.379 81.2291C107.368 81.2101 107.547 81.115 107.79 81.2823C107.903 81.3697 107.995 81.556 107.93 81.7575C107.865 81.9742 107.6 82.0844 107.383 82.0236C107.155 81.9704 107.004 81.7727 106.985 81.5712C106.966 81.3659 107.091 81.1949 107.231 81.1378C107.379 81.0808 107.497 81.1302 107.558 81.1797C107.619 81.2291 107.626 81.2747 107.615 81.2823C107.6 81.3051 107.467 81.1835 107.3 81.2785C107.228 81.3203 107.167 81.4344 107.186 81.5446C107.201 81.6549 107.307 81.7803 107.436 81.8069C107.573 81.8411 107.706 81.7841 107.74 81.6853C107.782 81.5826 107.748 81.461 107.683 81.3963C107.547 81.2519 107.376 81.2595 107.379 81.2291Z",
    fill: "#375A64"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0154 87.0758C88.0154 87.0758 87.9205 86.9884 87.7838 86.8059C87.6471 86.6234 87.4573 86.3497 87.2409 86.0037C86.8042 85.3119 86.2613 84.3158 85.7905 83.1563C85.3196 81.9968 85.0159 80.902 84.845 80.1036C84.7615 79.7045 84.7045 79.3775 84.6742 79.1494C84.6438 78.9213 84.6362 78.7959 84.6514 78.7921C84.6856 78.7845 84.7881 79.2787 84.9969 80.0656C85.2019 80.8526 85.5285 81.9246 85.9955 83.0727C86.4625 84.217 86.9751 85.2168 87.3738 85.9239C87.7724 86.631 88.042 87.0568 88.0116 87.0758H88.0154Z",
    fill: "#375A64"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5668 86.825C90.5668 86.825 90.4605 86.7299 90.301 86.5323C90.1416 86.3346 89.9213 86.0419 89.6556 85.6769C89.1278 84.9432 88.4406 83.8939 87.7609 82.6926C87.0813 81.4875 86.5421 80.3584 86.1852 79.5259C86.0068 79.1115 85.8701 78.7694 85.7827 78.5299C85.6954 78.2904 85.6536 78.1573 85.6688 78.1535C85.6992 78.1421 85.9346 78.6477 86.3257 79.4613C86.7168 80.2748 87.2787 81.3849 87.9508 82.5862C88.6266 83.7837 89.2911 84.8367 89.7809 85.5933C90.2744 86.3498 90.5858 86.8098 90.5592 86.8326L90.5668 86.825Z",
    fill: "#375A64"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4928 68.8586C94.508 68.8852 93.9954 69.1855 93.1639 69.6722C92.283 70.1854 91.1591 70.8354 89.9176 71.5578C88.6456 72.2915 87.4914 72.9453 86.6447 73.4015C85.8018 73.8615 85.2512 74.1048 85.2398 74.0744C85.2322 74.0592 85.3613 73.987 85.5929 73.8463C85.8663 73.6829 86.1928 73.489 86.5725 73.2647C87.4534 72.7477 88.5735 72.0938 89.8113 71.3677C91.0832 70.634 92.2413 69.9877 93.0918 69.5353C93.517 69.311 93.8625 69.1323 94.1055 69.0183C94.3485 68.9042 94.4852 68.8472 94.4928 68.8586Z",
    fill: "#375A64"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M117.373 61.4492L115.539 62.4566L115.505 64.0191L116.268 64.6806L117.566 63.3652L117.373 61.4492Z",
    fill: "#3BBFA6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M116.765 64.1711C116.704 64.1483 116.875 63.6692 116.818 63.0724C116.765 62.4755 116.541 62.0155 116.602 61.9851C116.644 61.9547 116.978 62.3919 117.039 63.0534C117.099 63.7187 116.815 64.2053 116.769 64.1749L116.765 64.1711Z",
    fill: "#09363F"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M115.675 64.057C115.675 64.057 115.345 65.6689 114.833 66.1631C112.915 68.0259 111.806 65.1823 110.804 62.5478C109.802 59.9133 109.369 53.9637 106.84 51.9033C104.311 49.8428 101.183 48.4286 98.077 49.6223L96.3418 51.9223L98.9616 52.8727C98.9616 52.8727 103.837 51.162 105.845 55.1651C107.854 59.1644 108.978 66.9805 111.339 68.1057C113.697 69.231 115.038 68.3947 115.801 66.9995C116.564 65.6043 116.773 64.1711 116.773 64.1711L115.683 64.0532L115.675 64.057Z",
    fill: "#30CFB0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M116.796 64.1446C116.834 64.1864 116.568 64.4259 116.146 64.4031C115.941 64.3917 115.763 64.3004 115.668 64.2092C115.569 64.1142 115.543 64.0343 115.565 64.0153C115.615 63.9735 115.827 64.1712 116.162 64.1826C116.492 64.2054 116.765 64.0875 116.796 64.1446Z",
    fill: "#09363F"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M117.225 62.0156C117.225 62.0156 117.278 61.7837 117.418 61.3731L117.49 61.4263C117.058 61.7533 116.325 62.2399 115.315 62.6466C115.06 62.7341 114.81 62.8823 114.46 62.8709C114.286 62.8633 114.111 62.7569 114.009 62.6238C113.902 62.4908 113.834 62.3463 113.758 62.2095C113.458 61.6544 113.147 61.0652 112.832 60.4493C111.56 57.9707 110.595 55.7733 110.197 54.7697L110.227 54.7963C109.824 54.6823 109.608 54.61 109.612 54.5948C109.616 54.5796 109.84 54.6176 110.25 54.7051H110.269L110.28 54.7317C110.751 55.7011 111.761 57.8718 113.029 60.3467C113.348 60.9587 113.656 61.548 113.944 62.1068C114.088 62.3881 114.225 62.658 114.476 62.6695C114.722 62.6885 114.996 62.5554 115.243 62.4718C116.241 62.0916 116.982 61.6392 117.433 61.3465L117.563 61.2628L117.506 61.3997C117.339 61.8027 117.24 62.0156 117.225 62.0118V62.0156Z",
    fill: "#09363F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_35_83672",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 53,
    width: 44,
    height: 36
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9199 81.6016C58.9199 81.6016 81.5341 64.8631 84.0249 62.9128C86.8953 60.6661 98.8061 52.3481 99.7667 53.1959C100.724 54.0437 103.359 58.3737 99.6338 63.3082C95.9091 68.2427 93.0007 70.4704 93.0007 70.4704L85.2437 74.0744L63.1345 88.2316L59.1895 82.0235L58.9199 81.6016Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_35_83672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.055 46.3301L101.624 47.2006L101.68 50.4244V50.4206L101.737 53.6406L103.302 54.5111L103.921 54.1386L102.353 53.268L102.299 50.0443L102.242 46.8281L100.674 45.9575H100.671L100.055 46.3301Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6648 46.9231L96.7218 50.1469L97.9709 50.8426L98.0279 54.0663L98.6468 53.6938L98.5936 50.8312L98.5898 50.47L97.3368 49.7781L97.2837 46.5505L96.6648 46.9231Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8688 50.1813L94.9258 53.405L94.2955 53.0553H94.2917L94.2385 49.8315L95.7725 48.9077L96.4027 49.2575L94.8688 50.1813Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7899 54.0817L96.733 50.8579L97.3595 51.2039L97.3633 51.2077L97.4202 54.4314L95.8863 55.3552L95.2522 55.0055L96.7899 54.0817Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1143 50.512L96.1712 53.7396L95.8599 53.9259L95.5485 53.751L95.5447 53.7472L95.4878 50.5234L95.7991 50.3372L96.1029 50.5082L96.1143 50.512Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3911 46.4824L92.9554 47.3492L93.0693 53.7929L94.6336 54.6635L95.2563 54.2871L93.6882 53.4204L93.6313 50.1928L93.5743 46.9804L92.01 46.1099H92.0062L91.3911 46.4824Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9966 47.0754L88.0535 50.2992L89.3027 50.9949L89.3597 54.2187L89.9786 53.8461L89.9292 50.9835L89.9216 50.6223L88.6724 49.9304L88.6155 46.7029L87.9966 47.0754Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2006 50.3334L86.2575 53.5571L85.6311 53.2074H85.6273L85.5703 49.9798L87.1043 49.0598L87.7345 49.4096L86.2006 50.3334Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1218 54.2339L88.0649 51.0063L88.6952 51.3561V51.3599L88.7521 54.5837L87.2182 55.5075L86.5879 55.1577L88.1218 54.2339Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4461 50.6641L87.503 53.8879L87.1917 54.0742L86.8803 53.9031L86.8765 53.8993L86.8196 50.6755L87.1309 50.4893L87.4347 50.6565L87.4461 50.6641Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7227 46.6345L84.287 47.5013L84.3439 50.7251L84.4009 53.9412L85.969 54.8118L86.5879 54.4392L85.0198 53.5725L84.9628 50.3449L84.9059 47.1287L83.3415 46.262H83.3378L82.7227 46.6345Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3284 47.2275L79.3853 50.4513L80.6383 51.1432L80.6952 54.3708L81.3103 53.9982L81.261 51.1356L81.2534 50.7744L80.0042 50.0787L79.9473 46.855L79.3284 47.2275Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5362 50.4855L77.5893 53.7092L76.9629 53.3595L76.9591 53.3557L76.9021 50.1319L78.4398 49.2119L79.0701 49.5617L77.5362 50.4855Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4536 54.386L79.3967 51.1584L80.0269 51.5082L80.0307 51.512L80.0877 54.7358L78.55 55.6596L77.9197 55.3098L79.4536 54.386Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7777 50.8162L78.8347 54.04L78.5271 54.2263L78.212 54.0552L78.2082 54.0514L78.155 50.8276L78.4626 50.6414L78.7663 50.8086L78.7777 50.8162Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0544 46.7863L75.6226 47.653L75.7327 54.093L77.3008 54.9635L77.9197 54.591L76.3516 53.7242L76.2984 50.4966L76.2414 47.2805L74.6733 46.4099V46.4137H74.6695L74.0544 46.7863Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6638 47.3794L70.7208 50.6032L71.9699 51.2951L72.0269 54.5226L72.6458 54.1501L72.5926 51.2875L72.5888 50.9225L71.3359 50.2306L71.2827 47.0068L70.6638 47.3794Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.868 50.6337L68.9249 53.8612L68.2946 53.5115L68.2908 53.5077L68.2339 50.2839L69.7716 49.3601L70.4019 49.7137L68.868 50.6337Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7892 54.5341L70.7322 51.3103L71.3587 51.6601H71.3625L71.4195 54.8876L69.8817 55.8076L69.2515 55.4617L70.7892 54.5341Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1133 50.9681L70.1665 54.1919L69.8589 54.3781L69.5476 54.2033H69.5438L69.4868 50.9795L69.7944 50.7932L70.1019 50.9605L70.1133 50.9681Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3862 46.9346L66.9543 47.8051L67.0113 51.0289L67.0682 54.2451L68.6326 55.1156L69.2514 54.7431L67.6871 53.8725L67.6302 50.6487L67.5732 47.4326L66.0051 46.562V46.5658H66.0013L65.3862 46.9346Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9956 47.5315L62.0526 50.7515L63.3017 51.4472L63.3587 54.6747L63.9776 54.3022L63.9206 51.0746L62.6714 50.3827L62.6145 47.1589L61.9956 47.5315Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1996 50.7857L60.2566 54.0095L59.6263 53.6636L59.6225 53.6598L59.5693 50.436L61.1033 49.5122L61.7336 49.862L60.1996 50.7857Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1207 54.6862L62.0638 51.4624L62.6941 51.8122L62.751 55.0397L61.2171 55.9597L60.583 55.61L62.1207 54.6862Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4451 51.1202L61.502 54.344L61.1907 54.5302L60.8794 54.3554H60.8756L60.8186 51.1278L61.13 50.9453L61.4337 51.1126L61.4451 51.1202Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7214 47.0867L58.2857 47.9572L58.3997 54.3972L59.964 55.2677H59.9678L60.5867 54.8952L59.0185 54.0246L58.9616 50.8008L58.9046 47.5847L57.3403 46.7141H57.3365V46.7179L56.7214 47.0867Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.207 54.9255L101.771 55.7961L101.828 59.0199V59.0161L101.885 62.236L103.45 63.1066L104.072 62.7341L102.504 61.8635L102.447 58.6359L102.39 55.4235L100.826 54.553H100.822L100.207 54.9255Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6693 55.1308L98.7263 58.3584L98.0998 58.0086L98.096 58.0048L98.0391 54.7811L99.573 53.8611L100.203 54.2108L98.6693 55.1308Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.591 59.0352L100.534 55.8076L101.164 56.1574L101.221 59.3849L99.6869 60.3087L99.0566 59.959L100.591 59.0352Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8127 55.5186L96.8697 58.7423L98.1227 59.438L98.1758 62.6618L98.7947 62.2892L98.7454 59.4266L98.7378 59.0655L97.4886 58.3736L97.4316 55.146L96.8127 55.5186Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8696 58.7424L98.1226 59.4419",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9148 55.4654L99.9718 58.6892L99.6604 58.8754L99.3491 58.7044L99.3453 58.7006L99.2883 55.4768L99.5997 55.2905L99.9034 55.4578L99.9148 55.4654Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4888 58.3699L98.7379 59.0656",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.017 58.7767L95.074 62.0005L94.4475 61.6507H94.4437L94.3867 58.427L95.9207 57.5032L96.5547 57.8529L95.017 58.7767Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9382 62.6771L96.8813 59.4534L97.5116 59.7993L97.5154 59.8031L97.5685 63.0269L96.0346 63.9507L95.4043 63.6009L96.9382 62.6771Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2623 59.1075L96.3193 62.3313L96.0117 62.5213L95.6966 62.3465L95.6928 62.3427L95.6396 59.1189L95.9472 58.9326L96.2509 59.0999L96.2623 59.1075Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5391 55.0779L93.1072 55.9447L93.2173 62.3884L94.7854 63.2552L95.4043 62.8826L93.8362 62.0158L93.783 58.7883L93.7223 55.5759L92.158 54.7053H92.1542L91.5391 55.0779Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0052 55.2831L90.0583 58.5068L89.4318 58.1609L89.428 58.1571L89.3711 54.9333L90.9088 54.0095L91.5391 54.3593L90.0052 55.2831Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9226 59.1835L91.8657 55.9597L92.4959 56.3095H92.4997L92.5567 59.537L91.019 60.457L90.3887 60.1073L91.9226 59.1835Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1484 55.6709L88.2016 58.8947L89.4546 59.5866L89.5115 62.8141L90.1304 62.4416L90.0773 59.579L90.0735 59.2178L88.8205 58.5221L88.7635 55.2983L88.1484 55.6709Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2017 58.8945L89.4546 59.5902",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2467 55.6175L91.3037 58.8413L90.9961 59.0276L90.681 58.8527H90.6772L90.624 55.6289L90.9316 55.4426L91.2353 55.6099L91.2467 55.6175Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8203 58.522L90.0733 59.2177",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3523 58.9288L86.4093 62.1526L85.779 61.8028H85.7752L85.7183 58.5753L87.256 57.6553L87.8863 58.005L86.3523 58.9288Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2698 62.8294L88.2166 59.6018L88.8431 59.9516L88.8469 59.9554L88.9039 63.1791L87.3661 64.1029L86.7358 63.7532L88.2698 62.8294Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5977 59.2596L87.6508 62.4834L87.3433 62.6696L87.0281 62.4986V62.4948L86.9712 59.271L87.2787 59.0847L87.5863 59.252L87.5977 59.2596Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8708 55.2299L84.439 56.0966L84.4959 59.3204L84.5529 62.5366L86.1172 63.4071L86.7361 63.0346L85.168 62.1678L85.1148 58.9402L85.0579 55.7241L83.4897 54.8535V54.8573H83.4859L82.8708 55.2299Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.337 55.4352L81.3939 58.6589L80.7636 58.313L80.7598 58.3092L80.7029 55.0854L82.2406 54.1616L82.8709 54.5114L81.337 55.4352Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2582 59.3356L83.2012 56.1118L83.8277 56.4616H83.8315L83.8885 59.6853L82.3507 60.6091L81.7205 60.2594L83.2582 59.3356Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4802 55.823L79.5372 59.0468L80.7864 59.7387L80.8433 62.9662L81.4622 62.5937L81.409 59.7311L81.4052 59.3661L80.1523 58.6742L80.0991 55.4504L79.4802 55.823Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5371 59.0466L80.7863 59.7423",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5823 55.7696L82.6354 58.9934L82.3279 59.1796L82.0166 59.0048H82.0128L81.9558 55.7772L82.2634 55.5947L82.5709 55.762L82.5823 55.7696Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1521 58.6741L81.4051 59.366",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6842 59.0771L77.7412 62.3047L77.1109 61.9549L77.1071 61.9511L77.054 58.7274L78.5879 57.8074L79.2182 58.1571L77.6842 59.0771Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6054 62.9815L79.5484 59.7539L80.1749 60.1037H80.1787L80.2356 63.3312L78.7017 64.255L78.0676 63.9053L79.6054 62.9815Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9297 59.4117L78.9867 62.6355L78.6753 62.8217L78.364 62.6469H78.3602L78.3032 59.4231L78.6146 59.2368L78.9183 59.4041L78.9297 59.4117Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2063 55.3779L75.7706 56.2485L75.8845 62.6884L77.4488 63.559L78.0715 63.1864L76.5034 62.3159L76.4465 59.0921L76.3895 55.8759L74.8252 55.0054L74.8214 55.0092L74.2063 55.3779Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6684 55.587L72.7253 58.8108L72.095 58.461H72.0912L72.0381 55.2373L73.572 54.3135L74.2023 54.6632L72.6684 55.587Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5897 59.4874L74.5328 56.2637L75.1631 56.6134L75.22 59.8372L73.6861 60.761L73.052 60.4112L74.5897 59.4874Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8118 55.9749L70.8687 59.1986L72.1179 59.8905L72.1748 63.1181L72.7937 62.7455L72.7444 59.8829L72.7368 59.518L71.4876 58.8261L71.4307 55.6023L70.8118 55.9749Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8687 59.1985L72.1178 59.8942",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9138 55.9178L73.9708 59.1454L73.6594 59.3316L73.3481 59.1568H73.3443L73.2874 55.9292L73.5987 55.7429L73.9024 55.914L73.9138 55.9178Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4878 58.8262L72.737 59.5181",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.016 59.2291L69.073 62.4529L68.4465 62.1069L68.4427 62.1031L68.3857 58.8794L69.9197 57.9556L70.55 58.3053L69.016 59.2291Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9373 63.1295L70.8803 59.9058L71.5106 60.2555H71.5144L71.5675 63.4831L70.0336 64.4031L69.4033 64.0533L70.9373 63.1295Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2615 59.5635L70.3184 62.7873L70.0071 62.9736L69.6958 62.7987H69.692L69.635 59.575L69.9464 59.3887L70.2501 59.5559L70.2615 59.5635Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5381 55.53L67.1024 56.4006L67.1594 59.6244L67.2163 62.8405L68.7844 63.7111L69.4033 63.3385L67.8352 62.468L67.7782 59.2442L67.7213 56.028L66.157 55.1575L66.1532 55.1613L65.5381 55.53Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0002 55.7391L64.0571 58.9629L63.4306 58.6131H63.4268L63.3699 55.3894L64.9038 54.4656L65.5341 54.8153L64.0002 55.7391Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9214 59.6395L65.8644 56.4158L66.4947 56.7617L66.4985 56.7655L66.5517 59.9893L65.0177 60.9131L64.3875 60.5633L65.9214 59.6395Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1436 56.127L62.2005 59.3469L63.4535 60.0426L63.5104 63.2664L64.1255 62.8976L64.0724 59.6701L62.8194 58.9782L62.7624 55.7544L62.1436 56.127Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2004 59.3469V59.3507L63.4534 60.0464",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2456 56.0699L65.3026 59.2975L64.9912 59.4837L64.6799 59.3089L64.6761 59.3051L64.6191 56.0813L64.9305 55.895L65.2342 56.0661L65.2456 56.0699Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8193 58.9744L64.0723 59.6701",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3514 59.3812L60.4045 62.605L59.778 62.259L59.7742 62.2552L59.7173 59.0315L61.255 58.1077L61.8853 58.4574L60.3514 59.3812Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2688 63.2816L62.2118 60.0579L62.8421 60.4076H62.8459L62.9029 63.6314L61.3651 64.5552L60.7349 64.2054L62.2688 63.2816Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5929 59.712L61.6499 62.9396L61.3423 63.1258L61.0272 62.951H61.0234L60.9702 59.7234L61.2778 59.5371L61.5815 59.7082L61.5929 59.712Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8696 55.6821L58.4377 56.5527L58.5478 62.9926L60.116 63.8632L60.7349 63.4906L59.1667 62.6201L59.1136 59.3963L59.0566 56.1801L57.4885 55.3096L57.4847 55.3134L56.8696 55.6821Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.355 63.5212L101.923 64.388L101.976 67.6156L101.98 67.6118L102.037 70.8317L103.602 71.7023L104.22 71.3259L102.652 70.4592L102.599 67.2316L102.538 64.0192L100.974 63.1487H100.97L100.355 63.5212Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8213 63.7264L98.8783 66.954L98.248 66.6042L98.2442 66.6004L98.1873 63.3767L99.725 62.4529L100.355 62.8064L98.8213 63.7264Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.739 67.6268L100.686 64.4031L101.312 64.7528H101.316L101.373 67.9804L99.8351 68.9004L99.2048 68.5544L100.739 67.6268Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9646 64.1143L97.0216 67.338L98.2707 68.0337L98.3277 71.2575L98.9466 70.8849L98.8934 68.0223L98.8896 67.6612L97.6366 66.9693L97.5835 63.7417L96.9646 64.1143Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0215 67.3379L98.2707 68.0336",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.067 64.0609L100.12 67.2846L99.8123 67.4709L99.4971 67.296L99.4402 64.0723L99.7477 63.886L100.051 64.0533L100.067 64.0609Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6367 66.9653L98.8897 67.661",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1687 67.3722L95.2257 70.5959L94.5954 70.2462H94.5916L94.5347 67.0186L96.0724 66.0986L96.7027 66.4484L95.1687 67.3722Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.09 71.2727L97.033 68.0452L97.6595 68.3949L97.6633 68.3987L97.7203 71.6225L96.1863 72.5463L95.5522 72.1965L97.09 71.2727Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4141 67.7029L96.471 70.9267L96.1597 71.113L95.8483 70.9419L95.8445 70.9381L95.7876 67.7144L96.0989 67.5281L96.4027 67.6953L96.4141 67.7029Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.687 63.6733L93.2551 64.5401L93.369 70.98L94.9333 71.8506L95.5522 71.4781L93.9879 70.6113L93.931 67.3837L93.874 64.1675L92.3097 63.3008H92.3059L91.687 63.6733Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.153 63.8785L90.2099 67.1023L89.5797 66.7563L89.5759 66.7525L89.5227 63.5288L91.0566 62.605L91.6869 62.9547L90.153 63.8785Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0744 67.7789L92.0174 64.5552L92.6439 64.9049H92.6477L92.7046 68.1325L91.1707 69.0525L90.5366 68.7027L92.0744 67.7789Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2964 64.2664L88.3533 67.4901L89.6025 68.182L89.6595 71.4096L90.2784 71.037L90.229 68.1744L90.2214 67.8133L88.9722 67.1176L88.9153 63.8938L88.2964 64.2664Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3533 67.49L89.6024 68.1857",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3985 64.213L91.4554 67.4367L91.1441 67.623L90.8327 67.4481H90.8289L90.772 64.2206L91.0833 64.0381L91.3871 64.2054L91.3985 64.213Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9722 67.1174L90.2213 67.8131",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5004 67.5205L86.5574 70.748L85.9271 70.3983V70.3945L85.8701 67.1707L87.4041 66.2507L88.0343 66.6005L86.5004 67.5205Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4215 71.4248L88.3646 68.1973L88.9949 68.547V68.5508L89.0518 71.7746L87.5179 72.6984L86.8838 72.3486L88.4215 71.4248Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7459 67.8551L87.8028 71.0788L87.4915 71.2651L87.1801 71.094L87.1763 71.0902L87.1194 67.8665L87.4307 67.6802L87.7345 67.8474L87.7459 67.8551Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0225 63.8215L84.5868 64.6921L84.6437 67.9159L84.7007 71.132L86.265 72.0026L86.8877 71.63L85.3196 70.7595L85.2626 67.5357L85.2057 64.3195L83.6413 63.449L83.6376 63.4528L83.0225 63.8215Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4848 64.0306L81.5417 67.2544L80.9152 66.9046H80.9114L80.8545 63.6809L82.3884 62.7571L83.0187 63.1068L81.4848 64.0306Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.406 67.931L83.3491 64.7073L83.9793 65.057L84.0363 68.2808L82.5023 69.2046L81.8721 68.8548L83.406 67.931Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6282 64.4185L79.6851 67.6384L80.9381 68.3341L80.9913 71.5617L81.6101 71.1891L81.5608 68.3265L81.5532 67.9616L80.304 67.2697L80.2471 64.0459L79.6282 64.4185Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6851 67.6384V67.6422L80.938 68.3379",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7302 64.3614L82.7872 67.589L82.4759 67.7752L82.1645 67.6004H82.1607L82.1038 64.3728L82.4151 64.1865L82.7189 64.3576L82.7302 64.3614Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.304 67.2695L81.5531 67.9614",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8322 67.6725L77.8891 70.9L77.2627 70.5503L77.2589 70.5465L77.2019 67.3227L78.7358 66.3989L79.3699 66.7525L77.8322 67.6725Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7534 71.5729L79.6965 68.3491L80.3267 68.6989H80.3305L80.3875 71.9264L78.8498 72.8464L78.2195 72.4967L79.7534 71.5729Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0775 68.0069L79.1345 71.2307L78.8269 71.417L78.5118 71.2421H78.508L78.4548 68.0183L78.7624 67.832L79.0661 67.9993L79.0775 68.0069Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3542 63.9734L75.9224 64.844L76.0325 71.2839L77.6006 72.1545L78.2195 71.7819L76.6514 70.9113L76.5982 67.6876L76.5375 64.4714L74.9731 63.6008L74.9693 63.6046L74.3542 63.9734Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8204 64.1825L72.8735 67.4062L72.247 67.0565H72.2432L72.1863 63.8327L73.724 62.9089L74.3543 63.2587L72.8204 64.1825Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7378 68.0829L74.6808 64.8591L75.3111 65.2051L75.3149 65.2089L75.3719 68.4326L73.8341 69.3564L73.2039 69.0067L74.7378 68.0829Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9636 64.5703L71.0206 67.7941L72.2697 68.486L72.3267 71.7097L72.9456 71.341L72.8924 68.4746L72.8886 68.1134L71.6357 67.4215L71.5825 64.1978L70.9636 64.5703Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0205 67.7939L72.2697 68.4896",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0619 64.5132L74.1189 67.7408L73.8113 67.9271L73.4962 67.7522L73.4924 67.7484L73.4392 64.5247L73.7468 64.3384L74.0505 64.5095L74.0619 64.5132Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6357 67.4216L72.8887 68.1135",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1678 67.8246L69.2247 71.0483L68.5944 70.7024L68.5906 70.6986L68.5337 67.4748L70.0714 66.551L70.7017 66.9008L69.1678 67.8246Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0852 71.725L71.0321 68.5012L71.6585 68.851H71.6623L71.7193 72.0785L70.1816 72.9985L69.5513 72.6488L71.0852 71.725Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4131 68.159L70.4663 71.3828L70.1587 71.569L69.8436 71.3942L69.7866 68.1666L70.0942 67.9841L70.4017 68.1514L70.4131 68.159Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.686 64.1255L67.2541 64.9961L67.3111 68.2198L67.368 71.436L68.9324 72.3066L69.5513 71.934L67.9831 71.0634L67.93 67.8397L67.873 64.6235L66.3049 63.7529L66.3011 63.7567L65.686 64.1255Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1521 64.3346L64.2091 67.5583L63.5788 67.2086H63.575L63.5181 63.9848L65.0558 63.061L65.6861 63.4108L64.1521 64.3346Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0734 68.235L66.0164 65.0112L66.6429 65.3572L66.6467 65.361L66.7037 68.5848L65.1659 69.5085L64.5356 69.1588L66.0734 68.235Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2954 64.7223L62.3524 67.9423L63.6015 68.638L63.6585 71.8617L64.2774 71.4892L64.2204 68.2654L62.9675 67.5735L62.9143 64.3459L62.2954 64.7223Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3523 67.9424V67.9462L63.6015 68.6419",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3975 64.6654L65.4506 67.8891L65.1431 68.0792L64.8317 67.9043L64.828 67.9005L64.771 64.6768L65.0785 64.4905L65.3861 64.6578L65.3975 64.6654Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9673 67.5698L64.2203 68.2655",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4994 67.9767L60.5564 71.2004L59.9261 70.8507H59.9223L59.8691 67.6269L61.4031 66.7031L62.0334 67.0529L60.4994 67.9767Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4205 71.8771L62.3636 68.6533L62.9901 69.0031H62.9939L63.0508 72.2268L61.5169 73.1506L60.8828 72.8009L62.4205 71.8771Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7449 68.3074L61.8018 71.535L61.4905 71.7213L61.1792 71.5464H61.1754L61.1184 68.3188L61.4297 68.1326L61.7335 68.3036L61.7449 68.3074Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0212 64.2776L58.5856 65.1482L58.6995 71.5881L60.2638 72.4587L60.8865 72.0861L59.3184 71.2155L59.2614 67.9918L59.2044 64.7756L57.6401 63.905H57.6363L57.0212 64.2776Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.503 72.1165L102.071 72.9832L102.128 76.207L102.185 79.427L103.749 80.2937L104.368 79.9212L102.804 79.0544L102.747 75.8268L102.69 72.6145L101.126 71.7439H101.122L100.503 72.1165Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9691 72.3216L99.0261 75.5454L98.3958 75.1995V75.1957L98.3389 71.9719L99.8728 71.0481L100.503 71.3978L98.9691 72.3216Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.891 76.2221L100.834 72.9983L101.464 73.348L101.521 76.5756L99.9869 77.4956L99.3528 77.1458L100.891 76.2221Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1125 72.7095L97.1695 75.9332L98.4225 76.6251L98.4756 79.8527L99.0945 79.4801L99.0452 76.6175L99.0376 76.2564L97.7884 75.5607L97.7314 72.3369L97.1125 72.7095Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1694 75.9331L98.4224 76.6288",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.215 72.6561L100.272 75.8798L99.9602 76.0661L99.6489 75.8912H99.6451L99.5881 72.6675L99.8995 72.4812L100.203 72.6485L100.215 72.6561Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7886 75.5605L99.0377 76.2562",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3168 75.9674L95.3738 79.1912L94.7473 78.8414H94.7435L94.6865 75.6138L96.2205 74.6938L96.8507 75.0436L95.3168 75.9674Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.238 79.8679L97.1811 76.6404L97.8114 76.9901L97.8152 76.9939L97.8683 80.2177L96.3344 81.1415L95.7041 80.7917L97.238 79.8679Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5623 76.2982L96.6192 79.5219L96.3079 79.7082L95.9965 79.5371L95.9927 79.5333L95.9358 76.3096L96.2471 76.1233L96.5509 76.2906L96.5623 76.2982Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8389 72.2685L93.407 73.1352L93.5171 79.5752L95.0814 80.4457H95.0852L95.7041 80.0732L94.136 79.2064L94.079 75.9788L94.0221 72.7627L92.4578 71.8921V71.8959H92.454L91.8389 72.2685Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3012 72.4737L90.3581 75.6975L89.7316 75.3516L89.7279 75.3478L89.6709 72.124L91.2048 71.2002L91.8389 71.5499L90.3012 72.4737Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2224 76.3742L92.1655 73.1504L92.7957 73.5001H92.7995L92.8527 76.7239L91.3188 77.6477L90.6885 77.298L92.2224 76.3742Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4482 72.8616L88.5014 76.0853L89.7544 76.7772L89.8113 80.0048L90.4302 79.6322L90.3771 76.7696L90.3733 76.4047L89.1203 75.7128L89.0633 72.489L88.4482 72.8616Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5015 76.0852L89.7544 76.7809",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5465 72.8045L91.6035 76.0321L91.2959 76.2184L90.9808 76.0435H90.977L90.9238 72.8159L91.2314 72.6296L91.5351 72.8007L91.5465 72.8045Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1201 75.7129L90.3731 76.4048",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6521 76.1158L86.7053 79.3434L86.0788 78.9936L86.075 78.9898L86.0181 75.7661L87.5558 74.8423L88.1861 75.1958L86.6521 76.1158Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5696 80.0201L88.5164 76.7925L89.1429 77.1422H89.1467L89.2037 80.3698L87.6659 81.2936L87.0356 80.9438L88.5696 80.0201Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8937 76.4503L87.9506 79.674L87.6431 79.8603L87.3279 79.6854L87.271 76.4617L87.5785 76.2754L87.8823 76.4427L87.8937 76.4503Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1707 72.4168L84.7388 73.2873L84.7919 76.5111H84.7957L84.8527 79.7273L86.417 80.5978L87.0359 80.2253L85.4678 79.3547L85.4146 76.1309L85.3577 72.9148L83.7895 72.0442V72.048H83.7857L83.1707 72.4168Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6368 72.6258L81.6937 75.8496L81.0634 75.4999H81.0596L81.0027 72.2761L82.5404 71.3523L83.1707 71.702L81.6368 72.6258Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5542 76.5263L83.501 73.3025L84.1275 73.6522H84.1313L84.1883 76.876L82.6505 77.7998L82.0203 77.45L83.5542 76.5263Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.78 73.0137L79.837 76.2336L81.0862 76.9293L81.1431 80.1569L81.762 79.7843L81.7088 76.9217L81.705 76.5568L80.4521 75.8649L80.3989 72.6411L79.78 73.0137Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8369 76.2336V76.2374L81.0861 76.9331",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8821 72.9566L82.9353 76.1842L82.6277 76.3705L82.3126 76.1956L82.2556 72.968L82.5632 72.7817L82.8707 72.9528L82.8821 72.9566Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4519 75.865L81.7049 76.5569",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.984 76.2679L78.041 79.4917L77.4107 79.1457L77.4069 79.1419L77.3538 75.9182L78.8877 74.9944L79.518 75.3441L77.984 76.2679Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9052 80.1684L79.8482 76.9446L80.4747 77.2943H80.4785L80.5354 80.5219L79.0015 81.4419L78.3674 81.0921L79.9052 80.1684Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2295 76.6024L79.2865 79.8261L78.9751 80.0124L78.6638 79.8375H78.66L78.603 76.6138L78.9144 76.4275L79.2181 76.5948L79.2295 76.6024Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5022 72.5688L76.0703 73.4394L76.1842 79.8793L77.7485 80.7499L78.3674 80.3774L76.8031 79.5068L76.7462 76.283L76.6892 73.0669L75.1249 72.1963H75.1211V72.2001L74.5022 72.5688Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9682 72.7779L73.0251 76.0017L72.3948 75.652H72.391L72.3379 72.4282L73.8718 71.5044L74.5021 71.8541L72.9682 72.7779Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8895 76.6784L74.8326 73.4546L75.4591 73.8005L75.4629 73.8043L75.5198 77.0281L73.9859 77.9519L73.3518 77.6022L74.8895 76.6784Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1116 73.1658L71.1685 76.3895L72.4177 77.0814L72.4747 80.3052L73.0935 79.9364L73.0442 77.07L73.0366 76.7089L71.7874 76.017L71.7305 72.7932L71.1116 73.1658Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1685 76.3894L72.4176 77.0851",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2136 73.1087L74.2706 76.3363L73.9593 76.5226L73.6479 76.3477L73.6441 76.3439L73.5872 73.1201L73.8985 72.9338L74.2023 73.1049L74.2136 73.1087Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7876 76.0168L73.0368 76.7087",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3158 76.4198L69.3728 79.6435L68.7463 79.2938H68.7425L68.6855 76.07L70.2195 75.1462L70.8498 75.496L69.3158 76.4198Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2371 80.3202L71.1801 77.0964L71.8104 77.4462L71.8673 80.6699L70.3334 81.5937L69.7031 81.244L71.2371 80.3202Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5613 76.7506L70.6183 79.9781L70.3069 80.1644L69.9956 79.9895H69.9918L69.9348 76.762L70.2462 76.5757L70.5499 76.7468L70.5613 76.7506Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8376 72.7209L67.402 73.5915L67.4589 76.8153L67.5159 80.0315L69.0802 80.902L69.7029 80.5295L68.1348 79.6589L68.0778 76.4351L68.0208 73.219L66.4565 72.3484H66.4527V72.3522L65.8376 72.7209Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3 72.93L64.3569 76.1538L63.7304 75.804H63.7266L63.6697 72.5765L65.2036 71.6565L65.8339 72.0062L64.3 72.93Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2212 76.8306L66.1642 73.603L66.7945 73.9528L66.7983 73.9566L66.8515 77.1803L65.3175 78.1041L64.6873 77.7544L66.2212 76.8306Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4434 73.3178L62.5003 76.5377L63.7533 77.2334L63.8102 80.4572L64.4253 80.0846L64.3722 76.8609L63.1192 76.169L63.0622 72.9414L62.4434 73.3178Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5002 76.5378V76.5416L63.7532 77.2373",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5454 73.2608L65.6024 76.4846L65.291 76.6709L64.9797 76.4998L64.9759 76.496L64.9189 73.2722L65.2303 73.0859L65.534 73.2532L65.5454 73.2608Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1191 76.165L64.3683 76.8607",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6512 76.5719L60.7043 79.7956L60.0778 79.4459H60.074L60.0171 76.2221L61.5548 75.2983L62.1851 75.6481L60.6512 76.5719Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5686 80.4723L62.5117 77.2485L63.1419 77.5983H63.1457L63.2027 80.8221L61.665 81.7458L61.0347 81.3961L62.5686 80.4723Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8927 76.9027L61.9497 80.1302L61.6421 80.3165L61.327 80.1416H61.3232L61.27 76.9141L61.5776 76.7278L61.8813 76.8989L61.8927 76.9027Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1694 72.873L58.7375 73.7436L58.8477 80.1835L60.4158 81.0541L61.0346 80.6816L59.4665 79.811L59.4134 76.5834L59.3564 73.3711L57.7883 72.5005H57.7845L57.1694 72.873Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.655 80.7118L102.223 81.5786L102.277 84.8023H102.28L102.333 88.0185L103.902 88.8891L104.52 88.5165L102.952 87.6497L102.895 84.4222L102.838 81.206L101.274 80.3354V80.3392H101.27L100.655 80.7118Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1214 80.9171L99.1745 84.1409L98.548 83.7949L98.5443 83.7911L98.4873 80.5673L100.025 79.6436L100.655 79.9933L99.1214 80.9171Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.039 84.8175L100.986 81.5938L101.612 81.9435H101.616L101.673 85.1673L100.135 86.0911L99.5049 85.7413L101.039 84.8175Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2646 81.3049L97.3178 84.5287L98.5708 85.2206L98.6277 88.4482L99.2466 88.0756L99.1935 85.213L99.1897 84.8518L97.9367 84.1561L97.8797 80.9324L97.2646 81.3049Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3179 84.5286L98.5708 85.2243",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.363 81.2515L100.42 84.4753L100.112 84.6616L99.7972 84.4867L99.7402 81.2591L100.048 81.0767L100.352 81.2439L100.363 81.2515Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9368 84.156L99.1897 84.8517",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4688 84.559L95.5257 87.7866L94.8955 87.4369L94.8917 87.4331L94.8347 84.2093L96.3725 83.2893L97.0027 83.6391L95.4688 84.559Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.39 88.4634L97.3331 85.2358L97.9596 85.5856H97.9634L98.0203 88.8132L96.4826 89.7369L95.8523 89.3872L97.39 88.4634Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7141 84.8936L96.7673 88.1174L96.4597 88.3037L96.1484 88.1288H96.1446L96.0876 84.905L96.3952 84.7188L96.7027 84.886L96.7141 84.8936Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9871 80.8601L93.5552 81.7307L93.6691 88.1706L95.2334 89.0412L95.8523 88.6686L94.288 87.7981L94.231 84.5743L94.1741 81.3581L92.6059 80.4875V80.4913L91.9871 80.8601Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.453 81.0692L90.51 84.293L89.8797 83.9432H89.8759L89.8228 80.7194L91.3567 79.7957L91.987 80.1454L90.453 81.0692Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3744 84.9696L92.3174 81.7458L92.9439 82.0956H92.9477L93.0047 85.3194L91.4707 86.2432L90.8367 85.8934L92.3744 84.9696Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5964 81.457L88.6534 84.6808L89.9026 85.3727L89.9595 88.6003L90.5784 88.2277L90.529 85.3651L90.5215 85.0001L89.2723 84.3082L89.2153 81.0845L88.5964 81.457Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6533 84.6807L89.9025 85.3764",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6985 81.4L91.7555 84.6275L91.4441 84.8138L91.1328 84.6389H91.129L91.072 81.4114L91.3834 81.2251L91.6871 81.3962L91.6985 81.4Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2722 84.3083L90.5214 85.0002",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8004 84.7113L86.8574 87.9351L86.2271 87.5891V87.5853L86.1702 84.3615L87.7041 83.4377L88.3344 83.7875L86.8004 84.7113Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7216 88.6117L88.6646 85.3879L89.2949 85.7377L89.3519 88.9653L87.8179 89.8853L87.1838 89.5355L88.7216 88.6117Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0459 85.0457L88.1029 88.2695L87.7915 88.4558L87.4802 88.2809H87.4764L87.4194 85.0571L87.7308 84.8708L88.0345 85.0381L88.0459 85.0457Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3188 81.0122L84.887 81.8828L84.9439 85.1065L85.0009 88.3227L86.5652 89.1933L87.1841 88.8207L85.6198 87.9502L85.5628 84.7264L85.5058 81.5102L83.9415 80.6396H83.9377V80.6435L83.3188 81.0122Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7848 81.2213L81.8418 84.4451L81.2115 84.0953L81.1545 80.8715L82.6885 79.9478L83.3188 80.2975L81.7848 81.2213Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7062 85.1217L83.6492 81.8979L84.2795 82.2439V82.2477L84.3365 85.4715L82.8025 86.3953L82.1685 86.0455L83.7062 85.1217Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9282 81.6091L79.9852 84.8291L81.2381 85.5248L81.2913 88.7486L81.9102 88.3798L81.8608 85.5172L81.8532 85.1522L80.6041 84.4603L80.5471 81.2366L79.9282 81.6091Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9851 84.8291V84.8329L81.2381 85.5286",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0303 81.5521L83.0872 84.7796L82.7759 84.9659L82.4646 84.7911L82.4608 84.7872L82.4038 81.5635L82.7152 81.3772L83.0189 81.5483L83.0303 81.5521Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.604 84.4604L81.8532 85.1523",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1322 84.8634L78.1892 88.0871L77.5627 87.7412L77.5589 87.7374L77.502 84.5136L79.0359 83.5898L79.6662 83.9396L78.1322 84.8634Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0535 88.7638L79.9965 85.54L80.6268 85.8898H80.6306L80.6837 89.1136L79.1498 90.0373L78.5195 89.6876L80.0535 88.7638Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3777 85.1978L79.4347 88.4216L79.1233 88.6079L78.812 88.433H78.8082L78.7512 85.2054L79.0626 85.0229L79.3663 85.1902L79.3777 85.1978Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6543 81.1643L76.2224 82.0349L76.3325 88.4748L77.9006 89.3454L78.5195 88.9728L76.9514 88.1022L76.8945 84.8785L76.8375 81.6623L75.2732 80.7917L75.2694 80.7955L74.6543 81.1643Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1166 81.3734L73.1736 84.5972L72.5471 84.2474H72.5433L72.4863 81.0198L74.0203 80.0999L74.6543 80.4496L73.1166 81.3734Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0378 85.2738L74.9809 82.05L75.6112 82.396L75.615 82.3998L75.6719 85.6236L74.1342 86.5474L73.5039 86.1976L75.0378 85.2738Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2637 81.7611L71.3168 84.9811L72.5698 85.6768L72.6267 88.9006L73.2456 88.528L73.1925 85.6654L73.1887 85.3042L71.9357 84.6123L71.8788 81.3848L71.2637 81.7611Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3169 84.9812V84.985L72.5699 85.6769",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3619 81.7042L74.4189 84.9279L74.1113 85.1142L73.7962 84.9431L73.7924 84.9393L73.7393 81.7156L74.0468 81.5293L74.3506 81.6966L74.3619 81.7042Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9358 84.6123L73.1888 85.3042",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4678 85.0152L69.521 88.239L68.8945 87.8893H68.8907L68.8337 84.6655L70.3715 83.7417L71.0018 84.0914L69.4678 85.0152Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3853 88.9157L71.3321 85.6919L71.9586 86.0416H71.9624L72.0193 89.2654L70.4816 90.1892L69.8513 89.8395L71.3853 88.9157Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7094 85.346L70.7663 88.5736L70.4588 88.7599L70.1436 88.585L70.0867 85.3574L70.3942 85.1711L70.698 85.3422L70.7094 85.346Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9861 81.3164L67.5542 82.187L67.6112 85.4107V85.4069L67.6681 88.6269L69.2324 89.4975L69.8513 89.1249L68.2832 88.2543L68.23 85.0306L68.1731 81.8144L66.605 80.9438H66.6012L65.9861 81.3164Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4522 81.5255L64.5091 84.7493L63.8789 84.3995H63.8751L63.8181 81.1719L65.3559 80.252L65.9861 80.6017L64.4522 81.5255Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3696 85.4261L66.3165 82.1985L66.943 82.5482L66.9468 82.552L67.0037 85.7758L65.466 86.6996L64.8357 86.3499L66.3696 85.4261Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5955 81.9094L62.6524 85.1332L63.9016 85.8289L63.9585 89.0527L64.5774 88.6801L64.5205 85.4563L63.2675 84.7644L63.2144 81.5369L62.5955 81.9094Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6523 85.1333V85.1371L63.9015 85.8328",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6975 81.8563L65.7507 85.08L65.4431 85.2663L65.128 85.0952V85.0914L65.071 81.8677L65.3786 81.6814L65.6861 81.8487L65.6975 81.8563Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2673 84.7605L64.5203 85.4562",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7995 85.1673L60.8564 88.3911L60.2261 88.0414H60.2223L60.1692 84.8176L61.7031 83.8938L62.3334 84.2436L60.7995 85.1673Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7206 89.0678L62.6636 85.844L63.2901 86.1899L63.2939 86.1937L63.3509 89.4175L61.8169 90.3413L61.1829 89.9916L62.7206 89.0678Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0449 85.4981L62.1019 88.7257L61.7906 88.912L61.4792 88.7371L61.4754 88.7333L61.4185 85.5095L61.7298 85.3232L62.0336 85.4943L62.0449 85.4981Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3213 81.4685L58.8856 82.3353L58.9995 88.779L60.5638 89.6496L61.1827 89.2732L59.6184 88.4064L59.5614 85.1789L59.5045 81.9665L57.9402 81.0959H57.9364L57.3213 81.4685Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2692 89.5126L99.3261 92.7363L98.6959 92.3866H98.6921L98.6389 89.1628L100.173 88.239L100.803 88.5888L99.2692 89.5126Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6012 89.6646L90.6582 92.8884L90.0317 92.5387H90.0279L89.9709 89.3149L91.5049 88.3911L92.1352 88.7409L90.6012 89.6646Z",
    stroke: "#A9D6D4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  })))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2497 26.6608C46.2535 26.6189 46.2573 26.5771 46.2611 26.5391L46.2725 26.3985C46.2801 26.3034 46.2877 26.2084 46.2915 26.0981C46.3029 25.8548 46.3067 25.6153 46.3029 25.3758V25.1857C46.2915 24.9919 46.2839 24.798 46.2649 24.5775C46.2649 24.5509 46.2649 24.5205 46.2611 24.4938V24.452C46.2346 24.1973 46.2004 23.935 46.1548 23.6689L46.1283 23.5054C46.0751 23.2089 46.0219 22.9542 45.9612 22.6995C45.9042 22.4676 45.8321 22.2243 45.7448 21.9544L45.6954 21.8023C45.6119 21.5552 45.5208 21.3119 45.4258 21.0838L45.3689 20.9507C45.274 20.7264 45.1714 20.5098 45.0499 20.2703L45.0272 20.2208C44.917 20.0079 44.7955 19.7874 44.6513 19.5517L44.5639 19.4111C44.4197 19.1792 44.2792 18.9701 44.1387 18.7762L44.0817 18.7002C43.9412 18.5101 43.797 18.3238 43.6375 18.1337C43.6223 18.1147 43.6071 18.0957 43.5919 18.0729L43.5616 18.0387C43.4097 17.86 43.2502 17.6852 43.087 17.5179L42.9768 17.4076C42.8326 17.2632 42.6845 17.1225 42.5174 16.9743C42.4984 16.9552 42.4795 16.94 42.4605 16.921L42.4225 16.8868C42.282 16.7652 42.1377 16.6435 41.9935 16.5333L41.9631 16.5105C41.8074 16.3888 41.6441 16.271 41.4809 16.1607L41.4467 16.1341C41.4125 16.1113 41.3784 16.0885 41.348 16.0695L41.2986 16.0353C41.2075 15.9744 41.1126 15.9136 41.0177 15.8528C40.9683 15.8224 40.9189 15.7958 40.8696 15.7653L40.8126 15.7311C40.7177 15.6779 40.6266 15.6209 40.5089 15.5601L40.3 15.4498C40.2165 15.408 40.133 15.3662 40.0457 15.3244C39.9659 15.2863 39.8862 15.2483 39.8065 15.2141C39.7191 15.1761 39.6318 15.1381 39.5141 15.0849L39.4495 15.0582C39.4154 15.043 39.3812 15.0316 39.347 15.0202L39.2977 15.0012C39.2103 14.967 39.123 14.9328 39.0357 14.9024C38.9522 14.872 38.8648 14.8454 38.7813 14.8149C38.6902 14.7845 38.6028 14.7579 38.4813 14.7199L38.4054 14.6971C38.3712 14.6895 38.3409 14.6781 38.3067 14.6705L38.2535 14.6553C38.1548 14.6287 38.0561 14.602 37.9574 14.5792C37.87 14.5602 37.7865 14.5374 37.6992 14.5222C37.6005 14.4994 37.498 14.4804 37.3992 14.4614L37.2663 14.4348C37.1752 14.4196 37.0841 14.4044 36.9892 14.3892L34.0618 13.9634L33.982 14.5146L33.9023 15.0658C34.0238 15.0849 34.1415 15.1077 34.2706 15.1305C34.3617 15.1457 34.4491 15.1647 34.5402 15.1837C34.6199 15.1989 34.6959 15.2179 34.7718 15.2369C34.8591 15.2597 34.9503 15.2825 35.0376 15.3053C35.1135 15.3282 35.1895 15.3472 35.2654 15.37C35.3451 15.3928 35.4287 15.4194 35.5084 15.446C35.5843 15.4726 35.6603 15.4954 35.7362 15.5258C35.8159 15.5525 35.8919 15.5829 35.9716 15.6133C36.0475 15.6437 36.1197 15.6703 36.1956 15.7007C36.2754 15.7349 36.3513 15.7691 36.4272 15.8034C36.4994 15.8376 36.5715 15.868 36.6437 15.9022C36.7196 15.9402 36.7955 15.9782 36.8715 16.0162C36.9398 16.0505 37.0082 16.0847 37.0765 16.1227C37.16 16.1683 37.2474 16.2177 37.3271 16.2672L37.3765 16.2976C37.422 16.3242 37.4676 16.3508 37.5093 16.3774C37.5929 16.4306 37.6802 16.4838 37.7637 16.5409L37.9308 16.6511C38.0789 16.7538 38.2232 16.8564 38.3598 16.9629L38.3902 16.9857C38.5231 17.0883 38.6522 17.1947 38.7775 17.305L38.8762 17.3924C39.0129 17.5141 39.1458 17.6395 39.2749 17.7688L39.3736 17.8676C39.5217 18.0197 39.666 18.1756 39.8027 18.3352L39.8824 18.4303C40.0191 18.5937 40.152 18.761 40.2773 18.9321L40.3304 19.0005C40.4633 19.1868 40.5886 19.3769 40.7101 19.5708L40.786 19.6962C40.9038 19.8939 41.0177 20.0954 41.1354 20.3235L41.1581 20.3691C41.2569 20.563 41.348 20.7607 41.4353 20.9621L41.4885 21.08C41.5758 21.2929 41.6555 21.5096 41.7315 21.7301L41.777 21.8669C41.8568 22.114 41.9213 22.3345 41.9783 22.5626C42.0276 22.7679 42.077 22.9998 42.1225 23.2659L42.1491 23.418C42.1871 23.6651 42.2175 23.897 42.2403 24.1289L42.2516 24.2658C42.2668 24.4406 42.2744 24.6155 42.2782 24.7904V24.9614C42.2858 25.1781 42.282 25.3986 42.2706 25.6153C42.2668 25.7218 42.2554 25.8282 42.2478 25.9537L42.2365 26.1247C42.2213 26.2958 42.1985 26.4707 42.1757 26.6418C42.1605 26.7406 42.1415 26.8432 42.1263 26.9421L42.115 26.9991C42.096 27.0941 42.0808 27.1892 42.0618 27.2842C42.0466 27.3641 42.0276 27.4477 42.0086 27.5275C41.9859 27.6188 41.9631 27.7138 41.9403 27.8051C41.9175 27.8849 41.8985 27.9685 41.872 28.0484C41.8492 28.132 41.8226 28.2194 41.796 28.2993C41.7694 28.3791 41.7429 28.4627 41.7163 28.5426C41.6897 28.6262 41.6593 28.706 41.629 28.7897C41.5986 28.8695 41.572 28.9455 41.5416 29.0254C41.5113 29.1052 41.4771 29.1888 41.4429 29.2687C41.4087 29.3447 41.3784 29.4207 41.3442 29.4968C41.31 29.5766 41.272 29.6564 41.2341 29.7325C41.1999 29.8047 41.1619 29.8769 41.1278 29.9492C41.0822 30.0366 41.0366 30.124 40.9835 30.2191C40.9493 30.2837 40.9151 30.3445 40.881 30.4054C40.8316 30.4928 40.7822 30.5764 40.7291 30.6601L40.7025 30.7019C40.6721 30.7513 40.6456 30.7969 40.6152 30.8463C40.5393 30.9642 40.4633 31.0782 40.3836 31.1923L40.3114 31.2987C40.2051 31.447 40.095 31.5915 39.9621 31.7587L39.928 31.8005C39.8065 31.9488 39.6812 32.0933 39.5369 32.2529L39.4458 32.3556C39.2977 32.5114 39.1496 32.6635 38.9939 32.808L38.8838 32.9068C38.7927 32.9905 38.7016 33.0703 38.6104 33.1501L38.4586 33.2718C38.375 33.3402 38.2915 33.4048 38.208 33.4695C38.1586 33.5075 38.1055 33.5455 38.0409 33.5949C37.9574 33.6557 37.8776 33.7128 37.7941 33.7736C37.7334 33.8154 37.6764 33.8534 37.6157 33.8914C37.5321 33.9447 37.4448 34.0017 37.3613 34.0549C37.3005 34.0929 37.2398 34.1271 37.179 34.1652C37.0917 34.2184 37.0006 34.2678 36.9132 34.3134L36.7272 34.4123C36.6323 34.4617 36.5373 34.5073 36.4424 34.5529L36.2678 34.6366C36.1577 34.686 36.0438 34.7354 35.9298 34.781L35.797 34.8342C35.6375 34.8951 35.478 34.9559 35.3148 35.0091L35.216 35.0395C35.0869 35.0813 34.9578 35.1194 34.825 35.1574L34.6465 35.203C34.5402 35.2296 34.4339 35.2562 34.3276 35.279C34.2782 35.2904 34.225 35.298 34.1757 35.3094L34.1263 35.317C34.0238 35.336 33.9251 35.3551 33.8226 35.3703C33.7542 35.3817 33.6821 35.3893 33.61 35.4007C33.5074 35.4159 33.4087 35.4273 33.3062 35.4387C33.2341 35.4463 33.1619 35.4539 33.086 35.4577C32.9835 35.4653 32.881 35.4729 32.7784 35.4767C32.7063 35.4767 32.6342 35.4843 32.562 35.4843C32.4557 35.4843 32.3456 35.4843 32.2393 35.4843H32.1785C32.1292 35.4843 32.0836 35.4843 32.0343 35.4843C31.9165 35.4805 31.7988 35.4729 31.6773 35.4653L31.5027 35.4539C31.3242 35.4387 31.1458 35.4197 30.9673 35.3931L30.8876 35.9443L30.8079 36.4955L33.7353 36.9213C33.9327 36.9517 34.1339 36.9745 34.3314 36.9898L34.525 37.0012C34.6579 37.0088 34.7908 37.0202 34.9237 37.024C34.9806 37.024 35.0376 37.024 35.0945 37.024H35.1553C35.2768 37.024 35.3945 37.024 35.5122 37.024C35.5919 37.024 35.6679 37.0202 35.7552 37.0164C35.8691 37.0126 35.9868 37.005 36.1007 36.9936C36.1804 36.9859 36.264 36.9783 36.3437 36.9707C36.4576 36.9593 36.5715 36.9441 36.6892 36.9289C36.7652 36.9175 36.8449 36.9061 36.9208 36.8947C37.0347 36.8757 37.1486 36.8567 37.2625 36.8339L37.3081 36.8263C37.3689 36.8149 37.4296 36.8035 37.4866 36.7921C37.6081 36.7655 37.7258 36.735 37.8435 36.7084L37.9042 36.6932C37.9498 36.6818 37.9953 36.6704 38.0409 36.659C38.189 36.6172 38.3333 36.5754 38.5117 36.5183L38.5877 36.4955C38.7699 36.4347 38.9484 36.3701 39.1268 36.3017L39.2749 36.2408C39.4002 36.1876 39.5293 36.1382 39.6508 36.0812C39.6963 36.0622 39.7381 36.0393 39.7837 36.0165L39.8444 35.9861C39.9507 35.9367 40.057 35.8835 40.1634 35.8303C40.2203 35.7998 40.2773 35.7694 40.3684 35.72C40.4671 35.6668 40.5658 35.6098 40.6645 35.5527C40.7329 35.5147 40.8012 35.4729 40.8696 35.4311C40.9645 35.3741 41.0594 35.3132 41.1543 35.2524C41.2227 35.2068 41.2872 35.165 41.3518 35.1194C41.4467 35.0547 41.5378 34.9901 41.6555 34.9027C41.7087 34.8646 41.7618 34.8228 41.815 34.7848C41.9099 34.7126 42.001 34.6404 42.096 34.5643L42.263 34.4275C42.3655 34.34 42.4681 34.2488 42.5668 34.1614L42.6883 34.0511C42.8591 33.8914 43.0262 33.7204 43.1895 33.5493L43.311 33.42C43.4553 33.2642 43.5957 33.1007 43.7324 32.9334L43.7894 32.865C43.9147 32.7091 44.0362 32.5495 44.1539 32.3822L44.2336 32.2643C44.3209 32.1389 44.4083 32.0096 44.4994 31.869L44.5298 31.8196C44.5487 31.7891 44.5677 31.7549 44.5867 31.7245L44.6171 31.6751C44.674 31.5839 44.731 31.4888 44.7842 31.3938C44.8259 31.3215 44.8677 31.2455 44.9057 31.1733C44.9588 31.0782 45.0082 30.9832 45.0727 30.8539L45.1752 30.6487C45.217 30.5612 45.2588 30.4738 45.2967 30.3863C45.3347 30.3027 45.3727 30.2191 45.4068 30.1354C45.4448 30.048 45.4828 29.9568 45.517 29.8655L45.6157 29.607C45.6498 29.5158 45.6802 29.4245 45.7106 29.3371C45.741 29.2497 45.7713 29.1584 45.7979 29.071C45.8283 28.9759 45.8549 28.8847 45.8815 28.7897L45.9536 28.5198C45.9802 28.4171 46.003 28.3145 46.0295 28.2118C46.0485 28.1244 46.0713 28.0331 46.0865 27.9457C46.1093 27.8393 46.1283 27.7366 46.1472 27.6302L46.1586 27.577C46.1662 27.5389 46.1738 27.5047 46.1776 27.4667C46.189 27.3907 46.2004 27.3146 46.2118 27.2348C46.2384 27.0447 46.2611 26.8546 46.2801 26.6646L46.2497 26.6608Z",
    fill: "#E1E1E1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0977 26.7825C43.9578 20.8652 39.9785 15.3869 34.2097 14.5463C28.4409 13.7058 23.0672 17.8212 22.2072 23.7385C21.3471 29.6558 25.3264 35.134 31.0952 35.9746C36.864 36.8152 42.2377 32.6997 43.0977 26.7825Z",
    fill: "#F5F5F5"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3974 18.1831C39.704 15.9819 37.2132 14.4195 34.2934 13.9937C28.2298 13.1117 22.5611 17.4417 21.6574 23.6536C20.7538 29.8692 24.9569 35.6401 31.0205 36.522C36.1881 37.2748 41.0671 34.2373 42.9541 29.4738C43.2844 28.6489 43.5198 27.7745 43.6527 26.8583C44.1197 23.6384 43.2199 20.5439 41.3974 18.1831ZM31.1192 35.8263C25.4429 34.9976 21.5169 29.5879 22.3637 23.76C23.2104 17.936 28.5146 13.8682 34.1909 14.6932C36.6817 15.0543 38.8307 16.3051 40.3912 18.0804C42.3884 20.35 43.4173 23.4863 42.9427 26.7557C42.8136 27.6377 42.5858 28.474 42.2669 29.261C40.4899 33.6974 35.9337 36.5258 31.1192 35.8263Z",
    fill: "#E1E1E1"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M32.167 28.8696C32.167 28.8696 32.1291 28.8582 32.1139 28.8544C31.981 28.8163 31.8519 28.7745 31.7418 28.7289C31.6507 28.6909 31.5747 28.6453 31.4988 28.5996C31.4646 28.5806 31.4228 28.5616 31.3887 28.5388C31.2976 28.478 31.2102 28.4134 31.1343 28.3411C31.0773 28.2879 31.0318 28.2271 30.9862 28.1663C30.9672 28.1396 30.9406 28.1168 30.9217 28.0864C30.8647 28.0028 30.8154 27.9154 30.7736 27.8241C30.7394 27.7329 30.709 27.6416 30.6901 27.5466C30.6787 27.4896 30.6749 27.4325 30.6673 27.3755C30.6597 27.3185 30.6483 27.2653 30.6483 27.2083L29.7446 27.0752C29.7446 27.0752 29.7446 27.098 29.7446 27.1094C29.7446 27.155 29.756 27.1968 29.7636 27.2425C29.7712 27.2995 29.775 27.3565 29.7864 27.4135C29.7864 27.4211 29.7864 27.4249 29.7864 27.4325C29.8054 27.52 29.8358 27.6074 29.8699 27.6911C29.9117 27.7823 29.9611 27.8697 30.018 27.9534C30.037 27.98 30.0636 28.0066 30.0826 28.0332C30.1205 28.0826 30.1585 28.132 30.2041 28.1777C30.2116 28.1853 30.223 28.1967 30.2306 28.2043C30.299 28.2689 30.3749 28.3297 30.4622 28.3868C30.4698 28.3906 30.4774 28.3944 30.485 28.3982C30.5192 28.421 30.5572 28.44 30.5951 28.459C30.6483 28.4894 30.6938 28.5198 30.7508 28.5464C30.7812 28.5616 30.8078 28.573 30.8381 28.5844C30.9141 28.6187 30.9976 28.6491 31.0811 28.6757C31.1229 28.6871 31.1685 28.6985 31.2102 28.7099C31.2292 28.7137 31.2444 28.7213 31.2634 28.7251C31.3583 28.7479 31.457 28.7707 31.5633 28.7897C31.6127 28.7973 31.6658 28.8087 31.719 28.8163L32.6227 28.9494C32.4594 28.9266 32.3075 28.8924 32.167 28.8582V28.8696Z",
    fill: "#CCCCCC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0314 20.0117C34.2098 20.0687 34.3731 20.1334 34.5288 20.2056C34.5516 20.217 34.5781 20.2284 34.6009 20.2398C34.7376 20.3082 34.8667 20.3805 34.9844 20.4603C35.0186 20.4831 35.0489 20.5059 35.0831 20.5287C35.1211 20.5553 35.1591 20.582 35.1932 20.6124C35.2274 20.639 35.2616 20.6694 35.2957 20.6998C35.3299 20.7302 35.3641 20.7568 35.3945 20.791C35.4172 20.8139 35.44 20.8367 35.4628 20.8595C35.5501 20.9507 35.6299 21.0458 35.702 21.1484C35.7893 21.2777 35.8653 21.4107 35.9336 21.5476C35.945 21.5704 35.9564 21.5932 35.9678 21.616C36.0285 21.7491 36.0817 21.8859 36.1235 22.0266C36.1311 22.0532 36.1386 22.0798 36.1462 22.1102C36.188 22.2547 36.2184 22.4029 36.2412 22.555C36.2412 22.5588 36.2412 22.5626 36.2412 22.5702C36.2639 22.7413 36.2753 22.9199 36.2715 23.1024L37.1752 23.2355C37.1752 23.1747 37.1752 23.1138 37.1752 23.053C37.1714 22.9352 37.16 22.8173 37.1448 22.6995C37.1448 22.6957 37.1448 22.6919 37.1448 22.6881C37.1296 22.5816 37.1106 22.4752 37.0879 22.3725C37.0765 22.3269 37.0613 22.2851 37.0499 22.2433C37.0423 22.2167 37.0347 22.1862 37.0271 22.1596C36.9853 22.019 36.9322 21.8821 36.8714 21.7491C36.8601 21.7262 36.8487 21.7034 36.8373 21.6806C36.7689 21.5438 36.693 21.4107 36.6057 21.2815C36.5335 21.1788 36.4538 21.0838 36.3665 20.9925C36.3551 20.9811 36.3475 20.9697 36.3399 20.9583C36.3285 20.9469 36.3133 20.9355 36.3019 20.9241C36.2715 20.8937 36.2374 20.8633 36.2032 20.8329C36.169 20.8025 36.1349 20.7758 36.1007 20.7454C36.0665 20.7188 36.0285 20.6884 35.9906 20.6618C35.9678 20.6466 35.9488 20.6276 35.9222 20.6124C35.9146 20.6048 35.8994 20.601 35.8919 20.5934C35.7741 20.5135 35.6451 20.4413 35.5084 20.3729C35.497 20.3691 35.4894 20.3615 35.4818 20.3577C35.4704 20.3501 35.4514 20.3463 35.44 20.3425C35.2843 20.2702 35.1211 20.2056 34.9426 20.1486C34.935 20.1486 34.9274 20.141 34.9199 20.141C34.8401 20.1144 34.7604 20.0916 34.6769 20.0687L34.8743 18.7078L33.9706 18.5747L33.7732 19.9357C33.8643 19.9623 33.9554 19.9889 34.039 20.0155L34.0314 20.0117Z",
    fill: "#CCCCCC"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7309 28.379C36.7309 28.379 36.7309 28.3714 36.7309 28.3638C36.7574 28.2649 36.7764 28.1623 36.7916 28.0559C36.7992 28.0102 36.803 27.9646 36.8106 27.919C36.8106 27.9 36.8106 27.8848 36.8106 27.8658C36.8296 27.6947 36.8372 27.5274 36.8334 27.3716C36.8334 27.3716 36.8334 27.3678 36.8334 27.364C36.8334 27.2689 36.822 27.1777 36.8106 27.0902C36.8106 27.0712 36.803 27.0522 36.7992 27.0332C36.7878 26.9686 36.7802 26.904 36.765 26.8469C36.765 26.8317 36.7574 26.8203 36.7536 26.8051C36.6663 26.4478 36.4917 26.1246 36.2335 25.8395C36.1993 25.8015 36.1651 25.7635 36.1309 25.7293C36.1158 25.7141 36.0968 25.6989 36.0816 25.6836C36.036 25.638 35.9867 25.5962 35.9373 25.5544C35.9031 25.524 35.869 25.4974 35.8348 25.467C35.7816 25.4251 35.7209 25.3795 35.6639 25.3377C35.6374 25.3187 35.6146 25.2997 35.588 25.2807C35.5804 25.2731 35.569 25.2693 35.5576 25.2617C35.4551 25.1932 35.345 25.1248 35.2311 25.0602C35.1058 24.9918 34.9691 24.9233 34.8286 24.8549C34.8134 24.8473 34.7982 24.8397 34.7831 24.8321C34.7565 24.8207 34.7261 24.8093 34.6995 24.7941C34.597 24.7446 34.4869 24.6952 34.373 24.6496C34.3274 24.6306 34.2819 24.6116 34.2363 24.5926C34.0806 24.528 33.9174 24.4633 33.7465 24.3987C33.5908 24.3417 33.4428 24.2809 33.3061 24.2238C33.2871 24.2162 33.2681 24.2086 33.2491 24.201C33.12 24.1478 32.9985 24.0908 32.8808 24.0375C32.8353 24.0147 32.7859 23.9919 32.7441 23.9729C32.6644 23.9311 32.5885 23.8931 32.5163 23.8513C32.4935 23.8399 32.4746 23.8247 32.4518 23.8133C32.4024 23.7828 32.3569 23.7562 32.3113 23.7258C32.2923 23.7144 32.2733 23.6992 32.2505 23.684C32.1784 23.6346 32.1139 23.5852 32.0531 23.5357C31.9848 23.4749 31.9278 23.4103 31.8746 23.3457C31.8557 23.3228 31.8329 23.3 31.8177 23.2734C31.7645 23.1974 31.719 23.1176 31.6848 23.0301C31.6582 22.9541 31.643 22.8705 31.6316 22.7868C31.6316 22.7602 31.6241 22.7336 31.6203 22.7032C31.6127 22.6043 31.6165 22.5055 31.6316 22.3991C31.643 22.3116 31.6658 22.228 31.6962 22.1481C31.6962 22.1481 31.6962 22.1443 31.6962 22.1405C31.7228 22.0721 31.7607 22.0075 31.8025 21.9467C31.8139 21.9315 31.8253 21.9124 31.8367 21.8972C31.8709 21.8516 31.9126 21.8098 31.9544 21.768C31.9734 21.749 31.9924 21.73 32.0113 21.711C32.0759 21.6539 32.1518 21.6045 32.2316 21.5589C32.5847 21.3574 33.0745 21.308 33.7085 21.3992L32.8049 21.2662C32.1708 21.1749 31.681 21.2244 31.3279 21.4258C31.2444 21.4715 31.1722 21.5247 31.1077 21.5779C31.0849 21.5969 31.0697 21.6159 31.0507 21.6349C31.0204 21.6653 30.9862 21.6958 30.9558 21.7262C30.9482 21.7376 30.9406 21.749 30.9292 21.7604C30.9178 21.7756 30.9064 21.7908 30.8951 21.8098C30.8799 21.8288 30.8647 21.8478 30.8533 21.8706C30.8305 21.9124 30.8077 21.9581 30.7887 21.9999C30.7887 21.9999 30.7887 22.0037 30.7887 22.0075C30.7736 22.0493 30.7584 22.0911 30.747 22.1367C30.7356 22.1748 30.728 22.2166 30.7242 22.2584C30.7242 22.2736 30.7204 22.2926 30.7166 22.3078C30.709 22.3838 30.7052 22.4561 30.709 22.5245C30.709 22.5397 30.7128 22.5511 30.7128 22.5625C30.7128 22.5891 30.7204 22.6157 30.7242 22.6462C30.728 22.6842 30.7318 22.7222 30.7394 22.7602C30.7508 22.8058 30.7622 22.8476 30.7774 22.8895C30.8115 22.9731 30.8571 23.0529 30.9102 23.1328C30.9254 23.1556 30.9482 23.1784 30.9672 23.205C30.9938 23.2392 31.0166 23.2734 31.0507 23.3038C31.0811 23.3343 31.1115 23.3647 31.1456 23.3913C31.2026 23.4407 31.2709 23.4901 31.3431 23.5395C31.3507 23.5471 31.3583 23.5509 31.3659 23.5585C31.3773 23.5661 31.3886 23.5738 31.4 23.5814C31.4456 23.6118 31.4912 23.6384 31.5405 23.6688C31.5633 23.6802 31.5823 23.6954 31.6051 23.7068C31.6772 23.7486 31.7531 23.7904 31.8329 23.8285C31.8671 23.8437 31.9012 23.8627 31.9392 23.8779C31.9506 23.8817 31.962 23.8893 31.9734 23.8931C32.0873 23.9463 32.2088 24.0033 32.3417 24.0566C32.3607 24.0642 32.3796 24.0718 32.3986 24.0794C32.5391 24.1364 32.6834 24.1972 32.8391 24.2542C33.0099 24.3189 33.1732 24.3835 33.3289 24.4481C33.3744 24.4671 33.42 24.4861 33.4655 24.5051C33.5794 24.5546 33.6858 24.6002 33.7883 24.6496C33.83 24.6686 33.8756 24.6914 33.9174 24.7104C34.0579 24.7789 34.1945 24.8473 34.3198 24.9157C34.4375 24.9803 34.5439 25.0488 34.6464 25.1172C34.6843 25.14 34.7185 25.1666 34.7527 25.1932C34.8096 25.2351 34.8704 25.2769 34.9235 25.3225C34.9577 25.3491 34.9919 25.3795 35.0261 25.4099C35.0754 25.4517 35.1248 25.4974 35.1703 25.5392C35.2235 25.5886 35.2766 25.6418 35.3222 25.6951C35.5804 25.9802 35.7551 26.3033 35.8424 26.6607C35.8614 26.7329 35.8728 26.8127 35.8879 26.8888C35.8879 26.9078 35.8955 26.9268 35.8993 26.9458C35.9107 27.037 35.9183 27.1321 35.9221 27.2271C35.9259 27.383 35.9183 27.5502 35.8993 27.7213C35.8917 27.7821 35.8879 27.8468 35.8804 27.9114C35.8652 28.0178 35.8462 28.1205 35.8196 28.2193C35.8158 28.2421 35.8082 28.2611 35.8006 28.2801C35.7778 28.3714 35.7475 28.4588 35.7171 28.5425C35.7057 28.5767 35.6905 28.6071 35.6791 28.6375C35.6449 28.7135 35.6108 28.7858 35.5728 28.858C35.55 28.896 35.531 28.9378 35.5083 28.9758C35.4513 29.0709 35.383 29.1583 35.3146 29.2458C35.2956 29.2724 35.2729 29.2952 35.2501 29.3218C35.1969 29.3826 35.1438 29.4396 35.0868 29.4967C35.064 29.5195 35.0412 29.5423 35.0147 29.5651C34.9311 29.6373 34.8476 29.7096 34.7527 29.7742C34.4451 29.9947 34.0768 30.1505 33.6554 30.257C33.4466 30.3102 33.2225 30.3444 32.9833 30.3672C32.7479 30.39 32.4973 30.3938 32.2354 30.3862L31.9961 32.0247L32.8998 32.1578L33.139 30.5193C33.663 30.5345 34.1376 30.4927 34.559 30.39C34.9805 30.2874 35.3488 30.1277 35.6563 29.9072C35.7513 29.8426 35.8348 29.7704 35.9183 29.6982C35.9449 29.6753 35.9677 29.6525 35.9905 29.6297C36.0474 29.5727 36.1044 29.5157 36.1575 29.4548C36.1689 29.4396 36.1879 29.4282 36.1993 29.4092C36.2069 29.3978 36.2145 29.3864 36.2221 29.3788C36.2904 29.2914 36.3588 29.2039 36.4157 29.1089C36.4271 29.0899 36.4423 29.0671 36.4537 29.0443C36.4651 29.0253 36.4727 29.0063 36.4803 28.9872C36.5182 28.915 36.5562 28.8428 36.5866 28.7668C36.5942 28.7477 36.6056 28.7325 36.6132 28.7135C36.6169 28.6983 36.6207 28.6831 36.6283 28.6717C36.6625 28.5881 36.6891 28.5006 36.7119 28.4094C36.7157 28.3942 36.7233 28.379 36.7271 28.36L36.7309 28.379Z",
    fill: "#CCCCCC"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1187 18.5936L33.9213 19.9546C34.8174 20.1979 35.459 20.5971 35.8539 21.1635C36.245 21.7299 36.4386 22.38 36.431 23.1175L34.6731 22.8628C34.6427 22.4713 34.506 22.1329 34.2554 21.8516C34.0086 21.5741 33.5796 21.3878 32.9797 21.3004C32.3456 21.2091 31.8558 21.2585 31.5027 21.46C31.1496 21.6577 30.9484 21.9352 30.8952 22.2964C30.861 22.5321 30.88 22.7412 30.9484 22.9274C31.0205 23.1137 31.142 23.281 31.3167 23.4293C31.4913 23.5775 31.7191 23.722 32.0039 23.8664C32.2849 24.0071 32.6228 24.1516 33.0101 24.296C33.5872 24.5089 34.0808 24.7332 34.4946 24.9613C34.9085 25.1932 35.2426 25.4479 35.497 25.7368C35.7552 26.022 35.9299 26.3451 36.0172 26.7024C36.1083 27.0598 36.1197 27.478 36.0514 27.9532C35.9944 28.3562 35.8653 28.7097 35.6755 29.0214C35.4856 29.3332 35.235 29.5993 34.9199 29.816C34.6123 30.0365 34.244 30.1923 33.8226 30.2988C33.4011 30.4014 32.9265 30.4432 32.4026 30.428L32.1634 32.0665L30.694 31.8536L30.9332 30.2151C30.4244 30.0897 29.9877 29.9186 29.6308 29.6981C29.2701 29.4738 28.9778 29.2229 28.75 28.934C28.5222 28.6451 28.3589 28.3257 28.2602 27.9722C28.1615 27.6186 28.1197 27.2423 28.1349 26.8469L29.908 27.1054C29.908 27.3259 29.9574 27.5274 30.0333 27.7213C30.1168 27.9114 30.2345 28.0824 30.394 28.2383C30.5573 28.3904 30.7547 28.5196 31.0015 28.6261C31.2445 28.7325 31.5407 28.8085 31.8862 28.8618C32.6114 28.9682 33.1771 28.9188 33.5796 28.7173C33.9783 28.5196 34.2099 28.2079 34.2706 27.7897C34.3086 27.535 34.2896 27.3107 34.2213 27.1244C34.1491 26.9343 34.0162 26.7595 33.8264 26.596C33.6365 26.4325 33.3822 26.2767 33.067 26.1246C32.7481 25.9725 32.3646 25.8091 31.9128 25.6342C31.3926 25.4289 30.9446 25.216 30.5573 25.0031C30.1738 24.7864 29.8662 24.5431 29.6308 24.2694C29.3954 23.9957 29.236 23.6802 29.1486 23.3266C29.0651 22.9693 29.0537 22.5549 29.1259 22.0759C29.179 21.7147 29.2929 21.3878 29.4676 21.0913C29.6384 20.7985 29.8738 20.5514 30.1624 20.3462C30.451 20.1485 30.7889 19.9888 31.1724 19.8824C31.5635 19.7759 31.9887 19.7265 32.4557 19.7455L32.6532 18.3845L34.1225 18.5974L34.1187 18.5936Z",
    fill: "#E1E1E1"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.1814 27.231L46.1472 27.4591C46.1396 27.4971 46.132 27.5313 46.1244 27.5693L46.1168 27.6263C46.0978 27.729 46.0788 27.8354 46.0561 27.9419C46.0371 28.0293 46.0181 28.1206 45.9991 28.208C45.9725 28.3144 45.946 28.4133 45.9194 28.5159L45.8472 28.7858C45.8245 28.8771 45.7941 28.9683 45.7637 29.0634C45.7371 29.1546 45.7068 29.242 45.6764 29.3333C45.6498 29.4245 45.6118 29.5119 45.5815 29.6032L45.4827 29.8617C45.4486 29.9529 45.4106 30.0442 45.3726 30.1316C45.3498 30.1886 45.3271 30.2419 45.3043 30.2989L42.954 29.4777L41.8985 29.109C42.206 28.3525 42.4263 27.5465 42.5478 26.6988C43.0034 23.5548 42.0162 20.5363 40.095 18.3542L41.3973 18.1831L43.4552 17.9094C43.4894 17.9474 43.5273 17.9893 43.5615 18.0311L43.5957 18.0653C43.5957 18.0653 43.6261 18.1033 43.645 18.1261C43.8045 18.3162 43.9526 18.5025 44.0893 18.6926L44.15 18.7724C44.2905 18.9663 44.431 19.1754 44.5715 19.4073L44.6588 19.5479C44.7993 19.7874 44.9246 20.0041 45.0347 20.2208L45.0575 20.2702C45.179 20.5097 45.2815 20.7302 45.3764 20.9507L45.4334 21.0838C45.5283 21.3119 45.6194 21.5552 45.703 21.8023L45.7523 21.9505C45.8358 22.2167 45.908 22.46 45.9687 22.6957C46.0333 22.9504 46.0864 23.2051 46.1358 23.5016L46.1662 23.6651C46.2041 23.935 46.2383 24.1935 46.2611 24.4482V24.49C46.2687 24.5204 46.2725 24.547 46.2725 24.5737C46.2877 24.7941 46.2991 24.988 46.3029 25.1819L46.3105 25.372C46.3105 25.6115 46.3105 25.851 46.2991 26.0943C46.2953 26.2083 46.2839 26.2996 46.2763 26.3946L46.2649 26.5315C46.2649 26.5733 46.2611 26.6151 46.2573 26.6531C46.2383 26.8432 46.2117 27.0333 46.1852 27.2272L46.1814 27.231Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M175.112 71.3069L181.699 72.2915L179.262 78.4425L175.112 71.3069Z",
    fill: "#F5F5F5"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M178.858 76.1197L176.968 72.8708L163.847 80.5227L165.737 83.7715L178.858 76.1197Z",
    fill: "#F5F5F5"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M153.72 73.0898L161.234 74.2113L158.455 81.2253L153.72 73.0898Z",
    fill: "#ECECEC"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M157.989 78.5763L155.834 74.8708L140.863 83.6018L143.019 87.3073L157.989 78.5763Z",
    fill: "#ECECEC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M148.336 89.6802L162.073 91.4061L157.301 104.305L148.336 89.6802Z",
    fill: "#ECECEC"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M156.357 99.4937L152.275 92.8315L125.374 109.356L129.457 116.018L156.357 99.4937Z",
    fill: "#ECECEC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M237.305 179.316L5.69531 179.316C2.82661 179.316 0.5 176.988 0.5 174.114L0.5 9.88429C0.5 7.01048 2.82661 4.68187 5.69531 4.68187L237.305 4.68187C240.173 4.68187 242.5 7.01048 242.5 9.88429L242.5 174.114C242.5 176.988 240.173 179.316 237.305 179.316Z",
    stroke: "#849A9F",
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M180.891 8.37126C180.879 8.33324 180.868 8.29142 180.853 8.25341L180.811 8.12035C180.784 8.02911 180.754 7.93787 180.72 7.83523C180.64 7.60333 180.553 7.37904 180.462 7.15854L180.386 6.98367C180.31 6.80499 180.226 6.62632 180.131 6.42863C180.12 6.40202 180.109 6.37921 180.093 6.3526L180.074 6.31458C179.96 6.08649 179.831 5.85459 179.691 5.62269L179.604 5.48203C179.448 5.22732 179.304 5.01063 179.148 4.79394C179.007 4.60006 178.852 4.39857 178.673 4.18188L178.571 4.06023C178.4 3.86254 178.229 3.66866 178.054 3.49379L177.952 3.39114C177.781 3.22007 177.606 3.0528 177.405 2.87412L177.363 2.83611C177.181 2.67644 176.987 2.52057 176.767 2.3533L176.634 2.25446C176.414 2.09099 176.209 1.95033 176.004 1.82108L175.921 1.77166C175.719 1.6462 175.514 1.52835 175.298 1.4105C175.275 1.3991 175.256 1.38389 175.233 1.37249L175.192 1.35348C174.983 1.24323 174.77 1.14059 174.557 1.04555L174.417 0.984722C174.231 0.904889 174.041 0.828856 173.832 0.752824C173.809 0.741419 173.783 0.733816 173.76 0.726213L173.711 0.711006C173.532 0.65018 173.358 0.593155 173.179 0.539933L173.145 0.528528C172.955 0.475306 172.762 0.425885 172.568 0.380266L172.526 0.368861C172.488 0.361258 172.446 0.353654 172.408 0.346051L172.348 0.334647C172.238 0.311837 172.131 0.289027 172.017 0.270019C171.96 0.258614 171.907 0.251011 171.85 0.243407L171.786 0.232003C171.679 0.216797 171.573 0.20159 171.44 0.182582L171.205 0.159771C171.11 0.152168 171.019 0.140764 170.924 0.136963C170.837 0.12936 170.749 0.125558 170.662 0.121756C170.567 0.117954 170.472 0.114153 170.343 0.110352H170.271C170.233 0.110352 170.199 0.110352 170.161 0.110352H170.108C170.013 0.110352 169.921 0.110352 169.827 0.117955C169.735 0.117955 169.648 0.125557 169.557 0.13316C169.462 0.136962 169.367 0.144566 169.242 0.155971L169.162 0.163574C169.128 0.163574 169.094 0.171177 169.06 0.174978L169.006 0.182582C168.908 0.193987 168.805 0.205392 168.703 0.220599C168.615 0.232004 168.528 0.247209 168.441 0.262415C168.338 0.277622 168.239 0.29663 168.137 0.31944L168 0.34225C167.909 0.361258 167.818 0.384068 167.727 0.403076L164.849 1.09117L164.978 1.6348L165.107 2.17843C165.225 2.15182 165.346 2.12521 165.472 2.1024C165.563 2.08339 165.654 2.06818 165.741 2.05298C165.821 2.03777 165.897 2.02636 165.977 2.01496C166.068 2.00355 166.159 1.99215 166.246 1.98074C166.326 1.97314 166.406 1.96174 166.482 1.95794C166.565 1.95033 166.649 1.94653 166.736 1.93893C166.816 1.93513 166.895 1.92752 166.979 1.92752C167.062 1.92752 167.146 1.92372 167.23 1.92372C167.309 1.92372 167.389 1.92372 167.469 1.92372C167.552 1.92372 167.64 1.92752 167.723 1.93132C167.803 1.93132 167.883 1.93893 167.959 1.94273C168.042 1.95033 168.126 1.95793 168.213 1.96554C168.289 1.97314 168.365 1.98074 168.445 1.98835C168.539 1.99975 168.638 2.01496 168.733 2.03017L168.79 2.03777C168.843 2.04537 168.893 2.05297 168.946 2.06058C169.044 2.07959 169.143 2.09859 169.242 2.1176L169.435 2.15942C169.61 2.20124 169.781 2.24306 169.948 2.29248L169.982 2.30388C170.142 2.3495 170.301 2.40272 170.461 2.45595L170.582 2.50157C170.753 2.56239 170.924 2.63082 171.091 2.70305L171.22 2.75627C171.414 2.84371 171.604 2.93495 171.79 3.03379L171.896 3.09082C172.082 3.19346 172.268 3.29991 172.45 3.41015L172.526 3.45577C172.72 3.57742 172.906 3.71048 173.092 3.84734L173.21 3.93477C173.392 4.07543 173.574 4.2199 173.768 4.38717L173.806 4.42138C173.969 4.56584 174.128 4.71411 174.28 4.86997L174.371 4.96121C174.531 5.12848 174.687 5.29955 174.835 5.47443L174.926 5.58467C175.093 5.78616 175.233 5.96484 175.37 6.15872C175.495 6.32979 175.624 6.52747 175.765 6.75937L175.845 6.88863C175.974 7.10532 176.084 7.30681 176.19 7.51589L176.251 7.64135C176.327 7.79721 176.403 7.95688 176.471 8.12035L176.539 8.28002C176.623 8.4815 176.703 8.68679 176.771 8.89208C176.805 8.99472 176.836 9.09737 176.874 9.21522L176.927 9.37868C176.976 9.54595 177.018 9.71323 177.06 9.8805C177.082 9.97934 177.101 10.0782 177.124 10.177L177.136 10.234C177.155 10.3291 177.174 10.4241 177.189 10.5192C177.204 10.6028 177.215 10.6826 177.23 10.7663C177.246 10.8613 177.257 10.9564 177.268 11.0476C177.28 11.1312 177.287 11.2149 177.295 11.2985C177.303 11.3859 177.31 11.4734 177.318 11.5608C177.325 11.6444 177.329 11.7319 177.333 11.8155C177.337 11.903 177.341 11.9904 177.344 12.0778C177.344 12.1615 177.348 12.2451 177.348 12.3287C177.348 12.4162 177.348 12.5036 177.348 12.591C177.348 12.6747 177.344 12.7583 177.341 12.8382C177.337 12.9256 177.333 13.013 177.325 13.0967C177.318 13.1765 177.314 13.2563 177.306 13.3362C177.299 13.435 177.287 13.53 177.272 13.6403C177.265 13.7125 177.253 13.7848 177.246 13.8532C177.23 13.952 177.215 14.0471 177.2 14.1459L177.193 14.1953C177.185 14.2486 177.174 14.3056 177.162 14.3626C177.136 14.4995 177.105 14.6363 177.075 14.7694L177.044 14.8986C176.999 15.0735 176.953 15.2484 176.889 15.4537L176.874 15.5031C176.817 15.6856 176.752 15.868 176.676 16.0695L176.627 16.1988C176.547 16.3965 176.467 16.5941 176.376 16.788L176.312 16.9211C176.258 17.0313 176.205 17.1416 176.148 17.248L176.053 17.4191C176 17.5141 175.951 17.6054 175.894 17.6966C175.86 17.7498 175.826 17.8069 175.784 17.8753C175.731 17.9627 175.674 18.0464 175.617 18.13C175.575 18.1908 175.537 18.2479 175.495 18.3049C175.438 18.3885 175.378 18.4683 175.317 18.5482C175.275 18.6052 175.233 18.6622 175.188 18.7192C175.123 18.7991 175.059 18.8789 174.998 18.9549L174.861 19.1146C174.793 19.1945 174.721 19.2743 174.649 19.3503L174.516 19.491C174.432 19.5784 174.345 19.6658 174.254 19.7495L174.151 19.8483C174.026 19.9662 173.901 20.0764 173.768 20.1867L173.688 20.2513C173.582 20.3387 173.475 20.4224 173.369 20.506L173.221 20.6125C173.134 20.6771 173.043 20.7417 172.951 20.8025C172.91 20.8329 172.864 20.8596 172.822 20.8862L172.781 20.9128C172.693 20.9698 172.606 21.023 172.519 21.0763C172.458 21.1105 172.397 21.1485 172.333 21.1827C172.245 21.2321 172.154 21.2815 172.063 21.3272C171.998 21.3614 171.934 21.3956 171.865 21.426C171.774 21.4716 171.683 21.5134 171.588 21.5553C171.524 21.5857 171.455 21.6161 171.391 21.6427C171.292 21.6845 171.193 21.7225 171.091 21.7643L171.034 21.7871C170.988 21.8062 170.947 21.8214 170.897 21.8404C170.787 21.8822 170.673 21.9164 170.559 21.9544L170.392 22.0076C170.221 22.0571 170.047 22.1065 169.872 22.1483L170.001 22.6919L170.13 23.2356L173.008 22.5475C173.206 22.5019 173.396 22.4486 173.589 22.3916L173.775 22.3308C173.904 22.289 174.03 22.2471 174.155 22.2053C174.208 22.1863 174.261 22.1635 174.314 22.1445L174.371 22.1217C174.482 22.0799 174.595 22.0343 174.706 21.9886C174.778 21.9582 174.85 21.924 174.926 21.8898C175.032 21.8404 175.135 21.7948 175.237 21.7415C175.309 21.7073 175.381 21.6693 175.454 21.6313C175.556 21.5781 175.655 21.5248 175.761 21.464C175.829 21.426 175.898 21.388 175.962 21.3462C176.061 21.2853 176.16 21.2245 176.258 21.1637L176.296 21.1371C176.35 21.1029 176.399 21.0724 176.452 21.0382C176.555 20.9698 176.653 20.8976 176.752 20.8253L176.805 20.7873C176.843 20.7607 176.881 20.7303 176.919 20.7037C177.041 20.6125 177.158 20.5174 177.303 20.3996L177.367 20.3501C177.511 20.2285 177.656 20.103 177.796 19.97L177.91 19.8597C178.009 19.7647 178.108 19.6697 178.202 19.5708C178.237 19.5366 178.271 19.4986 178.301 19.4644L178.347 19.4149C178.426 19.3275 178.506 19.2401 178.586 19.1526C178.628 19.1032 178.669 19.0538 178.734 18.974C178.806 18.8865 178.878 18.7991 178.947 18.7116C178.996 18.6508 179.042 18.5862 179.091 18.5216C179.159 18.4341 179.224 18.3429 179.288 18.2517C179.334 18.187 179.38 18.1224 179.421 18.054C179.486 17.9589 179.547 17.8639 179.623 17.7422C179.657 17.6852 179.695 17.6282 179.729 17.5712C179.79 17.4685 179.847 17.3659 179.907 17.2632L180.01 17.077C180.074 16.9591 180.135 16.8375 180.192 16.7158L180.264 16.5675C180.363 16.3546 180.458 16.1342 180.545 15.9175L180.61 15.7502C180.686 15.5525 180.754 15.351 180.822 15.1419L180.849 15.0583C180.906 14.8682 180.959 14.6743 181.008 14.4766L181.039 14.336C181.073 14.1839 181.107 14.0357 181.141 13.8684L181.153 13.8114C181.16 13.7734 181.164 13.7391 181.172 13.7011L181.179 13.6441C181.198 13.5377 181.217 13.4274 181.232 13.321C181.244 13.2373 181.255 13.1537 181.267 13.0701C181.278 12.9636 181.293 12.8572 181.305 12.7127L181.324 12.4846C181.331 12.3896 181.335 12.2945 181.339 12.1957C181.342 12.1044 181.346 12.0132 181.346 11.922C181.346 11.8269 181.346 11.7281 181.346 11.6292V11.3517C181.339 11.2567 181.335 11.1578 181.331 11.0628C181.327 10.9678 181.32 10.8765 181.312 10.7815C181.305 10.6826 181.297 10.5876 181.286 10.4926L181.255 10.215C181.244 10.1124 181.229 10.006 181.21 9.89951C181.194 9.80827 181.183 9.72083 181.164 9.62959C181.145 9.52315 181.126 9.4205 181.103 9.31406L181.092 9.26083C181.084 9.22282 181.077 9.1886 181.069 9.15059C181.054 9.07456 181.035 8.99852 181.016 8.92249C180.97 8.73621 180.921 8.54993 180.868 8.36745L180.891 8.37126Z",
    fill: "#E1E1E1"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M170.253 22.6422C175.923 21.2865 179.395 15.4727 178.008 9.65662C176.621 3.84055 170.9 0.224662 165.23 1.5803C159.56 2.93595 156.088 8.74977 157.475 14.5658C158.862 20.3819 164.583 23.9978 170.253 22.6422Z",
    fill: "#F5F5F5"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M173.251 2.29234C170.867 0.874334 167.974 0.345909 165.103 1.0302C159.142 2.4558 155.478 8.5802 156.932 14.6856C158.39 20.7948 164.424 24.6002 170.385 23.1746C175.465 21.9619 178.875 17.3315 178.867 12.2069C178.867 11.3174 178.765 10.4164 178.552 9.5154C177.796 6.35246 175.814 3.80918 173.251 2.28853V2.29234ZM170.222 22.4903C164.644 23.8247 158.994 20.2512 157.627 14.5221C156.26 8.7969 159.689 3.05266 165.267 1.71829C167.716 1.13284 170.172 1.4978 172.279 2.56605C174.975 3.93463 177.09 6.47031 177.853 9.68267C178.058 10.5494 178.157 11.4124 178.149 12.2602C178.138 17.0426 174.952 21.3574 170.218 22.4865L170.222 22.4903Z",
    fill: "#E1E1E1"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M181.039 8.92619L181.092 9.15049C181.096 9.1885 181.107 9.22272 181.111 9.26073L181.122 9.31395C181.141 9.4166 181.164 9.52304 181.183 9.62949C181.198 9.71693 181.214 9.80816 181.229 9.8994C181.244 10.0058 181.255 10.1123 181.271 10.2149L181.301 10.4925C181.312 10.5837 181.32 10.6825 181.327 10.7814C181.335 10.8764 181.343 10.9677 181.346 11.0627C181.354 11.1577 181.354 11.2528 181.358 11.3478V11.6253C181.365 11.7242 181.365 11.8192 181.358 11.9181C181.358 11.9789 181.358 12.0359 181.358 12.0967L178.871 12.207L177.755 12.2564C177.762 11.4391 177.667 10.6103 177.47 9.77775C176.733 6.68704 174.698 4.25021 172.109 2.93485L173.255 2.29237L175.066 1.27734C175.116 1.30015 175.161 1.32676 175.211 1.34957L175.252 1.36858C175.275 1.37999 175.298 1.39139 175.317 1.4066C175.537 1.52445 175.738 1.6423 175.94 1.76775L176.023 1.82097C176.224 1.95023 176.429 2.09089 176.65 2.25436L176.783 2.3532C177.003 2.52427 177.196 2.68014 177.379 2.836L177.417 2.87402C177.618 3.0527 177.793 3.21997 177.963 3.39104L178.066 3.49368C178.237 3.67236 178.415 3.86244 178.582 4.06393L178.685 4.18558C178.863 4.40227 179.019 4.60375 179.159 4.79764C179.311 5.01053 179.456 5.22722 179.615 5.48573L179.702 5.62639C179.839 5.86209 179.964 6.09019 180.082 6.31828L180.101 6.3563C180.116 6.38291 180.128 6.40572 180.139 6.43233C180.238 6.63001 180.317 6.80869 180.393 6.98737L180.469 7.16224C180.56 7.38654 180.644 7.61083 180.728 7.83893C180.766 7.94537 180.788 8.03281 180.819 8.12785L180.857 8.26091C180.868 8.29892 180.883 8.33694 180.895 8.37876C180.944 8.56124 180.993 8.74751 181.039 8.93759V8.92619Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M163.038 14.218L167.978 15.7044L168.813 19.2019L163.038 14.218Z",
    fill: "#E1E1E1"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M166.721 10.4316L167.784 14.8985L162.844 13.4121L166.721 10.4316Z",
    fill: "#E1E1E1"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M165.491 5.28418L166.721 10.4316L162.844 13.412L165.491 5.28418Z",
    fill: "#E1E1E1"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.721 10.4316L171.524 11.3364L167.784 14.8985L166.721 10.4316Z",
    fill: "#C1C1C1"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M165.491 5.28418L171.524 11.3363L166.721 10.4316L165.491 5.28418Z",
    fill: "#E1E1E1"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M166.797 10.7471L167.788 14.8985L168.494 14.7312L172.23 11.1691L166.201 5.11694L165.494 5.28422L166.721 10.4278L162.844 13.4083L163.55 13.241L166.797 10.7433V10.7471ZM168.395 14.3206L167.503 10.5799L171.524 11.3402L168.395 14.3245V14.3206ZM166.474 6.26883L171.152 10.9638L167.423 10.2605L166.47 6.26883H166.474Z",
    fill: "#E1E1E1"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M171.718 12.1424L169.284 18.0577L168.684 15.5372L163.74 14.0508L163.038 14.2181L167.978 15.7045L168.813 19.202L169.519 19.0347L172.424 11.9751L171.718 12.1424Z",
    fill: "#CCCCCC"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M171.717 12.1423L168.813 19.2019L167.978 15.7044L171.717 12.1423Z",
    fill: "#E1E1E1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecastsImg);
export default __webpack_public_path__ + "static/media/forecastsImg.e8b8ba18db169b81d3433af6c687708f.svg";
export { ForwardRef as ReactComponent };